var av = Object.defineProperty;
var lv = (e, r, u) =>
  r in e
    ? av(e, r, { enumerable: !0, configurable: !0, writable: !0, value: u })
    : (e[r] = u);
var Ln = (e, r, u) => (lv(e, typeof r != 'symbol' ? r + '' : r, u), u),
  cv = (e, r, u) => {
    if (!r.has(e)) throw TypeError('Cannot ' + u);
  };
var Ci = (e, r, u) => {
  if (r.has(e))
    throw TypeError('Cannot add the same private member more than once');
  r instanceof WeakSet ? r.add(e) : r.set(e, u);
};
var Ri = (e, r, u) => (cv(e, r, 'access private method'), u);
var dr =
    typeof globalThis < 'u'
      ? globalThis
      : typeof window < 'u'
      ? window
      : typeof global < 'u'
      ? global
      : typeof self < 'u'
      ? self
      : {},
  Wi = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Wi.exports;
(function (e, r) {
  (function () {
    var u,
      f = '4.17.21',
      s = 200,
      h = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      c = 'Expected a function',
      g = 'Invalid `variable` option passed into `_.template`',
      v = '__lodash_hash_undefined__',
      w = 500,
      d = '__lodash_placeholder__',
      y = 1,
      x = 2,
      C = 4,
      P = 1,
      z = 2,
      $ = 1,
      O = 2,
      U = 4,
      k = 8,
      B = 16,
      q = 32,
      X = 64,
      V = 128,
      rn = 256,
      on = 512,
      pn = 30,
      j = '...',
      zn = 800,
      xn = 16,
      A = 1,
      R = 2,
      I = 3,
      F = 1 / 0,
      G = 9007199254740991,
      Y = 17976931348623157e292,
      nn = NaN,
      Q = 4294967295,
      gn = Q - 1,
      In = Q >>> 1,
      An = [
        ['ary', V],
        ['bind', $],
        ['bindKey', O],
        ['curry', k],
        ['curryRight', B],
        ['flip', on],
        ['partial', q],
        ['partialRight', X],
        ['rearg', rn],
      ],
      Sn = '[object Arguments]',
      Jn = '[object Array]',
      rt = '[object AsyncFunction]',
      Hn = '[object Boolean]',
      Dt = '[object Date]',
      Cc = '[object DOMException]',
      Or = '[object Error]',
      $r = '[object Function]',
      mf = '[object GeneratorFunction]',
      St = '[object Map]',
      Ze = '[object Number]',
      Rc = '[object Null]',
      zt = '[object Object]',
      yf = '[object Promise]',
      Tc = '[object Proxy]',
      Je = '[object RegExp]',
      Et = '[object Set]',
      Qe = '[object String]',
      Fr = '[object Symbol]',
      Ic = '[object Undefined]',
      Ve = '[object WeakMap]',
      Mc = '[object WeakSet]',
      je = '[object ArrayBuffer]',
      Ce = '[object DataView]',
      fu = '[object Float32Array]',
      su = '[object Float64Array]',
      au = '[object Int8Array]',
      lu = '[object Int16Array]',
      cu = '[object Int32Array]',
      hu = '[object Uint8Array]',
      pu = '[object Uint8ClampedArray]',
      gu = '[object Uint16Array]',
      du = '[object Uint32Array]',
      Lc = /\b__p \+= '';/g,
      bc = /\b(__p \+=) '' \+/g,
      Pc = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
      xf = /&(?:amp|lt|gt|quot|#39);/g,
      Sf = /[&<>"']/g,
      Nc = RegExp(xf.source),
      Oc = RegExp(Sf.source),
      $c = /<%-([\s\S]+?)%>/g,
      Fc = /<%([\s\S]+?)%>/g,
      Ef = /<%=([\s\S]+?)%>/g,
      Dc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      zc = /^\w*$/,
      Bc =
        /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      _u = /[\\^$.*+?()[\]{}|]/g,
      Wc = RegExp(_u.source),
      vu = /^\s+/,
      kc = /\s/,
      Uc = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      Gc = /\{\n\/\* \[wrapped with (.+)\] \*/,
      qc = /,? & /,
      Hc = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
      Xc = /[()=,{}\[\]\/\s]/,
      Yc = /\\(\\)?/g,
      Kc = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
      Af = /\w*$/,
      Zc = /^[-+]0x[0-9a-f]+$/i,
      Jc = /^0b[01]+$/i,
      Qc = /^\[object .+?Constructor\]$/,
      Vc = /^0o[0-7]+$/i,
      jc = /^(?:0|[1-9]\d*)$/,
      nh = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
      Dr = /($^)/,
      th = /['\n\r\u2028\u2029\\]/g,
      zr = '\\ud800-\\udfff',
      eh = '\\u0300-\\u036f',
      rh = '\\ufe20-\\ufe2f',
      ih = '\\u20d0-\\u20ff',
      Cf = eh + rh + ih,
      Rf = '\\u2700-\\u27bf',
      Tf = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      uh = '\\xac\\xb1\\xd7\\xf7',
      oh = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      fh = '\\u2000-\\u206f',
      sh =
        ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      If = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      Mf = '\\ufe0e\\ufe0f',
      Lf = uh + oh + fh + sh,
      wu = "['’]",
      ah = '[' + zr + ']',
      bf = '[' + Lf + ']',
      Br = '[' + Cf + ']',
      Pf = '\\d+',
      lh = '[' + Rf + ']',
      Nf = '[' + Tf + ']',
      Of = '[^' + zr + Lf + Pf + Rf + Tf + If + ']',
      mu = '\\ud83c[\\udffb-\\udfff]',
      ch = '(?:' + Br + '|' + mu + ')',
      $f = '[^' + zr + ']',
      yu = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      xu = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      Re = '[' + If + ']',
      Ff = '\\u200d',
      Df = '(?:' + Nf + '|' + Of + ')',
      hh = '(?:' + Re + '|' + Of + ')',
      zf = '(?:' + wu + '(?:d|ll|m|re|s|t|ve))?',
      Bf = '(?:' + wu + '(?:D|LL|M|RE|S|T|VE))?',
      Wf = ch + '?',
      kf = '[' + Mf + ']?',
      ph = '(?:' + Ff + '(?:' + [$f, yu, xu].join('|') + ')' + kf + Wf + ')*',
      gh = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      dh = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      Uf = kf + Wf + ph,
      _h = '(?:' + [lh, yu, xu].join('|') + ')' + Uf,
      vh = '(?:' + [$f + Br + '?', Br, yu, xu, ah].join('|') + ')',
      wh = RegExp(wu, 'g'),
      mh = RegExp(Br, 'g'),
      Su = RegExp(mu + '(?=' + mu + ')|' + vh + Uf, 'g'),
      yh = RegExp(
        [
          Re + '?' + Nf + '+' + zf + '(?=' + [bf, Re, '$'].join('|') + ')',
          hh + '+' + Bf + '(?=' + [bf, Re + Df, '$'].join('|') + ')',
          Re + '?' + Df + '+' + zf,
          Re + '+' + Bf,
          dh,
          gh,
          Pf,
          _h,
        ].join('|'),
        'g'
      ),
      xh = RegExp('[' + Ff + zr + Cf + Mf + ']'),
      Sh = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
      Eh = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout',
      ],
      Ah = -1,
      En = {};
    (En[fu] =
      En[su] =
      En[au] =
      En[lu] =
      En[cu] =
      En[hu] =
      En[pu] =
      En[gu] =
      En[du] =
        !0),
      (En[Sn] =
        En[Jn] =
        En[je] =
        En[Hn] =
        En[Ce] =
        En[Dt] =
        En[Or] =
        En[$r] =
        En[St] =
        En[Ze] =
        En[zt] =
        En[Je] =
        En[Et] =
        En[Qe] =
        En[Ve] =
          !1);
    var mn = {};
    (mn[Sn] =
      mn[Jn] =
      mn[je] =
      mn[Ce] =
      mn[Hn] =
      mn[Dt] =
      mn[fu] =
      mn[su] =
      mn[au] =
      mn[lu] =
      mn[cu] =
      mn[St] =
      mn[Ze] =
      mn[zt] =
      mn[Je] =
      mn[Et] =
      mn[Qe] =
      mn[Fr] =
      mn[hu] =
      mn[pu] =
      mn[gu] =
      mn[du] =
        !0),
      (mn[Or] = mn[$r] = mn[Ve] = !1);
    var Ch = {
        // Latin-1 Supplement block.
        À: 'A',
        Á: 'A',
        Â: 'A',
        Ã: 'A',
        Ä: 'A',
        Å: 'A',
        à: 'a',
        á: 'a',
        â: 'a',
        ã: 'a',
        ä: 'a',
        å: 'a',
        Ç: 'C',
        ç: 'c',
        Ð: 'D',
        ð: 'd',
        È: 'E',
        É: 'E',
        Ê: 'E',
        Ë: 'E',
        è: 'e',
        é: 'e',
        ê: 'e',
        ë: 'e',
        Ì: 'I',
        Í: 'I',
        Î: 'I',
        Ï: 'I',
        ì: 'i',
        í: 'i',
        î: 'i',
        ï: 'i',
        Ñ: 'N',
        ñ: 'n',
        Ò: 'O',
        Ó: 'O',
        Ô: 'O',
        Õ: 'O',
        Ö: 'O',
        Ø: 'O',
        ò: 'o',
        ó: 'o',
        ô: 'o',
        õ: 'o',
        ö: 'o',
        ø: 'o',
        Ù: 'U',
        Ú: 'U',
        Û: 'U',
        Ü: 'U',
        ù: 'u',
        ú: 'u',
        û: 'u',
        ü: 'u',
        Ý: 'Y',
        ý: 'y',
        ÿ: 'y',
        Æ: 'Ae',
        æ: 'ae',
        Þ: 'Th',
        þ: 'th',
        ß: 'ss',
        // Latin Extended-A block.
        Ā: 'A',
        Ă: 'A',
        Ą: 'A',
        ā: 'a',
        ă: 'a',
        ą: 'a',
        Ć: 'C',
        Ĉ: 'C',
        Ċ: 'C',
        Č: 'C',
        ć: 'c',
        ĉ: 'c',
        ċ: 'c',
        č: 'c',
        Ď: 'D',
        Đ: 'D',
        ď: 'd',
        đ: 'd',
        Ē: 'E',
        Ĕ: 'E',
        Ė: 'E',
        Ę: 'E',
        Ě: 'E',
        ē: 'e',
        ĕ: 'e',
        ė: 'e',
        ę: 'e',
        ě: 'e',
        Ĝ: 'G',
        Ğ: 'G',
        Ġ: 'G',
        Ģ: 'G',
        ĝ: 'g',
        ğ: 'g',
        ġ: 'g',
        ģ: 'g',
        Ĥ: 'H',
        Ħ: 'H',
        ĥ: 'h',
        ħ: 'h',
        Ĩ: 'I',
        Ī: 'I',
        Ĭ: 'I',
        Į: 'I',
        İ: 'I',
        ĩ: 'i',
        ī: 'i',
        ĭ: 'i',
        į: 'i',
        ı: 'i',
        Ĵ: 'J',
        ĵ: 'j',
        Ķ: 'K',
        ķ: 'k',
        ĸ: 'k',
        Ĺ: 'L',
        Ļ: 'L',
        Ľ: 'L',
        Ŀ: 'L',
        Ł: 'L',
        ĺ: 'l',
        ļ: 'l',
        ľ: 'l',
        ŀ: 'l',
        ł: 'l',
        Ń: 'N',
        Ņ: 'N',
        Ň: 'N',
        Ŋ: 'N',
        ń: 'n',
        ņ: 'n',
        ň: 'n',
        ŋ: 'n',
        Ō: 'O',
        Ŏ: 'O',
        Ő: 'O',
        ō: 'o',
        ŏ: 'o',
        ő: 'o',
        Ŕ: 'R',
        Ŗ: 'R',
        Ř: 'R',
        ŕ: 'r',
        ŗ: 'r',
        ř: 'r',
        Ś: 'S',
        Ŝ: 'S',
        Ş: 'S',
        Š: 'S',
        ś: 's',
        ŝ: 's',
        ş: 's',
        š: 's',
        Ţ: 'T',
        Ť: 'T',
        Ŧ: 'T',
        ţ: 't',
        ť: 't',
        ŧ: 't',
        Ũ: 'U',
        Ū: 'U',
        Ŭ: 'U',
        Ů: 'U',
        Ű: 'U',
        Ų: 'U',
        ũ: 'u',
        ū: 'u',
        ŭ: 'u',
        ů: 'u',
        ű: 'u',
        ų: 'u',
        Ŵ: 'W',
        ŵ: 'w',
        Ŷ: 'Y',
        ŷ: 'y',
        Ÿ: 'Y',
        Ź: 'Z',
        Ż: 'Z',
        Ž: 'Z',
        ź: 'z',
        ż: 'z',
        ž: 'z',
        Ĳ: 'IJ',
        ĳ: 'ij',
        Œ: 'Oe',
        œ: 'oe',
        ŉ: "'n",
        ſ: 's',
      },
      Rh = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      },
      Th = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'",
      },
      Ih = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029',
      },
      Mh = parseFloat,
      Lh = parseInt,
      Gf = typeof dr == 'object' && dr && dr.Object === Object && dr,
      bh = typeof self == 'object' && self && self.Object === Object && self,
      Wn = Gf || bh || Function('return this')(),
      Eu = r && !r.nodeType && r,
      se = Eu && !0 && e && !e.nodeType && e,
      qf = se && se.exports === Eu,
      Au = qf && Gf.process,
      ht = (function () {
        try {
          var S = se && se.require && se.require('util').types;
          return S || (Au && Au.binding && Au.binding('util'));
        } catch {}
      })(),
      Hf = ht && ht.isArrayBuffer,
      Xf = ht && ht.isDate,
      Yf = ht && ht.isMap,
      Kf = ht && ht.isRegExp,
      Zf = ht && ht.isSet,
      Jf = ht && ht.isTypedArray;
    function it(S, M, T) {
      switch (T.length) {
        case 0:
          return S.call(M);
        case 1:
          return S.call(M, T[0]);
        case 2:
          return S.call(M, T[0], T[1]);
        case 3:
          return S.call(M, T[0], T[1], T[2]);
      }
      return S.apply(M, T);
    }
    function Ph(S, M, T, W) {
      for (var tn = -1, dn = S == null ? 0 : S.length; ++tn < dn; ) {
        var Fn = S[tn];
        M(W, Fn, T(Fn), S);
      }
      return W;
    }
    function pt(S, M) {
      for (
        var T = -1, W = S == null ? 0 : S.length;
        ++T < W && M(S[T], T, S) !== !1;

      );
      return S;
    }
    function Nh(S, M) {
      for (var T = S == null ? 0 : S.length; T-- && M(S[T], T, S) !== !1; );
      return S;
    }
    function Qf(S, M) {
      for (var T = -1, W = S == null ? 0 : S.length; ++T < W; )
        if (!M(S[T], T, S)) return !1;
      return !0;
    }
    function Vt(S, M) {
      for (
        var T = -1, W = S == null ? 0 : S.length, tn = 0, dn = [];
        ++T < W;

      ) {
        var Fn = S[T];
        M(Fn, T, S) && (dn[tn++] = Fn);
      }
      return dn;
    }
    function Wr(S, M) {
      var T = S == null ? 0 : S.length;
      return !!T && Te(S, M, 0) > -1;
    }
    function Cu(S, M, T) {
      for (var W = -1, tn = S == null ? 0 : S.length; ++W < tn; )
        if (T(M, S[W])) return !0;
      return !1;
    }
    function Cn(S, M) {
      for (var T = -1, W = S == null ? 0 : S.length, tn = Array(W); ++T < W; )
        tn[T] = M(S[T], T, S);
      return tn;
    }
    function jt(S, M) {
      for (var T = -1, W = M.length, tn = S.length; ++T < W; ) S[tn + T] = M[T];
      return S;
    }
    function Ru(S, M, T, W) {
      var tn = -1,
        dn = S == null ? 0 : S.length;
      for (W && dn && (T = S[++tn]); ++tn < dn; ) T = M(T, S[tn], tn, S);
      return T;
    }
    function Oh(S, M, T, W) {
      var tn = S == null ? 0 : S.length;
      for (W && tn && (T = S[--tn]); tn--; ) T = M(T, S[tn], tn, S);
      return T;
    }
    function Tu(S, M) {
      for (var T = -1, W = S == null ? 0 : S.length; ++T < W; )
        if (M(S[T], T, S)) return !0;
      return !1;
    }
    var $h = Iu('length');
    function Fh(S) {
      return S.split('');
    }
    function Dh(S) {
      return S.match(Hc) || [];
    }
    function Vf(S, M, T) {
      var W;
      return (
        T(S, function (tn, dn, Fn) {
          if (M(tn, dn, Fn)) return (W = dn), !1;
        }),
        W
      );
    }
    function kr(S, M, T, W) {
      for (var tn = S.length, dn = T + (W ? 1 : -1); W ? dn-- : ++dn < tn; )
        if (M(S[dn], dn, S)) return dn;
      return -1;
    }
    function Te(S, M, T) {
      return M === M ? Zh(S, M, T) : kr(S, jf, T);
    }
    function zh(S, M, T, W) {
      for (var tn = T - 1, dn = S.length; ++tn < dn; )
        if (W(S[tn], M)) return tn;
      return -1;
    }
    function jf(S) {
      return S !== S;
    }
    function ns(S, M) {
      var T = S == null ? 0 : S.length;
      return T ? Lu(S, M) / T : nn;
    }
    function Iu(S) {
      return function (M) {
        return M == null ? u : M[S];
      };
    }
    function Mu(S) {
      return function (M) {
        return S == null ? u : S[M];
      };
    }
    function ts(S, M, T, W, tn) {
      return (
        tn(S, function (dn, Fn, wn) {
          T = W ? ((W = !1), dn) : M(T, dn, Fn, wn);
        }),
        T
      );
    }
    function Bh(S, M) {
      var T = S.length;
      for (S.sort(M); T--; ) S[T] = S[T].value;
      return S;
    }
    function Lu(S, M) {
      for (var T, W = -1, tn = S.length; ++W < tn; ) {
        var dn = M(S[W]);
        dn !== u && (T = T === u ? dn : T + dn);
      }
      return T;
    }
    function bu(S, M) {
      for (var T = -1, W = Array(S); ++T < S; ) W[T] = M(T);
      return W;
    }
    function Wh(S, M) {
      return Cn(M, function (T) {
        return [T, S[T]];
      });
    }
    function es(S) {
      return S && S.slice(0, os(S) + 1).replace(vu, '');
    }
    function ut(S) {
      return function (M) {
        return S(M);
      };
    }
    function Pu(S, M) {
      return Cn(M, function (T) {
        return S[T];
      });
    }
    function nr(S, M) {
      return S.has(M);
    }
    function rs(S, M) {
      for (var T = -1, W = S.length; ++T < W && Te(M, S[T], 0) > -1; );
      return T;
    }
    function is(S, M) {
      for (var T = S.length; T-- && Te(M, S[T], 0) > -1; );
      return T;
    }
    function kh(S, M) {
      for (var T = S.length, W = 0; T--; ) S[T] === M && ++W;
      return W;
    }
    var Uh = Mu(Ch),
      Gh = Mu(Rh);
    function qh(S) {
      return '\\' + Ih[S];
    }
    function Hh(S, M) {
      return S == null ? u : S[M];
    }
    function Ie(S) {
      return xh.test(S);
    }
    function Xh(S) {
      return Sh.test(S);
    }
    function Yh(S) {
      for (var M, T = []; !(M = S.next()).done; ) T.push(M.value);
      return T;
    }
    function Nu(S) {
      var M = -1,
        T = Array(S.size);
      return (
        S.forEach(function (W, tn) {
          T[++M] = [tn, W];
        }),
        T
      );
    }
    function us(S, M) {
      return function (T) {
        return S(M(T));
      };
    }
    function ne(S, M) {
      for (var T = -1, W = S.length, tn = 0, dn = []; ++T < W; ) {
        var Fn = S[T];
        (Fn === M || Fn === d) && ((S[T] = d), (dn[tn++] = T));
      }
      return dn;
    }
    function Ur(S) {
      var M = -1,
        T = Array(S.size);
      return (
        S.forEach(function (W) {
          T[++M] = W;
        }),
        T
      );
    }
    function Kh(S) {
      var M = -1,
        T = Array(S.size);
      return (
        S.forEach(function (W) {
          T[++M] = [W, W];
        }),
        T
      );
    }
    function Zh(S, M, T) {
      for (var W = T - 1, tn = S.length; ++W < tn; ) if (S[W] === M) return W;
      return -1;
    }
    function Jh(S, M, T) {
      for (var W = T + 1; W--; ) if (S[W] === M) return W;
      return W;
    }
    function Me(S) {
      return Ie(S) ? Vh(S) : $h(S);
    }
    function At(S) {
      return Ie(S) ? jh(S) : Fh(S);
    }
    function os(S) {
      for (var M = S.length; M-- && kc.test(S.charAt(M)); );
      return M;
    }
    var Qh = Mu(Th);
    function Vh(S) {
      for (var M = (Su.lastIndex = 0); Su.test(S); ) ++M;
      return M;
    }
    function jh(S) {
      return S.match(Su) || [];
    }
    function n0(S) {
      return S.match(yh) || [];
    }
    var t0 = function S(M) {
        M = M == null ? Wn : Le.defaults(Wn.Object(), M, Le.pick(Wn, Eh));
        var T = M.Array,
          W = M.Date,
          tn = M.Error,
          dn = M.Function,
          Fn = M.Math,
          wn = M.Object,
          Ou = M.RegExp,
          e0 = M.String,
          gt = M.TypeError,
          Gr = T.prototype,
          r0 = dn.prototype,
          be = wn.prototype,
          qr = M['__core-js_shared__'],
          Hr = r0.toString,
          vn = be.hasOwnProperty,
          i0 = 0,
          fs = (function () {
            var n = /[^.]+$/.exec((qr && qr.keys && qr.keys.IE_PROTO) || '');
            return n ? 'Symbol(src)_1.' + n : '';
          })(),
          Xr = be.toString,
          u0 = Hr.call(wn),
          o0 = Wn._,
          f0 = Ou(
            '^' +
              Hr.call(vn)
                .replace(_u, '\\$&')
                .replace(
                  /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                  '$1.*?'
                ) +
              '$'
          ),
          Yr = qf ? M.Buffer : u,
          te = M.Symbol,
          Kr = M.Uint8Array,
          ss = Yr ? Yr.allocUnsafe : u,
          Zr = us(wn.getPrototypeOf, wn),
          as = wn.create,
          ls = be.propertyIsEnumerable,
          Jr = Gr.splice,
          cs = te ? te.isConcatSpreadable : u,
          tr = te ? te.iterator : u,
          ae = te ? te.toStringTag : u,
          Qr = (function () {
            try {
              var n = ge(wn, 'defineProperty');
              return n({}, '', {}), n;
            } catch {}
          })(),
          s0 = M.clearTimeout !== Wn.clearTimeout && M.clearTimeout,
          a0 = W && W.now !== Wn.Date.now && W.now,
          l0 = M.setTimeout !== Wn.setTimeout && M.setTimeout,
          Vr = Fn.ceil,
          jr = Fn.floor,
          $u = wn.getOwnPropertySymbols,
          c0 = Yr ? Yr.isBuffer : u,
          hs = M.isFinite,
          h0 = Gr.join,
          p0 = us(wn.keys, wn),
          Dn = Fn.max,
          Gn = Fn.min,
          g0 = W.now,
          d0 = M.parseInt,
          ps = Fn.random,
          _0 = Gr.reverse,
          Fu = ge(M, 'DataView'),
          er = ge(M, 'Map'),
          Du = ge(M, 'Promise'),
          Pe = ge(M, 'Set'),
          rr = ge(M, 'WeakMap'),
          ir = ge(wn, 'create'),
          ni = rr && new rr(),
          Ne = {},
          v0 = de(Fu),
          w0 = de(er),
          m0 = de(Du),
          y0 = de(Pe),
          x0 = de(rr),
          ti = te ? te.prototype : u,
          ur = ti ? ti.valueOf : u,
          gs = ti ? ti.toString : u;
        function l(n) {
          if (Mn(n) && !en(n) && !(n instanceof ln)) {
            if (n instanceof dt) return n;
            if (vn.call(n, '__wrapped__')) return da(n);
          }
          return new dt(n);
        }
        var Oe = /* @__PURE__ */ (function () {
          function n() {}
          return function (t) {
            if (!Rn(t)) return {};
            if (as) return as(t);
            n.prototype = t;
            var i = new n();
            return (n.prototype = u), i;
          };
        })();
        function ei() {}
        function dt(n, t) {
          (this.__wrapped__ = n),
            (this.__actions__ = []),
            (this.__chain__ = !!t),
            (this.__index__ = 0),
            (this.__values__ = u);
        }
        (l.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: $c,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Fc,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Ef,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: '',
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: l,
          },
        }),
          (l.prototype = ei.prototype),
          (l.prototype.constructor = l),
          (dt.prototype = Oe(ei.prototype)),
          (dt.prototype.constructor = dt);
        function ln(n) {
          (this.__wrapped__ = n),
            (this.__actions__ = []),
            (this.__dir__ = 1),
            (this.__filtered__ = !1),
            (this.__iteratees__ = []),
            (this.__takeCount__ = Q),
            (this.__views__ = []);
        }
        function S0() {
          var n = new ln(this.__wrapped__);
          return (
            (n.__actions__ = Qn(this.__actions__)),
            (n.__dir__ = this.__dir__),
            (n.__filtered__ = this.__filtered__),
            (n.__iteratees__ = Qn(this.__iteratees__)),
            (n.__takeCount__ = this.__takeCount__),
            (n.__views__ = Qn(this.__views__)),
            n
          );
        }
        function E0() {
          if (this.__filtered__) {
            var n = new ln(this);
            (n.__dir__ = -1), (n.__filtered__ = !0);
          } else (n = this.clone()), (n.__dir__ *= -1);
          return n;
        }
        function A0() {
          var n = this.__wrapped__.value(),
            t = this.__dir__,
            i = en(n),
            o = t < 0,
            a = i ? n.length : 0,
            p = Fp(0, a, this.__views__),
            _ = p.start,
            m = p.end,
            E = m - _,
            L = o ? m : _ - 1,
            b = this.__iteratees__,
            N = b.length,
            D = 0,
            H = Gn(E, this.__takeCount__);
          if (!i || (!o && a == E && H == E)) return zs(n, this.__actions__);
          var Z = [];
          n: for (; E-- && D < H; ) {
            L += t;
            for (var fn = -1, J = n[L]; ++fn < N; ) {
              var an = b[fn],
                cn = an.iteratee,
                st = an.type,
                Kn = cn(J);
              if (st == R) J = Kn;
              else if (!Kn) {
                if (st == A) continue n;
                break n;
              }
            }
            Z[D++] = J;
          }
          return Z;
        }
        (ln.prototype = Oe(ei.prototype)), (ln.prototype.constructor = ln);
        function le(n) {
          var t = -1,
            i = n == null ? 0 : n.length;
          for (this.clear(); ++t < i; ) {
            var o = n[t];
            this.set(o[0], o[1]);
          }
        }
        function C0() {
          (this.__data__ = ir ? ir(null) : {}), (this.size = 0);
        }
        function R0(n) {
          var t = this.has(n) && delete this.__data__[n];
          return (this.size -= t ? 1 : 0), t;
        }
        function T0(n) {
          var t = this.__data__;
          if (ir) {
            var i = t[n];
            return i === v ? u : i;
          }
          return vn.call(t, n) ? t[n] : u;
        }
        function I0(n) {
          var t = this.__data__;
          return ir ? t[n] !== u : vn.call(t, n);
        }
        function M0(n, t) {
          var i = this.__data__;
          return (
            (this.size += this.has(n) ? 0 : 1),
            (i[n] = ir && t === u ? v : t),
            this
          );
        }
        (le.prototype.clear = C0),
          (le.prototype.delete = R0),
          (le.prototype.get = T0),
          (le.prototype.has = I0),
          (le.prototype.set = M0);
        function Bt(n) {
          var t = -1,
            i = n == null ? 0 : n.length;
          for (this.clear(); ++t < i; ) {
            var o = n[t];
            this.set(o[0], o[1]);
          }
        }
        function L0() {
          (this.__data__ = []), (this.size = 0);
        }
        function b0(n) {
          var t = this.__data__,
            i = ri(t, n);
          if (i < 0) return !1;
          var o = t.length - 1;
          return i == o ? t.pop() : Jr.call(t, i, 1), --this.size, !0;
        }
        function P0(n) {
          var t = this.__data__,
            i = ri(t, n);
          return i < 0 ? u : t[i][1];
        }
        function N0(n) {
          return ri(this.__data__, n) > -1;
        }
        function O0(n, t) {
          var i = this.__data__,
            o = ri(i, n);
          return o < 0 ? (++this.size, i.push([n, t])) : (i[o][1] = t), this;
        }
        (Bt.prototype.clear = L0),
          (Bt.prototype.delete = b0),
          (Bt.prototype.get = P0),
          (Bt.prototype.has = N0),
          (Bt.prototype.set = O0);
        function Wt(n) {
          var t = -1,
            i = n == null ? 0 : n.length;
          for (this.clear(); ++t < i; ) {
            var o = n[t];
            this.set(o[0], o[1]);
          }
        }
        function $0() {
          (this.size = 0),
            (this.__data__ = {
              hash: new le(),
              map: new (er || Bt)(),
              string: new le(),
            });
        }
        function F0(n) {
          var t = di(this, n).delete(n);
          return (this.size -= t ? 1 : 0), t;
        }
        function D0(n) {
          return di(this, n).get(n);
        }
        function z0(n) {
          return di(this, n).has(n);
        }
        function B0(n, t) {
          var i = di(this, n),
            o = i.size;
          return i.set(n, t), (this.size += i.size == o ? 0 : 1), this;
        }
        (Wt.prototype.clear = $0),
          (Wt.prototype.delete = F0),
          (Wt.prototype.get = D0),
          (Wt.prototype.has = z0),
          (Wt.prototype.set = B0);
        function ce(n) {
          var t = -1,
            i = n == null ? 0 : n.length;
          for (this.__data__ = new Wt(); ++t < i; ) this.add(n[t]);
        }
        function W0(n) {
          return this.__data__.set(n, v), this;
        }
        function k0(n) {
          return this.__data__.has(n);
        }
        (ce.prototype.add = ce.prototype.push = W0), (ce.prototype.has = k0);
        function Ct(n) {
          var t = (this.__data__ = new Bt(n));
          this.size = t.size;
        }
        function U0() {
          (this.__data__ = new Bt()), (this.size = 0);
        }
        function G0(n) {
          var t = this.__data__,
            i = t.delete(n);
          return (this.size = t.size), i;
        }
        function q0(n) {
          return this.__data__.get(n);
        }
        function H0(n) {
          return this.__data__.has(n);
        }
        function X0(n, t) {
          var i = this.__data__;
          if (i instanceof Bt) {
            var o = i.__data__;
            if (!er || o.length < s - 1)
              return o.push([n, t]), (this.size = ++i.size), this;
            i = this.__data__ = new Wt(o);
          }
          return i.set(n, t), (this.size = i.size), this;
        }
        (Ct.prototype.clear = U0),
          (Ct.prototype.delete = G0),
          (Ct.prototype.get = q0),
          (Ct.prototype.has = H0),
          (Ct.prototype.set = X0);
        function ds(n, t) {
          var i = en(n),
            o = !i && _e(n),
            a = !i && !o && oe(n),
            p = !i && !o && !a && ze(n),
            _ = i || o || a || p,
            m = _ ? bu(n.length, e0) : [],
            E = m.length;
          for (var L in n)
            (t || vn.call(n, L)) &&
              !(
                _ && // Safari 9 has enumerable `arguments.length` in strict mode.
                (L == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
                  (a && (L == 'offset' || L == 'parent')) || // PhantomJS 2 has enumerable non-index properties on typed arrays.
                  (p &&
                    (L == 'buffer' ||
                      L == 'byteLength' ||
                      L == 'byteOffset')) || // Skip index properties.
                  qt(L, E))
              ) &&
              m.push(L);
          return m;
        }
        function _s(n) {
          var t = n.length;
          return t ? n[Ku(0, t - 1)] : u;
        }
        function Y0(n, t) {
          return _i(Qn(n), he(t, 0, n.length));
        }
        function K0(n) {
          return _i(Qn(n));
        }
        function zu(n, t, i) {
          ((i !== u && !Rt(n[t], i)) || (i === u && !(t in n))) && kt(n, t, i);
        }
        function or(n, t, i) {
          var o = n[t];
          (!(vn.call(n, t) && Rt(o, i)) || (i === u && !(t in n))) &&
            kt(n, t, i);
        }
        function ri(n, t) {
          for (var i = n.length; i--; ) if (Rt(n[i][0], t)) return i;
          return -1;
        }
        function Z0(n, t, i, o) {
          return (
            ee(n, function (a, p, _) {
              t(o, a, i(a), _);
            }),
            o
          );
        }
        function vs(n, t) {
          return n && bt(t, Bn(t), n);
        }
        function J0(n, t) {
          return n && bt(t, jn(t), n);
        }
        function kt(n, t, i) {
          t == '__proto__' && Qr
            ? Qr(n, t, {
                configurable: !0,
                enumerable: !0,
                value: i,
                writable: !0,
              })
            : (n[t] = i);
        }
        function Bu(n, t) {
          for (var i = -1, o = t.length, a = T(o), p = n == null; ++i < o; )
            a[i] = p ? u : yo(n, t[i]);
          return a;
        }
        function he(n, t, i) {
          return (
            n === n &&
              (i !== u && (n = n <= i ? n : i),
              t !== u && (n = n >= t ? n : t)),
            n
          );
        }
        function _t(n, t, i, o, a, p) {
          var _,
            m = t & y,
            E = t & x,
            L = t & C;
          if ((i && (_ = a ? i(n, o, a, p) : i(n)), _ !== u)) return _;
          if (!Rn(n)) return n;
          var b = en(n);
          if (b) {
            if (((_ = zp(n)), !m)) return Qn(n, _);
          } else {
            var N = qn(n),
              D = N == $r || N == mf;
            if (oe(n)) return ks(n, m);
            if (N == zt || N == Sn || (D && !a)) {
              if (((_ = E || D ? {} : oa(n)), !m))
                return E ? Tp(n, J0(_, n)) : Rp(n, vs(_, n));
            } else {
              if (!mn[N]) return a ? n : {};
              _ = Bp(n, N, m);
            }
          }
          p || (p = new Ct());
          var H = p.get(n);
          if (H) return H;
          p.set(n, _),
            $a(n)
              ? n.forEach(function (J) {
                  _.add(_t(J, t, i, J, n, p));
                })
              : Na(n) &&
                n.forEach(function (J, an) {
                  _.set(an, _t(J, t, i, an, n, p));
                });
          var Z = L ? (E ? uo : io) : E ? jn : Bn,
            fn = b ? u : Z(n);
          return (
            pt(fn || n, function (J, an) {
              fn && ((an = J), (J = n[an])), or(_, an, _t(J, t, i, an, n, p));
            }),
            _
          );
        }
        function Q0(n) {
          var t = Bn(n);
          return function (i) {
            return ws(i, n, t);
          };
        }
        function ws(n, t, i) {
          var o = i.length;
          if (n == null) return !o;
          for (n = wn(n); o--; ) {
            var a = i[o],
              p = t[a],
              _ = n[a];
            if ((_ === u && !(a in n)) || !p(_)) return !1;
          }
          return !0;
        }
        function ms(n, t, i) {
          if (typeof n != 'function') throw new gt(c);
          return pr(function () {
            n.apply(u, i);
          }, t);
        }
        function fr(n, t, i, o) {
          var a = -1,
            p = Wr,
            _ = !0,
            m = n.length,
            E = [],
            L = t.length;
          if (!m) return E;
          i && (t = Cn(t, ut(i))),
            o
              ? ((p = Cu), (_ = !1))
              : t.length >= s && ((p = nr), (_ = !1), (t = new ce(t)));
          n: for (; ++a < m; ) {
            var b = n[a],
              N = i == null ? b : i(b);
            if (((b = o || b !== 0 ? b : 0), _ && N === N)) {
              for (var D = L; D--; ) if (t[D] === N) continue n;
              E.push(b);
            } else p(t, N, o) || E.push(b);
          }
          return E;
        }
        var ee = Xs(Lt),
          ys = Xs(ku, !0);
        function V0(n, t) {
          var i = !0;
          return (
            ee(n, function (o, a, p) {
              return (i = !!t(o, a, p)), i;
            }),
            i
          );
        }
        function ii(n, t, i) {
          for (var o = -1, a = n.length; ++o < a; ) {
            var p = n[o],
              _ = t(p);
            if (_ != null && (m === u ? _ === _ && !ft(_) : i(_, m)))
              var m = _,
                E = p;
          }
          return E;
        }
        function j0(n, t, i, o) {
          var a = n.length;
          for (
            i = un(i),
              i < 0 && (i = -i > a ? 0 : a + i),
              o = o === u || o > a ? a : un(o),
              o < 0 && (o += a),
              o = i > o ? 0 : Da(o);
            i < o;

          )
            n[i++] = t;
          return n;
        }
        function xs(n, t) {
          var i = [];
          return (
            ee(n, function (o, a, p) {
              t(o, a, p) && i.push(o);
            }),
            i
          );
        }
        function kn(n, t, i, o, a) {
          var p = -1,
            _ = n.length;
          for (i || (i = kp), a || (a = []); ++p < _; ) {
            var m = n[p];
            t > 0 && i(m)
              ? t > 1
                ? kn(m, t - 1, i, o, a)
                : jt(a, m)
              : o || (a[a.length] = m);
          }
          return a;
        }
        var Wu = Ys(),
          Ss = Ys(!0);
        function Lt(n, t) {
          return n && Wu(n, t, Bn);
        }
        function ku(n, t) {
          return n && Ss(n, t, Bn);
        }
        function ui(n, t) {
          return Vt(t, function (i) {
            return Ht(n[i]);
          });
        }
        function pe(n, t) {
          t = ie(t, n);
          for (var i = 0, o = t.length; n != null && i < o; ) n = n[Pt(t[i++])];
          return i && i == o ? n : u;
        }
        function Es(n, t, i) {
          var o = t(n);
          return en(n) ? o : jt(o, i(n));
        }
        function Xn(n) {
          return n == null
            ? n === u
              ? Ic
              : Rc
            : ae && ae in wn(n)
            ? $p(n)
            : Kp(n);
        }
        function Uu(n, t) {
          return n > t;
        }
        function np(n, t) {
          return n != null && vn.call(n, t);
        }
        function tp(n, t) {
          return n != null && t in wn(n);
        }
        function ep(n, t, i) {
          return n >= Gn(t, i) && n < Dn(t, i);
        }
        function Gu(n, t, i) {
          for (
            var o = i ? Cu : Wr,
              a = n[0].length,
              p = n.length,
              _ = p,
              m = T(p),
              E = 1 / 0,
              L = [];
            _--;

          ) {
            var b = n[_];
            _ && t && (b = Cn(b, ut(t))),
              (E = Gn(b.length, E)),
              (m[_] =
                !i && (t || (a >= 120 && b.length >= 120))
                  ? new ce(_ && b)
                  : u);
          }
          b = n[0];
          var N = -1,
            D = m[0];
          n: for (; ++N < a && L.length < E; ) {
            var H = b[N],
              Z = t ? t(H) : H;
            if (((H = i || H !== 0 ? H : 0), !(D ? nr(D, Z) : o(L, Z, i)))) {
              for (_ = p; --_; ) {
                var fn = m[_];
                if (!(fn ? nr(fn, Z) : o(n[_], Z, i))) continue n;
              }
              D && D.push(Z), L.push(H);
            }
          }
          return L;
        }
        function rp(n, t, i, o) {
          return (
            Lt(n, function (a, p, _) {
              t(o, i(a), p, _);
            }),
            o
          );
        }
        function sr(n, t, i) {
          (t = ie(t, n)), (n = la(n, t));
          var o = n == null ? n : n[Pt(wt(t))];
          return o == null ? u : it(o, n, i);
        }
        function As(n) {
          return Mn(n) && Xn(n) == Sn;
        }
        function ip(n) {
          return Mn(n) && Xn(n) == je;
        }
        function up(n) {
          return Mn(n) && Xn(n) == Dt;
        }
        function ar(n, t, i, o, a) {
          return n === t
            ? !0
            : n == null || t == null || (!Mn(n) && !Mn(t))
            ? n !== n && t !== t
            : op(n, t, i, o, ar, a);
        }
        function op(n, t, i, o, a, p) {
          var _ = en(n),
            m = en(t),
            E = _ ? Jn : qn(n),
            L = m ? Jn : qn(t);
          (E = E == Sn ? zt : E), (L = L == Sn ? zt : L);
          var b = E == zt,
            N = L == zt,
            D = E == L;
          if (D && oe(n)) {
            if (!oe(t)) return !1;
            (_ = !0), (b = !1);
          }
          if (D && !b)
            return (
              p || (p = new Ct()),
              _ || ze(n) ? ra(n, t, i, o, a, p) : Np(n, t, E, i, o, a, p)
            );
          if (!(i & P)) {
            var H = b && vn.call(n, '__wrapped__'),
              Z = N && vn.call(t, '__wrapped__');
            if (H || Z) {
              var fn = H ? n.value() : n,
                J = Z ? t.value() : t;
              return p || (p = new Ct()), a(fn, J, i, o, p);
            }
          }
          return D ? (p || (p = new Ct()), Op(n, t, i, o, a, p)) : !1;
        }
        function fp(n) {
          return Mn(n) && qn(n) == St;
        }
        function qu(n, t, i, o) {
          var a = i.length,
            p = a,
            _ = !o;
          if (n == null) return !p;
          for (n = wn(n); a--; ) {
            var m = i[a];
            if (_ && m[2] ? m[1] !== n[m[0]] : !(m[0] in n)) return !1;
          }
          for (; ++a < p; ) {
            m = i[a];
            var E = m[0],
              L = n[E],
              b = m[1];
            if (_ && m[2]) {
              if (L === u && !(E in n)) return !1;
            } else {
              var N = new Ct();
              if (o) var D = o(L, b, E, n, t, N);
              if (!(D === u ? ar(b, L, P | z, o, N) : D)) return !1;
            }
          }
          return !0;
        }
        function Cs(n) {
          if (!Rn(n) || Gp(n)) return !1;
          var t = Ht(n) ? f0 : Qc;
          return t.test(de(n));
        }
        function sp(n) {
          return Mn(n) && Xn(n) == Je;
        }
        function ap(n) {
          return Mn(n) && qn(n) == Et;
        }
        function lp(n) {
          return Mn(n) && Si(n.length) && !!En[Xn(n)];
        }
        function Rs(n) {
          return typeof n == 'function'
            ? n
            : n == null
            ? nt
            : typeof n == 'object'
            ? en(n)
              ? Ms(n[0], n[1])
              : Is(n)
            : Ka(n);
        }
        function Hu(n) {
          if (!hr(n)) return p0(n);
          var t = [];
          for (var i in wn(n)) vn.call(n, i) && i != 'constructor' && t.push(i);
          return t;
        }
        function cp(n) {
          if (!Rn(n)) return Yp(n);
          var t = hr(n),
            i = [];
          for (var o in n)
            (o == 'constructor' && (t || !vn.call(n, o))) || i.push(o);
          return i;
        }
        function Xu(n, t) {
          return n < t;
        }
        function Ts(n, t) {
          var i = -1,
            o = Vn(n) ? T(n.length) : [];
          return (
            ee(n, function (a, p, _) {
              o[++i] = t(a, p, _);
            }),
            o
          );
        }
        function Is(n) {
          var t = fo(n);
          return t.length == 1 && t[0][2]
            ? sa(t[0][0], t[0][1])
            : function (i) {
                return i === n || qu(i, n, t);
              };
        }
        function Ms(n, t) {
          return ao(n) && fa(t)
            ? sa(Pt(n), t)
            : function (i) {
                var o = yo(i, n);
                return o === u && o === t ? xo(i, n) : ar(t, o, P | z);
              };
        }
        function oi(n, t, i, o, a) {
          n !== t &&
            Wu(
              t,
              function (p, _) {
                if ((a || (a = new Ct()), Rn(p))) hp(n, t, _, i, oi, o, a);
                else {
                  var m = o ? o(co(n, _), p, _ + '', n, t, a) : u;
                  m === u && (m = p), zu(n, _, m);
                }
              },
              jn
            );
        }
        function hp(n, t, i, o, a, p, _) {
          var m = co(n, i),
            E = co(t, i),
            L = _.get(E);
          if (L) {
            zu(n, i, L);
            return;
          }
          var b = p ? p(m, E, i + '', n, t, _) : u,
            N = b === u;
          if (N) {
            var D = en(E),
              H = !D && oe(E),
              Z = !D && !H && ze(E);
            (b = E),
              D || H || Z
                ? en(m)
                  ? (b = m)
                  : bn(m)
                  ? (b = Qn(m))
                  : H
                  ? ((N = !1), (b = ks(E, !0)))
                  : Z
                  ? ((N = !1), (b = Us(E, !0)))
                  : (b = [])
                : gr(E) || _e(E)
                ? ((b = m),
                  _e(m) ? (b = za(m)) : (!Rn(m) || Ht(m)) && (b = oa(E)))
                : (N = !1);
          }
          N && (_.set(E, b), a(b, E, o, p, _), _.delete(E)), zu(n, i, b);
        }
        function Ls(n, t) {
          var i = n.length;
          if (i) return (t += t < 0 ? i : 0), qt(t, i) ? n[t] : u;
        }
        function bs(n, t, i) {
          t.length
            ? (t = Cn(t, function (p) {
                return en(p)
                  ? function (_) {
                      return pe(_, p.length === 1 ? p[0] : p);
                    }
                  : p;
              }))
            : (t = [nt]);
          var o = -1;
          t = Cn(t, ut(K()));
          var a = Ts(n, function (p, _, m) {
            var E = Cn(t, function (L) {
              return L(p);
            });
            return { criteria: E, index: ++o, value: p };
          });
          return Bh(a, function (p, _) {
            return Cp(p, _, i);
          });
        }
        function pp(n, t) {
          return Ps(n, t, function (i, o) {
            return xo(n, o);
          });
        }
        function Ps(n, t, i) {
          for (var o = -1, a = t.length, p = {}; ++o < a; ) {
            var _ = t[o],
              m = pe(n, _);
            i(m, _) && lr(p, ie(_, n), m);
          }
          return p;
        }
        function gp(n) {
          return function (t) {
            return pe(t, n);
          };
        }
        function Yu(n, t, i, o) {
          var a = o ? zh : Te,
            p = -1,
            _ = t.length,
            m = n;
          for (n === t && (t = Qn(t)), i && (m = Cn(n, ut(i))); ++p < _; )
            for (
              var E = 0, L = t[p], b = i ? i(L) : L;
              (E = a(m, b, E, o)) > -1;

            )
              m !== n && Jr.call(m, E, 1), Jr.call(n, E, 1);
          return n;
        }
        function Ns(n, t) {
          for (var i = n ? t.length : 0, o = i - 1; i--; ) {
            var a = t[i];
            if (i == o || a !== p) {
              var p = a;
              qt(a) ? Jr.call(n, a, 1) : Qu(n, a);
            }
          }
          return n;
        }
        function Ku(n, t) {
          return n + jr(ps() * (t - n + 1));
        }
        function dp(n, t, i, o) {
          for (var a = -1, p = Dn(Vr((t - n) / (i || 1)), 0), _ = T(p); p--; )
            (_[o ? p : ++a] = n), (n += i);
          return _;
        }
        function Zu(n, t) {
          var i = '';
          if (!n || t < 1 || t > G) return i;
          do t % 2 && (i += n), (t = jr(t / 2)), t && (n += n);
          while (t);
          return i;
        }
        function sn(n, t) {
          return ho(aa(n, t, nt), n + '');
        }
        function _p(n) {
          return _s(Be(n));
        }
        function vp(n, t) {
          var i = Be(n);
          return _i(i, he(t, 0, i.length));
        }
        function lr(n, t, i, o) {
          if (!Rn(n)) return n;
          t = ie(t, n);
          for (
            var a = -1, p = t.length, _ = p - 1, m = n;
            m != null && ++a < p;

          ) {
            var E = Pt(t[a]),
              L = i;
            if (E === '__proto__' || E === 'constructor' || E === 'prototype')
              return n;
            if (a != _) {
              var b = m[E];
              (L = o ? o(b, E, m) : u),
                L === u && (L = Rn(b) ? b : qt(t[a + 1]) ? [] : {});
            }
            or(m, E, L), (m = m[E]);
          }
          return n;
        }
        var Os = ni
            ? function (n, t) {
                return ni.set(n, t), n;
              }
            : nt,
          wp = Qr
            ? function (n, t) {
                return Qr(n, 'toString', {
                  configurable: !0,
                  enumerable: !1,
                  value: Eo(t),
                  writable: !0,
                });
              }
            : nt;
        function mp(n) {
          return _i(Be(n));
        }
        function vt(n, t, i) {
          var o = -1,
            a = n.length;
          t < 0 && (t = -t > a ? 0 : a + t),
            (i = i > a ? a : i),
            i < 0 && (i += a),
            (a = t > i ? 0 : (i - t) >>> 0),
            (t >>>= 0);
          for (var p = T(a); ++o < a; ) p[o] = n[o + t];
          return p;
        }
        function yp(n, t) {
          var i;
          return (
            ee(n, function (o, a, p) {
              return (i = t(o, a, p)), !i;
            }),
            !!i
          );
        }
        function fi(n, t, i) {
          var o = 0,
            a = n == null ? o : n.length;
          if (typeof t == 'number' && t === t && a <= In) {
            for (; o < a; ) {
              var p = (o + a) >>> 1,
                _ = n[p];
              _ !== null && !ft(_) && (i ? _ <= t : _ < t)
                ? (o = p + 1)
                : (a = p);
            }
            return a;
          }
          return Ju(n, t, nt, i);
        }
        function Ju(n, t, i, o) {
          var a = 0,
            p = n == null ? 0 : n.length;
          if (p === 0) return 0;
          t = i(t);
          for (
            var _ = t !== t, m = t === null, E = ft(t), L = t === u;
            a < p;

          ) {
            var b = jr((a + p) / 2),
              N = i(n[b]),
              D = N !== u,
              H = N === null,
              Z = N === N,
              fn = ft(N);
            if (_) var J = o || Z;
            else
              L
                ? (J = Z && (o || D))
                : m
                ? (J = Z && D && (o || !H))
                : E
                ? (J = Z && D && !H && (o || !fn))
                : H || fn
                ? (J = !1)
                : (J = o ? N <= t : N < t);
            J ? (a = b + 1) : (p = b);
          }
          return Gn(p, gn);
        }
        function $s(n, t) {
          for (var i = -1, o = n.length, a = 0, p = []; ++i < o; ) {
            var _ = n[i],
              m = t ? t(_) : _;
            if (!i || !Rt(m, E)) {
              var E = m;
              p[a++] = _ === 0 ? 0 : _;
            }
          }
          return p;
        }
        function Fs(n) {
          return typeof n == 'number' ? n : ft(n) ? nn : +n;
        }
        function ot(n) {
          if (typeof n == 'string') return n;
          if (en(n)) return Cn(n, ot) + '';
          if (ft(n)) return gs ? gs.call(n) : '';
          var t = n + '';
          return t == '0' && 1 / n == -F ? '-0' : t;
        }
        function re(n, t, i) {
          var o = -1,
            a = Wr,
            p = n.length,
            _ = !0,
            m = [],
            E = m;
          if (i) (_ = !1), (a = Cu);
          else if (p >= s) {
            var L = t ? null : bp(n);
            if (L) return Ur(L);
            (_ = !1), (a = nr), (E = new ce());
          } else E = t ? [] : m;
          n: for (; ++o < p; ) {
            var b = n[o],
              N = t ? t(b) : b;
            if (((b = i || b !== 0 ? b : 0), _ && N === N)) {
              for (var D = E.length; D--; ) if (E[D] === N) continue n;
              t && E.push(N), m.push(b);
            } else a(E, N, i) || (E !== m && E.push(N), m.push(b));
          }
          return m;
        }
        function Qu(n, t) {
          return (
            (t = ie(t, n)), (n = la(n, t)), n == null || delete n[Pt(wt(t))]
          );
        }
        function Ds(n, t, i, o) {
          return lr(n, t, i(pe(n, t)), o);
        }
        function si(n, t, i, o) {
          for (
            var a = n.length, p = o ? a : -1;
            (o ? p-- : ++p < a) && t(n[p], p, n);

          );
          return i
            ? vt(n, o ? 0 : p, o ? p + 1 : a)
            : vt(n, o ? p + 1 : 0, o ? a : p);
        }
        function zs(n, t) {
          var i = n;
          return (
            i instanceof ln && (i = i.value()),
            Ru(
              t,
              function (o, a) {
                return a.func.apply(a.thisArg, jt([o], a.args));
              },
              i
            )
          );
        }
        function Vu(n, t, i) {
          var o = n.length;
          if (o < 2) return o ? re(n[0]) : [];
          for (var a = -1, p = T(o); ++a < o; )
            for (var _ = n[a], m = -1; ++m < o; )
              m != a && (p[a] = fr(p[a] || _, n[m], t, i));
          return re(kn(p, 1), t, i);
        }
        function Bs(n, t, i) {
          for (var o = -1, a = n.length, p = t.length, _ = {}; ++o < a; ) {
            var m = o < p ? t[o] : u;
            i(_, n[o], m);
          }
          return _;
        }
        function ju(n) {
          return bn(n) ? n : [];
        }
        function no(n) {
          return typeof n == 'function' ? n : nt;
        }
        function ie(n, t) {
          return en(n) ? n : ao(n, t) ? [n] : ga(_n(n));
        }
        var xp = sn;
        function ue(n, t, i) {
          var o = n.length;
          return (i = i === u ? o : i), !t && i >= o ? n : vt(n, t, i);
        }
        var Ws =
          s0 ||
          function (n) {
            return Wn.clearTimeout(n);
          };
        function ks(n, t) {
          if (t) return n.slice();
          var i = n.length,
            o = ss ? ss(i) : new n.constructor(i);
          return n.copy(o), o;
        }
        function to(n) {
          var t = new n.constructor(n.byteLength);
          return new Kr(t).set(new Kr(n)), t;
        }
        function Sp(n, t) {
          var i = t ? to(n.buffer) : n.buffer;
          return new n.constructor(i, n.byteOffset, n.byteLength);
        }
        function Ep(n) {
          var t = new n.constructor(n.source, Af.exec(n));
          return (t.lastIndex = n.lastIndex), t;
        }
        function Ap(n) {
          return ur ? wn(ur.call(n)) : {};
        }
        function Us(n, t) {
          var i = t ? to(n.buffer) : n.buffer;
          return new n.constructor(i, n.byteOffset, n.length);
        }
        function Gs(n, t) {
          if (n !== t) {
            var i = n !== u,
              o = n === null,
              a = n === n,
              p = ft(n),
              _ = t !== u,
              m = t === null,
              E = t === t,
              L = ft(t);
            if (
              (!m && !L && !p && n > t) ||
              (p && _ && E && !m && !L) ||
              (o && _ && E) ||
              (!i && E) ||
              !a
            )
              return 1;
            if (
              (!o && !p && !L && n < t) ||
              (L && i && a && !o && !p) ||
              (m && i && a) ||
              (!_ && a) ||
              !E
            )
              return -1;
          }
          return 0;
        }
        function Cp(n, t, i) {
          for (
            var o = -1,
              a = n.criteria,
              p = t.criteria,
              _ = a.length,
              m = i.length;
            ++o < _;

          ) {
            var E = Gs(a[o], p[o]);
            if (E) {
              if (o >= m) return E;
              var L = i[o];
              return E * (L == 'desc' ? -1 : 1);
            }
          }
          return n.index - t.index;
        }
        function qs(n, t, i, o) {
          for (
            var a = -1,
              p = n.length,
              _ = i.length,
              m = -1,
              E = t.length,
              L = Dn(p - _, 0),
              b = T(E + L),
              N = !o;
            ++m < E;

          )
            b[m] = t[m];
          for (; ++a < _; ) (N || a < p) && (b[i[a]] = n[a]);
          for (; L--; ) b[m++] = n[a++];
          return b;
        }
        function Hs(n, t, i, o) {
          for (
            var a = -1,
              p = n.length,
              _ = -1,
              m = i.length,
              E = -1,
              L = t.length,
              b = Dn(p - m, 0),
              N = T(b + L),
              D = !o;
            ++a < b;

          )
            N[a] = n[a];
          for (var H = a; ++E < L; ) N[H + E] = t[E];
          for (; ++_ < m; ) (D || a < p) && (N[H + i[_]] = n[a++]);
          return N;
        }
        function Qn(n, t) {
          var i = -1,
            o = n.length;
          for (t || (t = T(o)); ++i < o; ) t[i] = n[i];
          return t;
        }
        function bt(n, t, i, o) {
          var a = !i;
          i || (i = {});
          for (var p = -1, _ = t.length; ++p < _; ) {
            var m = t[p],
              E = o ? o(i[m], n[m], m, i, n) : u;
            E === u && (E = n[m]), a ? kt(i, m, E) : or(i, m, E);
          }
          return i;
        }
        function Rp(n, t) {
          return bt(n, so(n), t);
        }
        function Tp(n, t) {
          return bt(n, ia(n), t);
        }
        function ai(n, t) {
          return function (i, o) {
            var a = en(i) ? Ph : Z0,
              p = t ? t() : {};
            return a(i, n, K(o, 2), p);
          };
        }
        function $e(n) {
          return sn(function (t, i) {
            var o = -1,
              a = i.length,
              p = a > 1 ? i[a - 1] : u,
              _ = a > 2 ? i[2] : u;
            for (
              p = n.length > 3 && typeof p == 'function' ? (a--, p) : u,
                _ && Yn(i[0], i[1], _) && ((p = a < 3 ? u : p), (a = 1)),
                t = wn(t);
              ++o < a;

            ) {
              var m = i[o];
              m && n(t, m, o, p);
            }
            return t;
          });
        }
        function Xs(n, t) {
          return function (i, o) {
            if (i == null) return i;
            if (!Vn(i)) return n(i, o);
            for (
              var a = i.length, p = t ? a : -1, _ = wn(i);
              (t ? p-- : ++p < a) && o(_[p], p, _) !== !1;

            );
            return i;
          };
        }
        function Ys(n) {
          return function (t, i, o) {
            for (var a = -1, p = wn(t), _ = o(t), m = _.length; m--; ) {
              var E = _[n ? m : ++a];
              if (i(p[E], E, p) === !1) break;
            }
            return t;
          };
        }
        function Ip(n, t, i) {
          var o = t & $,
            a = cr(n);
          function p() {
            var _ = this && this !== Wn && this instanceof p ? a : n;
            return _.apply(o ? i : this, arguments);
          }
          return p;
        }
        function Ks(n) {
          return function (t) {
            t = _n(t);
            var i = Ie(t) ? At(t) : u,
              o = i ? i[0] : t.charAt(0),
              a = i ? ue(i, 1).join('') : t.slice(1);
            return o[n]() + a;
          };
        }
        function Fe(n) {
          return function (t) {
            return Ru(Xa(Ha(t).replace(wh, '')), n, '');
          };
        }
        function cr(n) {
          return function () {
            var t = arguments;
            switch (t.length) {
              case 0:
                return new n();
              case 1:
                return new n(t[0]);
              case 2:
                return new n(t[0], t[1]);
              case 3:
                return new n(t[0], t[1], t[2]);
              case 4:
                return new n(t[0], t[1], t[2], t[3]);
              case 5:
                return new n(t[0], t[1], t[2], t[3], t[4]);
              case 6:
                return new n(t[0], t[1], t[2], t[3], t[4], t[5]);
              case 7:
                return new n(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
            }
            var i = Oe(n.prototype),
              o = n.apply(i, t);
            return Rn(o) ? o : i;
          };
        }
        function Mp(n, t, i) {
          var o = cr(n);
          function a() {
            for (var p = arguments.length, _ = T(p), m = p, E = De(a); m--; )
              _[m] = arguments[m];
            var L = p < 3 && _[0] !== E && _[p - 1] !== E ? [] : ne(_, E);
            if (((p -= L.length), p < i))
              return js(n, t, li, a.placeholder, u, _, L, u, u, i - p);
            var b = this && this !== Wn && this instanceof a ? o : n;
            return it(b, this, _);
          }
          return a;
        }
        function Zs(n) {
          return function (t, i, o) {
            var a = wn(t);
            if (!Vn(t)) {
              var p = K(i, 3);
              (t = Bn(t)),
                (i = function (m) {
                  return p(a[m], m, a);
                });
            }
            var _ = n(t, i, o);
            return _ > -1 ? a[p ? t[_] : _] : u;
          };
        }
        function Js(n) {
          return Gt(function (t) {
            var i = t.length,
              o = i,
              a = dt.prototype.thru;
            for (n && t.reverse(); o--; ) {
              var p = t[o];
              if (typeof p != 'function') throw new gt(c);
              if (a && !_ && gi(p) == 'wrapper') var _ = new dt([], !0);
            }
            for (o = _ ? o : i; ++o < i; ) {
              p = t[o];
              var m = gi(p),
                E = m == 'wrapper' ? oo(p) : u;
              E &&
              lo(E[0]) &&
              E[1] == (V | k | q | rn) &&
              !E[4].length &&
              E[9] == 1
                ? (_ = _[gi(E[0])].apply(_, E[3]))
                : (_ = p.length == 1 && lo(p) ? _[m]() : _.thru(p));
            }
            return function () {
              var L = arguments,
                b = L[0];
              if (_ && L.length == 1 && en(b)) return _.plant(b).value();
              for (var N = 0, D = i ? t[N].apply(this, L) : b; ++N < i; )
                D = t[N].call(this, D);
              return D;
            };
          });
        }
        function li(n, t, i, o, a, p, _, m, E, L) {
          var b = t & V,
            N = t & $,
            D = t & O,
            H = t & (k | B),
            Z = t & on,
            fn = D ? u : cr(n);
          function J() {
            for (var an = arguments.length, cn = T(an), st = an; st--; )
              cn[st] = arguments[st];
            if (H)
              var Kn = De(J),
                at = kh(cn, Kn);
            if (
              (o && (cn = qs(cn, o, a, H)),
              p && (cn = Hs(cn, p, _, H)),
              (an -= at),
              H && an < L)
            ) {
              var Pn = ne(cn, Kn);
              return js(n, t, li, J.placeholder, i, cn, Pn, m, E, L - an);
            }
            var Tt = N ? i : this,
              Yt = D ? Tt[n] : n;
            return (
              (an = cn.length),
              m ? (cn = Zp(cn, m)) : Z && an > 1 && cn.reverse(),
              b && E < an && (cn.length = E),
              this && this !== Wn && this instanceof J && (Yt = fn || cr(Yt)),
              Yt.apply(Tt, cn)
            );
          }
          return J;
        }
        function Qs(n, t) {
          return function (i, o) {
            return rp(i, n, t(o), {});
          };
        }
        function ci(n, t) {
          return function (i, o) {
            var a;
            if (i === u && o === u) return t;
            if ((i !== u && (a = i), o !== u)) {
              if (a === u) return o;
              typeof i == 'string' || typeof o == 'string'
                ? ((i = ot(i)), (o = ot(o)))
                : ((i = Fs(i)), (o = Fs(o))),
                (a = n(i, o));
            }
            return a;
          };
        }
        function eo(n) {
          return Gt(function (t) {
            return (
              (t = Cn(t, ut(K()))),
              sn(function (i) {
                var o = this;
                return n(t, function (a) {
                  return it(a, o, i);
                });
              })
            );
          });
        }
        function hi(n, t) {
          t = t === u ? ' ' : ot(t);
          var i = t.length;
          if (i < 2) return i ? Zu(t, n) : t;
          var o = Zu(t, Vr(n / Me(t)));
          return Ie(t) ? ue(At(o), 0, n).join('') : o.slice(0, n);
        }
        function Lp(n, t, i, o) {
          var a = t & $,
            p = cr(n);
          function _() {
            for (
              var m = -1,
                E = arguments.length,
                L = -1,
                b = o.length,
                N = T(b + E),
                D = this && this !== Wn && this instanceof _ ? p : n;
              ++L < b;

            )
              N[L] = o[L];
            for (; E--; ) N[L++] = arguments[++m];
            return it(D, a ? i : this, N);
          }
          return _;
        }
        function Vs(n) {
          return function (t, i, o) {
            return (
              o && typeof o != 'number' && Yn(t, i, o) && (i = o = u),
              (t = Xt(t)),
              i === u ? ((i = t), (t = 0)) : (i = Xt(i)),
              (o = o === u ? (t < i ? 1 : -1) : Xt(o)),
              dp(t, i, o, n)
            );
          };
        }
        function pi(n) {
          return function (t, i) {
            return (
              (typeof t == 'string' && typeof i == 'string') ||
                ((t = mt(t)), (i = mt(i))),
              n(t, i)
            );
          };
        }
        function js(n, t, i, o, a, p, _, m, E, L) {
          var b = t & k,
            N = b ? _ : u,
            D = b ? u : _,
            H = b ? p : u,
            Z = b ? u : p;
          (t |= b ? q : X), (t &= ~(b ? X : q)), t & U || (t &= ~($ | O));
          var fn = [n, t, a, H, N, Z, D, m, E, L],
            J = i.apply(u, fn);
          return lo(n) && ca(J, fn), (J.placeholder = o), ha(J, n, t);
        }
        function ro(n) {
          var t = Fn[n];
          return function (i, o) {
            if (
              ((i = mt(i)), (o = o == null ? 0 : Gn(un(o), 292)), o && hs(i))
            ) {
              var a = (_n(i) + 'e').split('e'),
                p = t(a[0] + 'e' + (+a[1] + o));
              return (
                (a = (_n(p) + 'e').split('e')), +(a[0] + 'e' + (+a[1] - o))
              );
            }
            return t(i);
          };
        }
        var bp =
          Pe && 1 / Ur(new Pe([, -0]))[1] == F
            ? function (n) {
                return new Pe(n);
              }
            : Ro;
        function na(n) {
          return function (t) {
            var i = qn(t);
            return i == St ? Nu(t) : i == Et ? Kh(t) : Wh(t, n(t));
          };
        }
        function Ut(n, t, i, o, a, p, _, m) {
          var E = t & O;
          if (!E && typeof n != 'function') throw new gt(c);
          var L = o ? o.length : 0;
          if (
            (L || ((t &= ~(q | X)), (o = a = u)),
            (_ = _ === u ? _ : Dn(un(_), 0)),
            (m = m === u ? m : un(m)),
            (L -= a ? a.length : 0),
            t & X)
          ) {
            var b = o,
              N = a;
            o = a = u;
          }
          var D = E ? u : oo(n),
            H = [n, t, i, o, a, b, N, p, _, m];
          if (
            (D && Xp(H, D),
            (n = H[0]),
            (t = H[1]),
            (i = H[2]),
            (o = H[3]),
            (a = H[4]),
            (m = H[9] = H[9] === u ? (E ? 0 : n.length) : Dn(H[9] - L, 0)),
            !m && t & (k | B) && (t &= ~(k | B)),
            !t || t == $)
          )
            var Z = Ip(n, t, i);
          else
            t == k || t == B
              ? (Z = Mp(n, t, m))
              : (t == q || t == ($ | q)) && !a.length
              ? (Z = Lp(n, t, i, o))
              : (Z = li.apply(u, H));
          var fn = D ? Os : ca;
          return ha(fn(Z, H), n, t);
        }
        function ta(n, t, i, o) {
          return n === u || (Rt(n, be[i]) && !vn.call(o, i)) ? t : n;
        }
        function ea(n, t, i, o, a, p) {
          return (
            Rn(n) && Rn(t) && (p.set(t, n), oi(n, t, u, ea, p), p.delete(t)), n
          );
        }
        function Pp(n) {
          return gr(n) ? u : n;
        }
        function ra(n, t, i, o, a, p) {
          var _ = i & P,
            m = n.length,
            E = t.length;
          if (m != E && !(_ && E > m)) return !1;
          var L = p.get(n),
            b = p.get(t);
          if (L && b) return L == t && b == n;
          var N = -1,
            D = !0,
            H = i & z ? new ce() : u;
          for (p.set(n, t), p.set(t, n); ++N < m; ) {
            var Z = n[N],
              fn = t[N];
            if (o) var J = _ ? o(fn, Z, N, t, n, p) : o(Z, fn, N, n, t, p);
            if (J !== u) {
              if (J) continue;
              D = !1;
              break;
            }
            if (H) {
              if (
                !Tu(t, function (an, cn) {
                  if (!nr(H, cn) && (Z === an || a(Z, an, i, o, p)))
                    return H.push(cn);
                })
              ) {
                D = !1;
                break;
              }
            } else if (!(Z === fn || a(Z, fn, i, o, p))) {
              D = !1;
              break;
            }
          }
          return p.delete(n), p.delete(t), D;
        }
        function Np(n, t, i, o, a, p, _) {
          switch (i) {
            case Ce:
              if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset)
                return !1;
              (n = n.buffer), (t = t.buffer);
            case je:
              return !(
                n.byteLength != t.byteLength || !p(new Kr(n), new Kr(t))
              );
            case Hn:
            case Dt:
            case Ze:
              return Rt(+n, +t);
            case Or:
              return n.name == t.name && n.message == t.message;
            case Je:
            case Qe:
              return n == t + '';
            case St:
              var m = Nu;
            case Et:
              var E = o & P;
              if ((m || (m = Ur), n.size != t.size && !E)) return !1;
              var L = _.get(n);
              if (L) return L == t;
              (o |= z), _.set(n, t);
              var b = ra(m(n), m(t), o, a, p, _);
              return _.delete(n), b;
            case Fr:
              if (ur) return ur.call(n) == ur.call(t);
          }
          return !1;
        }
        function Op(n, t, i, o, a, p) {
          var _ = i & P,
            m = io(n),
            E = m.length,
            L = io(t),
            b = L.length;
          if (E != b && !_) return !1;
          for (var N = E; N--; ) {
            var D = m[N];
            if (!(_ ? D in t : vn.call(t, D))) return !1;
          }
          var H = p.get(n),
            Z = p.get(t);
          if (H && Z) return H == t && Z == n;
          var fn = !0;
          p.set(n, t), p.set(t, n);
          for (var J = _; ++N < E; ) {
            D = m[N];
            var an = n[D],
              cn = t[D];
            if (o) var st = _ ? o(cn, an, D, t, n, p) : o(an, cn, D, n, t, p);
            if (!(st === u ? an === cn || a(an, cn, i, o, p) : st)) {
              fn = !1;
              break;
            }
            J || (J = D == 'constructor');
          }
          if (fn && !J) {
            var Kn = n.constructor,
              at = t.constructor;
            Kn != at &&
              'constructor' in n &&
              'constructor' in t &&
              !(
                typeof Kn == 'function' &&
                Kn instanceof Kn &&
                typeof at == 'function' &&
                at instanceof at
              ) &&
              (fn = !1);
          }
          return p.delete(n), p.delete(t), fn;
        }
        function Gt(n) {
          return ho(aa(n, u, wa), n + '');
        }
        function io(n) {
          return Es(n, Bn, so);
        }
        function uo(n) {
          return Es(n, jn, ia);
        }
        var oo = ni
          ? function (n) {
              return ni.get(n);
            }
          : Ro;
        function gi(n) {
          for (
            var t = n.name + '', i = Ne[t], o = vn.call(Ne, t) ? i.length : 0;
            o--;

          ) {
            var a = i[o],
              p = a.func;
            if (p == null || p == n) return a.name;
          }
          return t;
        }
        function De(n) {
          var t = vn.call(l, 'placeholder') ? l : n;
          return t.placeholder;
        }
        function K() {
          var n = l.iteratee || Ao;
          return (
            (n = n === Ao ? Rs : n),
            arguments.length ? n(arguments[0], arguments[1]) : n
          );
        }
        function di(n, t) {
          var i = n.__data__;
          return Up(t) ? i[typeof t == 'string' ? 'string' : 'hash'] : i.map;
        }
        function fo(n) {
          for (var t = Bn(n), i = t.length; i--; ) {
            var o = t[i],
              a = n[o];
            t[i] = [o, a, fa(a)];
          }
          return t;
        }
        function ge(n, t) {
          var i = Hh(n, t);
          return Cs(i) ? i : u;
        }
        function $p(n) {
          var t = vn.call(n, ae),
            i = n[ae];
          try {
            n[ae] = u;
            var o = !0;
          } catch {}
          var a = Xr.call(n);
          return o && (t ? (n[ae] = i) : delete n[ae]), a;
        }
        var so = $u
            ? function (n) {
                return n == null
                  ? []
                  : ((n = wn(n)),
                    Vt($u(n), function (t) {
                      return ls.call(n, t);
                    }));
              }
            : To,
          ia = $u
            ? function (n) {
                for (var t = []; n; ) jt(t, so(n)), (n = Zr(n));
                return t;
              }
            : To,
          qn = Xn;
        ((Fu && qn(new Fu(new ArrayBuffer(1))) != Ce) ||
          (er && qn(new er()) != St) ||
          (Du && qn(Du.resolve()) != yf) ||
          (Pe && qn(new Pe()) != Et) ||
          (rr && qn(new rr()) != Ve)) &&
          (qn = function (n) {
            var t = Xn(n),
              i = t == zt ? n.constructor : u,
              o = i ? de(i) : '';
            if (o)
              switch (o) {
                case v0:
                  return Ce;
                case w0:
                  return St;
                case m0:
                  return yf;
                case y0:
                  return Et;
                case x0:
                  return Ve;
              }
            return t;
          });
        function Fp(n, t, i) {
          for (var o = -1, a = i.length; ++o < a; ) {
            var p = i[o],
              _ = p.size;
            switch (p.type) {
              case 'drop':
                n += _;
                break;
              case 'dropRight':
                t -= _;
                break;
              case 'take':
                t = Gn(t, n + _);
                break;
              case 'takeRight':
                n = Dn(n, t - _);
                break;
            }
          }
          return { start: n, end: t };
        }
        function Dp(n) {
          var t = n.match(Gc);
          return t ? t[1].split(qc) : [];
        }
        function ua(n, t, i) {
          t = ie(t, n);
          for (var o = -1, a = t.length, p = !1; ++o < a; ) {
            var _ = Pt(t[o]);
            if (!(p = n != null && i(n, _))) break;
            n = n[_];
          }
          return p || ++o != a
            ? p
            : ((a = n == null ? 0 : n.length),
              !!a && Si(a) && qt(_, a) && (en(n) || _e(n)));
        }
        function zp(n) {
          var t = n.length,
            i = new n.constructor(t);
          return (
            t &&
              typeof n[0] == 'string' &&
              vn.call(n, 'index') &&
              ((i.index = n.index), (i.input = n.input)),
            i
          );
        }
        function oa(n) {
          return typeof n.constructor == 'function' && !hr(n) ? Oe(Zr(n)) : {};
        }
        function Bp(n, t, i) {
          var o = n.constructor;
          switch (t) {
            case je:
              return to(n);
            case Hn:
            case Dt:
              return new o(+n);
            case Ce:
              return Sp(n, i);
            case fu:
            case su:
            case au:
            case lu:
            case cu:
            case hu:
            case pu:
            case gu:
            case du:
              return Us(n, i);
            case St:
              return new o();
            case Ze:
            case Qe:
              return new o(n);
            case Je:
              return Ep(n);
            case Et:
              return new o();
            case Fr:
              return Ap(n);
          }
        }
        function Wp(n, t) {
          var i = t.length;
          if (!i) return n;
          var o = i - 1;
          return (
            (t[o] = (i > 1 ? '& ' : '') + t[o]),
            (t = t.join(i > 2 ? ', ' : ' ')),
            n.replace(
              Uc,
              `{
/* [wrapped with ` +
                t +
                `] */
`
            )
          );
        }
        function kp(n) {
          return en(n) || _e(n) || !!(cs && n && n[cs]);
        }
        function qt(n, t) {
          var i = typeof n;
          return (
            (t = t ?? G),
            !!t &&
              (i == 'number' || (i != 'symbol' && jc.test(n))) &&
              n > -1 &&
              n % 1 == 0 &&
              n < t
          );
        }
        function Yn(n, t, i) {
          if (!Rn(i)) return !1;
          var o = typeof t;
          return (
            o == 'number' ? Vn(i) && qt(t, i.length) : o == 'string' && t in i
          )
            ? Rt(i[t], n)
            : !1;
        }
        function ao(n, t) {
          if (en(n)) return !1;
          var i = typeof n;
          return i == 'number' ||
            i == 'symbol' ||
            i == 'boolean' ||
            n == null ||
            ft(n)
            ? !0
            : zc.test(n) || !Dc.test(n) || (t != null && n in wn(t));
        }
        function Up(n) {
          var t = typeof n;
          return t == 'string' ||
            t == 'number' ||
            t == 'symbol' ||
            t == 'boolean'
            ? n !== '__proto__'
            : n === null;
        }
        function lo(n) {
          var t = gi(n),
            i = l[t];
          if (typeof i != 'function' || !(t in ln.prototype)) return !1;
          if (n === i) return !0;
          var o = oo(i);
          return !!o && n === o[0];
        }
        function Gp(n) {
          return !!fs && fs in n;
        }
        var qp = qr ? Ht : Io;
        function hr(n) {
          var t = n && n.constructor,
            i = (typeof t == 'function' && t.prototype) || be;
          return n === i;
        }
        function fa(n) {
          return n === n && !Rn(n);
        }
        function sa(n, t) {
          return function (i) {
            return i == null ? !1 : i[n] === t && (t !== u || n in wn(i));
          };
        }
        function Hp(n) {
          var t = yi(n, function (o) {
              return i.size === w && i.clear(), o;
            }),
            i = t.cache;
          return t;
        }
        function Xp(n, t) {
          var i = n[1],
            o = t[1],
            a = i | o,
            p = a < ($ | O | V),
            _ =
              (o == V && i == k) ||
              (o == V && i == rn && n[7].length <= t[8]) ||
              (o == (V | rn) && t[7].length <= t[8] && i == k);
          if (!(p || _)) return n;
          o & $ && ((n[2] = t[2]), (a |= i & $ ? 0 : U));
          var m = t[3];
          if (m) {
            var E = n[3];
            (n[3] = E ? qs(E, m, t[4]) : m), (n[4] = E ? ne(n[3], d) : t[4]);
          }
          return (
            (m = t[5]),
            m &&
              ((E = n[5]),
              (n[5] = E ? Hs(E, m, t[6]) : m),
              (n[6] = E ? ne(n[5], d) : t[6])),
            (m = t[7]),
            m && (n[7] = m),
            o & V && (n[8] = n[8] == null ? t[8] : Gn(n[8], t[8])),
            n[9] == null && (n[9] = t[9]),
            (n[0] = t[0]),
            (n[1] = a),
            n
          );
        }
        function Yp(n) {
          var t = [];
          if (n != null) for (var i in wn(n)) t.push(i);
          return t;
        }
        function Kp(n) {
          return Xr.call(n);
        }
        function aa(n, t, i) {
          return (
            (t = Dn(t === u ? n.length - 1 : t, 0)),
            function () {
              for (
                var o = arguments, a = -1, p = Dn(o.length - t, 0), _ = T(p);
                ++a < p;

              )
                _[a] = o[t + a];
              a = -1;
              for (var m = T(t + 1); ++a < t; ) m[a] = o[a];
              return (m[t] = i(_)), it(n, this, m);
            }
          );
        }
        function la(n, t) {
          return t.length < 2 ? n : pe(n, vt(t, 0, -1));
        }
        function Zp(n, t) {
          for (var i = n.length, o = Gn(t.length, i), a = Qn(n); o--; ) {
            var p = t[o];
            n[o] = qt(p, i) ? a[p] : u;
          }
          return n;
        }
        function co(n, t) {
          if (
            !(t === 'constructor' && typeof n[t] == 'function') &&
            t != '__proto__'
          )
            return n[t];
        }
        var ca = pa(Os),
          pr =
            l0 ||
            function (n, t) {
              return Wn.setTimeout(n, t);
            },
          ho = pa(wp);
        function ha(n, t, i) {
          var o = t + '';
          return ho(n, Wp(o, Jp(Dp(o), i)));
        }
        function pa(n) {
          var t = 0,
            i = 0;
          return function () {
            var o = g0(),
              a = xn - (o - i);
            if (((i = o), a > 0)) {
              if (++t >= zn) return arguments[0];
            } else t = 0;
            return n.apply(u, arguments);
          };
        }
        function _i(n, t) {
          var i = -1,
            o = n.length,
            a = o - 1;
          for (t = t === u ? o : t; ++i < t; ) {
            var p = Ku(i, a),
              _ = n[p];
            (n[p] = n[i]), (n[i] = _);
          }
          return (n.length = t), n;
        }
        var ga = Hp(function (n) {
          var t = [];
          return (
            n.charCodeAt(0) === 46 && t.push(''),
            n.replace(Bc, function (i, o, a, p) {
              t.push(a ? p.replace(Yc, '$1') : o || i);
            }),
            t
          );
        });
        function Pt(n) {
          if (typeof n == 'string' || ft(n)) return n;
          var t = n + '';
          return t == '0' && 1 / n == -F ? '-0' : t;
        }
        function de(n) {
          if (n != null) {
            try {
              return Hr.call(n);
            } catch {}
            try {
              return n + '';
            } catch {}
          }
          return '';
        }
        function Jp(n, t) {
          return (
            pt(An, function (i) {
              var o = '_.' + i[0];
              t & i[1] && !Wr(n, o) && n.push(o);
            }),
            n.sort()
          );
        }
        function da(n) {
          if (n instanceof ln) return n.clone();
          var t = new dt(n.__wrapped__, n.__chain__);
          return (
            (t.__actions__ = Qn(n.__actions__)),
            (t.__index__ = n.__index__),
            (t.__values__ = n.__values__),
            t
          );
        }
        function Qp(n, t, i) {
          (i ? Yn(n, t, i) : t === u) ? (t = 1) : (t = Dn(un(t), 0));
          var o = n == null ? 0 : n.length;
          if (!o || t < 1) return [];
          for (var a = 0, p = 0, _ = T(Vr(o / t)); a < o; )
            _[p++] = vt(n, a, (a += t));
          return _;
        }
        function Vp(n) {
          for (
            var t = -1, i = n == null ? 0 : n.length, o = 0, a = [];
            ++t < i;

          ) {
            var p = n[t];
            p && (a[o++] = p);
          }
          return a;
        }
        function jp() {
          var n = arguments.length;
          if (!n) return [];
          for (var t = T(n - 1), i = arguments[0], o = n; o--; )
            t[o - 1] = arguments[o];
          return jt(en(i) ? Qn(i) : [i], kn(t, 1));
        }
        var ng = sn(function (n, t) {
            return bn(n) ? fr(n, kn(t, 1, bn, !0)) : [];
          }),
          tg = sn(function (n, t) {
            var i = wt(t);
            return (
              bn(i) && (i = u), bn(n) ? fr(n, kn(t, 1, bn, !0), K(i, 2)) : []
            );
          }),
          eg = sn(function (n, t) {
            var i = wt(t);
            return bn(i) && (i = u), bn(n) ? fr(n, kn(t, 1, bn, !0), u, i) : [];
          });
        function rg(n, t, i) {
          var o = n == null ? 0 : n.length;
          return o
            ? ((t = i || t === u ? 1 : un(t)), vt(n, t < 0 ? 0 : t, o))
            : [];
        }
        function ig(n, t, i) {
          var o = n == null ? 0 : n.length;
          return o
            ? ((t = i || t === u ? 1 : un(t)),
              (t = o - t),
              vt(n, 0, t < 0 ? 0 : t))
            : [];
        }
        function ug(n, t) {
          return n && n.length ? si(n, K(t, 3), !0, !0) : [];
        }
        function og(n, t) {
          return n && n.length ? si(n, K(t, 3), !0) : [];
        }
        function fg(n, t, i, o) {
          var a = n == null ? 0 : n.length;
          return a
            ? (i && typeof i != 'number' && Yn(n, t, i) && ((i = 0), (o = a)),
              j0(n, t, i, o))
            : [];
        }
        function _a(n, t, i) {
          var o = n == null ? 0 : n.length;
          if (!o) return -1;
          var a = i == null ? 0 : un(i);
          return a < 0 && (a = Dn(o + a, 0)), kr(n, K(t, 3), a);
        }
        function va(n, t, i) {
          var o = n == null ? 0 : n.length;
          if (!o) return -1;
          var a = o - 1;
          return (
            i !== u && ((a = un(i)), (a = i < 0 ? Dn(o + a, 0) : Gn(a, o - 1))),
            kr(n, K(t, 3), a, !0)
          );
        }
        function wa(n) {
          var t = n == null ? 0 : n.length;
          return t ? kn(n, 1) : [];
        }
        function sg(n) {
          var t = n == null ? 0 : n.length;
          return t ? kn(n, F) : [];
        }
        function ag(n, t) {
          var i = n == null ? 0 : n.length;
          return i ? ((t = t === u ? 1 : un(t)), kn(n, t)) : [];
        }
        function lg(n) {
          for (var t = -1, i = n == null ? 0 : n.length, o = {}; ++t < i; ) {
            var a = n[t];
            o[a[0]] = a[1];
          }
          return o;
        }
        function ma(n) {
          return n && n.length ? n[0] : u;
        }
        function cg(n, t, i) {
          var o = n == null ? 0 : n.length;
          if (!o) return -1;
          var a = i == null ? 0 : un(i);
          return a < 0 && (a = Dn(o + a, 0)), Te(n, t, a);
        }
        function hg(n) {
          var t = n == null ? 0 : n.length;
          return t ? vt(n, 0, -1) : [];
        }
        var pg = sn(function (n) {
            var t = Cn(n, ju);
            return t.length && t[0] === n[0] ? Gu(t) : [];
          }),
          gg = sn(function (n) {
            var t = wt(n),
              i = Cn(n, ju);
            return (
              t === wt(i) ? (t = u) : i.pop(),
              i.length && i[0] === n[0] ? Gu(i, K(t, 2)) : []
            );
          }),
          dg = sn(function (n) {
            var t = wt(n),
              i = Cn(n, ju);
            return (
              (t = typeof t == 'function' ? t : u),
              t && i.pop(),
              i.length && i[0] === n[0] ? Gu(i, u, t) : []
            );
          });
        function _g(n, t) {
          return n == null ? '' : h0.call(n, t);
        }
        function wt(n) {
          var t = n == null ? 0 : n.length;
          return t ? n[t - 1] : u;
        }
        function vg(n, t, i) {
          var o = n == null ? 0 : n.length;
          if (!o) return -1;
          var a = o;
          return (
            i !== u && ((a = un(i)), (a = a < 0 ? Dn(o + a, 0) : Gn(a, o - 1))),
            t === t ? Jh(n, t, a) : kr(n, jf, a, !0)
          );
        }
        function wg(n, t) {
          return n && n.length ? Ls(n, un(t)) : u;
        }
        var mg = sn(ya);
        function ya(n, t) {
          return n && n.length && t && t.length ? Yu(n, t) : n;
        }
        function yg(n, t, i) {
          return n && n.length && t && t.length ? Yu(n, t, K(i, 2)) : n;
        }
        function xg(n, t, i) {
          return n && n.length && t && t.length ? Yu(n, t, u, i) : n;
        }
        var Sg = Gt(function (n, t) {
          var i = n == null ? 0 : n.length,
            o = Bu(n, t);
          return (
            Ns(
              n,
              Cn(t, function (a) {
                return qt(a, i) ? +a : a;
              }).sort(Gs)
            ),
            o
          );
        });
        function Eg(n, t) {
          var i = [];
          if (!(n && n.length)) return i;
          var o = -1,
            a = [],
            p = n.length;
          for (t = K(t, 3); ++o < p; ) {
            var _ = n[o];
            t(_, o, n) && (i.push(_), a.push(o));
          }
          return Ns(n, a), i;
        }
        function po(n) {
          return n == null ? n : _0.call(n);
        }
        function Ag(n, t, i) {
          var o = n == null ? 0 : n.length;
          return o
            ? (i && typeof i != 'number' && Yn(n, t, i)
                ? ((t = 0), (i = o))
                : ((t = t == null ? 0 : un(t)), (i = i === u ? o : un(i))),
              vt(n, t, i))
            : [];
        }
        function Cg(n, t) {
          return fi(n, t);
        }
        function Rg(n, t, i) {
          return Ju(n, t, K(i, 2));
        }
        function Tg(n, t) {
          var i = n == null ? 0 : n.length;
          if (i) {
            var o = fi(n, t);
            if (o < i && Rt(n[o], t)) return o;
          }
          return -1;
        }
        function Ig(n, t) {
          return fi(n, t, !0);
        }
        function Mg(n, t, i) {
          return Ju(n, t, K(i, 2), !0);
        }
        function Lg(n, t) {
          var i = n == null ? 0 : n.length;
          if (i) {
            var o = fi(n, t, !0) - 1;
            if (Rt(n[o], t)) return o;
          }
          return -1;
        }
        function bg(n) {
          return n && n.length ? $s(n) : [];
        }
        function Pg(n, t) {
          return n && n.length ? $s(n, K(t, 2)) : [];
        }
        function Ng(n) {
          var t = n == null ? 0 : n.length;
          return t ? vt(n, 1, t) : [];
        }
        function Og(n, t, i) {
          return n && n.length
            ? ((t = i || t === u ? 1 : un(t)), vt(n, 0, t < 0 ? 0 : t))
            : [];
        }
        function $g(n, t, i) {
          var o = n == null ? 0 : n.length;
          return o
            ? ((t = i || t === u ? 1 : un(t)),
              (t = o - t),
              vt(n, t < 0 ? 0 : t, o))
            : [];
        }
        function Fg(n, t) {
          return n && n.length ? si(n, K(t, 3), !1, !0) : [];
        }
        function Dg(n, t) {
          return n && n.length ? si(n, K(t, 3)) : [];
        }
        var zg = sn(function (n) {
            return re(kn(n, 1, bn, !0));
          }),
          Bg = sn(function (n) {
            var t = wt(n);
            return bn(t) && (t = u), re(kn(n, 1, bn, !0), K(t, 2));
          }),
          Wg = sn(function (n) {
            var t = wt(n);
            return (
              (t = typeof t == 'function' ? t : u), re(kn(n, 1, bn, !0), u, t)
            );
          });
        function kg(n) {
          return n && n.length ? re(n) : [];
        }
        function Ug(n, t) {
          return n && n.length ? re(n, K(t, 2)) : [];
        }
        function Gg(n, t) {
          return (
            (t = typeof t == 'function' ? t : u),
            n && n.length ? re(n, u, t) : []
          );
        }
        function go(n) {
          if (!(n && n.length)) return [];
          var t = 0;
          return (
            (n = Vt(n, function (i) {
              if (bn(i)) return (t = Dn(i.length, t)), !0;
            })),
            bu(t, function (i) {
              return Cn(n, Iu(i));
            })
          );
        }
        function xa(n, t) {
          if (!(n && n.length)) return [];
          var i = go(n);
          return t == null
            ? i
            : Cn(i, function (o) {
                return it(t, u, o);
              });
        }
        var qg = sn(function (n, t) {
            return bn(n) ? fr(n, t) : [];
          }),
          Hg = sn(function (n) {
            return Vu(Vt(n, bn));
          }),
          Xg = sn(function (n) {
            var t = wt(n);
            return bn(t) && (t = u), Vu(Vt(n, bn), K(t, 2));
          }),
          Yg = sn(function (n) {
            var t = wt(n);
            return (t = typeof t == 'function' ? t : u), Vu(Vt(n, bn), u, t);
          }),
          Kg = sn(go);
        function Zg(n, t) {
          return Bs(n || [], t || [], or);
        }
        function Jg(n, t) {
          return Bs(n || [], t || [], lr);
        }
        var Qg = sn(function (n) {
          var t = n.length,
            i = t > 1 ? n[t - 1] : u;
          return (i = typeof i == 'function' ? (n.pop(), i) : u), xa(n, i);
        });
        function Sa(n) {
          var t = l(n);
          return (t.__chain__ = !0), t;
        }
        function Vg(n, t) {
          return t(n), n;
        }
        function vi(n, t) {
          return t(n);
        }
        var jg = Gt(function (n) {
          var t = n.length,
            i = t ? n[0] : 0,
            o = this.__wrapped__,
            a = function (p) {
              return Bu(p, n);
            };
          return t > 1 ||
            this.__actions__.length ||
            !(o instanceof ln) ||
            !qt(i)
            ? this.thru(a)
            : ((o = o.slice(i, +i + (t ? 1 : 0))),
              o.__actions__.push({
                func: vi,
                args: [a],
                thisArg: u,
              }),
              new dt(o, this.__chain__).thru(function (p) {
                return t && !p.length && p.push(u), p;
              }));
        });
        function nd() {
          return Sa(this);
        }
        function td() {
          return new dt(this.value(), this.__chain__);
        }
        function ed() {
          this.__values__ === u && (this.__values__ = Fa(this.value()));
          var n = this.__index__ >= this.__values__.length,
            t = n ? u : this.__values__[this.__index__++];
          return { done: n, value: t };
        }
        function rd() {
          return this;
        }
        function id(n) {
          for (var t, i = this; i instanceof ei; ) {
            var o = da(i);
            (o.__index__ = 0),
              (o.__values__ = u),
              t ? (a.__wrapped__ = o) : (t = o);
            var a = o;
            i = i.__wrapped__;
          }
          return (a.__wrapped__ = n), t;
        }
        function ud() {
          var n = this.__wrapped__;
          if (n instanceof ln) {
            var t = n;
            return (
              this.__actions__.length && (t = new ln(this)),
              (t = t.reverse()),
              t.__actions__.push({
                func: vi,
                args: [po],
                thisArg: u,
              }),
              new dt(t, this.__chain__)
            );
          }
          return this.thru(po);
        }
        function od() {
          return zs(this.__wrapped__, this.__actions__);
        }
        var fd = ai(function (n, t, i) {
          vn.call(n, i) ? ++n[i] : kt(n, i, 1);
        });
        function sd(n, t, i) {
          var o = en(n) ? Qf : V0;
          return i && Yn(n, t, i) && (t = u), o(n, K(t, 3));
        }
        function ad(n, t) {
          var i = en(n) ? Vt : xs;
          return i(n, K(t, 3));
        }
        var ld = Zs(_a),
          cd = Zs(va);
        function hd(n, t) {
          return kn(wi(n, t), 1);
        }
        function pd(n, t) {
          return kn(wi(n, t), F);
        }
        function gd(n, t, i) {
          return (i = i === u ? 1 : un(i)), kn(wi(n, t), i);
        }
        function Ea(n, t) {
          var i = en(n) ? pt : ee;
          return i(n, K(t, 3));
        }
        function Aa(n, t) {
          var i = en(n) ? Nh : ys;
          return i(n, K(t, 3));
        }
        var dd = ai(function (n, t, i) {
          vn.call(n, i) ? n[i].push(t) : kt(n, i, [t]);
        });
        function _d(n, t, i, o) {
          (n = Vn(n) ? n : Be(n)), (i = i && !o ? un(i) : 0);
          var a = n.length;
          return (
            i < 0 && (i = Dn(a + i, 0)),
            Ei(n) ? i <= a && n.indexOf(t, i) > -1 : !!a && Te(n, t, i) > -1
          );
        }
        var vd = sn(function (n, t, i) {
            var o = -1,
              a = typeof t == 'function',
              p = Vn(n) ? T(n.length) : [];
            return (
              ee(n, function (_) {
                p[++o] = a ? it(t, _, i) : sr(_, t, i);
              }),
              p
            );
          }),
          wd = ai(function (n, t, i) {
            kt(n, i, t);
          });
        function wi(n, t) {
          var i = en(n) ? Cn : Ts;
          return i(n, K(t, 3));
        }
        function md(n, t, i, o) {
          return n == null
            ? []
            : (en(t) || (t = t == null ? [] : [t]),
              (i = o ? u : i),
              en(i) || (i = i == null ? [] : [i]),
              bs(n, t, i));
        }
        var yd = ai(
          function (n, t, i) {
            n[i ? 0 : 1].push(t);
          },
          function () {
            return [[], []];
          }
        );
        function xd(n, t, i) {
          var o = en(n) ? Ru : ts,
            a = arguments.length < 3;
          return o(n, K(t, 4), i, a, ee);
        }
        function Sd(n, t, i) {
          var o = en(n) ? Oh : ts,
            a = arguments.length < 3;
          return o(n, K(t, 4), i, a, ys);
        }
        function Ed(n, t) {
          var i = en(n) ? Vt : xs;
          return i(n, xi(K(t, 3)));
        }
        function Ad(n) {
          var t = en(n) ? _s : _p;
          return t(n);
        }
        function Cd(n, t, i) {
          (i ? Yn(n, t, i) : t === u) ? (t = 1) : (t = un(t));
          var o = en(n) ? Y0 : vp;
          return o(n, t);
        }
        function Rd(n) {
          var t = en(n) ? K0 : mp;
          return t(n);
        }
        function Td(n) {
          if (n == null) return 0;
          if (Vn(n)) return Ei(n) ? Me(n) : n.length;
          var t = qn(n);
          return t == St || t == Et ? n.size : Hu(n).length;
        }
        function Id(n, t, i) {
          var o = en(n) ? Tu : yp;
          return i && Yn(n, t, i) && (t = u), o(n, K(t, 3));
        }
        var Md = sn(function (n, t) {
            if (n == null) return [];
            var i = t.length;
            return (
              i > 1 && Yn(n, t[0], t[1])
                ? (t = [])
                : i > 2 && Yn(t[0], t[1], t[2]) && (t = [t[0]]),
              bs(n, kn(t, 1), [])
            );
          }),
          mi =
            a0 ||
            function () {
              return Wn.Date.now();
            };
        function Ld(n, t) {
          if (typeof t != 'function') throw new gt(c);
          return (
            (n = un(n)),
            function () {
              if (--n < 1) return t.apply(this, arguments);
            }
          );
        }
        function Ca(n, t, i) {
          return (
            (t = i ? u : t),
            (t = n && t == null ? n.length : t),
            Ut(n, V, u, u, u, u, t)
          );
        }
        function Ra(n, t) {
          var i;
          if (typeof t != 'function') throw new gt(c);
          return (
            (n = un(n)),
            function () {
              return (
                --n > 0 && (i = t.apply(this, arguments)), n <= 1 && (t = u), i
              );
            }
          );
        }
        var _o = sn(function (n, t, i) {
            var o = $;
            if (i.length) {
              var a = ne(i, De(_o));
              o |= q;
            }
            return Ut(n, o, t, i, a);
          }),
          Ta = sn(function (n, t, i) {
            var o = $ | O;
            if (i.length) {
              var a = ne(i, De(Ta));
              o |= q;
            }
            return Ut(t, o, n, i, a);
          });
        function Ia(n, t, i) {
          t = i ? u : t;
          var o = Ut(n, k, u, u, u, u, u, t);
          return (o.placeholder = Ia.placeholder), o;
        }
        function Ma(n, t, i) {
          t = i ? u : t;
          var o = Ut(n, B, u, u, u, u, u, t);
          return (o.placeholder = Ma.placeholder), o;
        }
        function La(n, t, i) {
          var o,
            a,
            p,
            _,
            m,
            E,
            L = 0,
            b = !1,
            N = !1,
            D = !0;
          if (typeof n != 'function') throw new gt(c);
          (t = mt(t) || 0),
            Rn(i) &&
              ((b = !!i.leading),
              (N = 'maxWait' in i),
              (p = N ? Dn(mt(i.maxWait) || 0, t) : p),
              (D = 'trailing' in i ? !!i.trailing : D));
          function H(Pn) {
            var Tt = o,
              Yt = a;
            return (o = a = u), (L = Pn), (_ = n.apply(Yt, Tt)), _;
          }
          function Z(Pn) {
            return (L = Pn), (m = pr(an, t)), b ? H(Pn) : _;
          }
          function fn(Pn) {
            var Tt = Pn - E,
              Yt = Pn - L,
              Za = t - Tt;
            return N ? Gn(Za, p - Yt) : Za;
          }
          function J(Pn) {
            var Tt = Pn - E,
              Yt = Pn - L;
            return E === u || Tt >= t || Tt < 0 || (N && Yt >= p);
          }
          function an() {
            var Pn = mi();
            if (J(Pn)) return cn(Pn);
            m = pr(an, fn(Pn));
          }
          function cn(Pn) {
            return (m = u), D && o ? H(Pn) : ((o = a = u), _);
          }
          function st() {
            m !== u && Ws(m), (L = 0), (o = E = a = m = u);
          }
          function Kn() {
            return m === u ? _ : cn(mi());
          }
          function at() {
            var Pn = mi(),
              Tt = J(Pn);
            if (((o = arguments), (a = this), (E = Pn), Tt)) {
              if (m === u) return Z(E);
              if (N) return Ws(m), (m = pr(an, t)), H(E);
            }
            return m === u && (m = pr(an, t)), _;
          }
          return (at.cancel = st), (at.flush = Kn), at;
        }
        var bd = sn(function (n, t) {
            return ms(n, 1, t);
          }),
          Pd = sn(function (n, t, i) {
            return ms(n, mt(t) || 0, i);
          });
        function Nd(n) {
          return Ut(n, on);
        }
        function yi(n, t) {
          if (typeof n != 'function' || (t != null && typeof t != 'function'))
            throw new gt(c);
          var i = function () {
            var o = arguments,
              a = t ? t.apply(this, o) : o[0],
              p = i.cache;
            if (p.has(a)) return p.get(a);
            var _ = n.apply(this, o);
            return (i.cache = p.set(a, _) || p), _;
          };
          return (i.cache = new (yi.Cache || Wt)()), i;
        }
        yi.Cache = Wt;
        function xi(n) {
          if (typeof n != 'function') throw new gt(c);
          return function () {
            var t = arguments;
            switch (t.length) {
              case 0:
                return !n.call(this);
              case 1:
                return !n.call(this, t[0]);
              case 2:
                return !n.call(this, t[0], t[1]);
              case 3:
                return !n.call(this, t[0], t[1], t[2]);
            }
            return !n.apply(this, t);
          };
        }
        function Od(n) {
          return Ra(2, n);
        }
        var $d = xp(function (n, t) {
            t =
              t.length == 1 && en(t[0])
                ? Cn(t[0], ut(K()))
                : Cn(kn(t, 1), ut(K()));
            var i = t.length;
            return sn(function (o) {
              for (var a = -1, p = Gn(o.length, i); ++a < p; )
                o[a] = t[a].call(this, o[a]);
              return it(n, this, o);
            });
          }),
          vo = sn(function (n, t) {
            var i = ne(t, De(vo));
            return Ut(n, q, u, t, i);
          }),
          ba = sn(function (n, t) {
            var i = ne(t, De(ba));
            return Ut(n, X, u, t, i);
          }),
          Fd = Gt(function (n, t) {
            return Ut(n, rn, u, u, u, t);
          });
        function Dd(n, t) {
          if (typeof n != 'function') throw new gt(c);
          return (t = t === u ? t : un(t)), sn(n, t);
        }
        function zd(n, t) {
          if (typeof n != 'function') throw new gt(c);
          return (
            (t = t == null ? 0 : Dn(un(t), 0)),
            sn(function (i) {
              var o = i[t],
                a = ue(i, 0, t);
              return o && jt(a, o), it(n, this, a);
            })
          );
        }
        function Bd(n, t, i) {
          var o = !0,
            a = !0;
          if (typeof n != 'function') throw new gt(c);
          return (
            Rn(i) &&
              ((o = 'leading' in i ? !!i.leading : o),
              (a = 'trailing' in i ? !!i.trailing : a)),
            La(n, t, {
              leading: o,
              maxWait: t,
              trailing: a,
            })
          );
        }
        function Wd(n) {
          return Ca(n, 1);
        }
        function kd(n, t) {
          return vo(no(t), n);
        }
        function Ud() {
          if (!arguments.length) return [];
          var n = arguments[0];
          return en(n) ? n : [n];
        }
        function Gd(n) {
          return _t(n, C);
        }
        function qd(n, t) {
          return (t = typeof t == 'function' ? t : u), _t(n, C, t);
        }
        function Hd(n) {
          return _t(n, y | C);
        }
        function Xd(n, t) {
          return (t = typeof t == 'function' ? t : u), _t(n, y | C, t);
        }
        function Yd(n, t) {
          return t == null || ws(n, t, Bn(t));
        }
        function Rt(n, t) {
          return n === t || (n !== n && t !== t);
        }
        var Kd = pi(Uu),
          Zd = pi(function (n, t) {
            return n >= t;
          }),
          _e = As(
            /* @__PURE__ */ (function () {
              return arguments;
            })()
          )
            ? As
            : function (n) {
                return Mn(n) && vn.call(n, 'callee') && !ls.call(n, 'callee');
              },
          en = T.isArray,
          Jd = Hf ? ut(Hf) : ip;
        function Vn(n) {
          return n != null && Si(n.length) && !Ht(n);
        }
        function bn(n) {
          return Mn(n) && Vn(n);
        }
        function Qd(n) {
          return n === !0 || n === !1 || (Mn(n) && Xn(n) == Hn);
        }
        var oe = c0 || Io,
          Vd = Xf ? ut(Xf) : up;
        function jd(n) {
          return Mn(n) && n.nodeType === 1 && !gr(n);
        }
        function n_(n) {
          if (n == null) return !0;
          if (
            Vn(n) &&
            (en(n) ||
              typeof n == 'string' ||
              typeof n.splice == 'function' ||
              oe(n) ||
              ze(n) ||
              _e(n))
          )
            return !n.length;
          var t = qn(n);
          if (t == St || t == Et) return !n.size;
          if (hr(n)) return !Hu(n).length;
          for (var i in n) if (vn.call(n, i)) return !1;
          return !0;
        }
        function t_(n, t) {
          return ar(n, t);
        }
        function e_(n, t, i) {
          i = typeof i == 'function' ? i : u;
          var o = i ? i(n, t) : u;
          return o === u ? ar(n, t, u, i) : !!o;
        }
        function wo(n) {
          if (!Mn(n)) return !1;
          var t = Xn(n);
          return (
            t == Or ||
            t == Cc ||
            (typeof n.message == 'string' &&
              typeof n.name == 'string' &&
              !gr(n))
          );
        }
        function r_(n) {
          return typeof n == 'number' && hs(n);
        }
        function Ht(n) {
          if (!Rn(n)) return !1;
          var t = Xn(n);
          return t == $r || t == mf || t == rt || t == Tc;
        }
        function Pa(n) {
          return typeof n == 'number' && n == un(n);
        }
        function Si(n) {
          return typeof n == 'number' && n > -1 && n % 1 == 0 && n <= G;
        }
        function Rn(n) {
          var t = typeof n;
          return n != null && (t == 'object' || t == 'function');
        }
        function Mn(n) {
          return n != null && typeof n == 'object';
        }
        var Na = Yf ? ut(Yf) : fp;
        function i_(n, t) {
          return n === t || qu(n, t, fo(t));
        }
        function u_(n, t, i) {
          return (i = typeof i == 'function' ? i : u), qu(n, t, fo(t), i);
        }
        function o_(n) {
          return Oa(n) && n != +n;
        }
        function f_(n) {
          if (qp(n)) throw new tn(h);
          return Cs(n);
        }
        function s_(n) {
          return n === null;
        }
        function a_(n) {
          return n == null;
        }
        function Oa(n) {
          return typeof n == 'number' || (Mn(n) && Xn(n) == Ze);
        }
        function gr(n) {
          if (!Mn(n) || Xn(n) != zt) return !1;
          var t = Zr(n);
          if (t === null) return !0;
          var i = vn.call(t, 'constructor') && t.constructor;
          return typeof i == 'function' && i instanceof i && Hr.call(i) == u0;
        }
        var mo = Kf ? ut(Kf) : sp;
        function l_(n) {
          return Pa(n) && n >= -G && n <= G;
        }
        var $a = Zf ? ut(Zf) : ap;
        function Ei(n) {
          return typeof n == 'string' || (!en(n) && Mn(n) && Xn(n) == Qe);
        }
        function ft(n) {
          return typeof n == 'symbol' || (Mn(n) && Xn(n) == Fr);
        }
        var ze = Jf ? ut(Jf) : lp;
        function c_(n) {
          return n === u;
        }
        function h_(n) {
          return Mn(n) && qn(n) == Ve;
        }
        function p_(n) {
          return Mn(n) && Xn(n) == Mc;
        }
        var g_ = pi(Xu),
          d_ = pi(function (n, t) {
            return n <= t;
          });
        function Fa(n) {
          if (!n) return [];
          if (Vn(n)) return Ei(n) ? At(n) : Qn(n);
          if (tr && n[tr]) return Yh(n[tr]());
          var t = qn(n),
            i = t == St ? Nu : t == Et ? Ur : Be;
          return i(n);
        }
        function Xt(n) {
          if (!n) return n === 0 ? n : 0;
          if (((n = mt(n)), n === F || n === -F)) {
            var t = n < 0 ? -1 : 1;
            return t * Y;
          }
          return n === n ? n : 0;
        }
        function un(n) {
          var t = Xt(n),
            i = t % 1;
          return t === t ? (i ? t - i : t) : 0;
        }
        function Da(n) {
          return n ? he(un(n), 0, Q) : 0;
        }
        function mt(n) {
          if (typeof n == 'number') return n;
          if (ft(n)) return nn;
          if (Rn(n)) {
            var t = typeof n.valueOf == 'function' ? n.valueOf() : n;
            n = Rn(t) ? t + '' : t;
          }
          if (typeof n != 'string') return n === 0 ? n : +n;
          n = es(n);
          var i = Jc.test(n);
          return i || Vc.test(n)
            ? Lh(n.slice(2), i ? 2 : 8)
            : Zc.test(n)
            ? nn
            : +n;
        }
        function za(n) {
          return bt(n, jn(n));
        }
        function __(n) {
          return n ? he(un(n), -G, G) : n === 0 ? n : 0;
        }
        function _n(n) {
          return n == null ? '' : ot(n);
        }
        var v_ = $e(function (n, t) {
            if (hr(t) || Vn(t)) {
              bt(t, Bn(t), n);
              return;
            }
            for (var i in t) vn.call(t, i) && or(n, i, t[i]);
          }),
          Ba = $e(function (n, t) {
            bt(t, jn(t), n);
          }),
          Ai = $e(function (n, t, i, o) {
            bt(t, jn(t), n, o);
          }),
          w_ = $e(function (n, t, i, o) {
            bt(t, Bn(t), n, o);
          }),
          m_ = Gt(Bu);
        function y_(n, t) {
          var i = Oe(n);
          return t == null ? i : vs(i, t);
        }
        var x_ = sn(function (n, t) {
            n = wn(n);
            var i = -1,
              o = t.length,
              a = o > 2 ? t[2] : u;
            for (a && Yn(t[0], t[1], a) && (o = 1); ++i < o; )
              for (var p = t[i], _ = jn(p), m = -1, E = _.length; ++m < E; ) {
                var L = _[m],
                  b = n[L];
                (b === u || (Rt(b, be[L]) && !vn.call(n, L))) && (n[L] = p[L]);
              }
            return n;
          }),
          S_ = sn(function (n) {
            return n.push(u, ea), it(Wa, u, n);
          });
        function E_(n, t) {
          return Vf(n, K(t, 3), Lt);
        }
        function A_(n, t) {
          return Vf(n, K(t, 3), ku);
        }
        function C_(n, t) {
          return n == null ? n : Wu(n, K(t, 3), jn);
        }
        function R_(n, t) {
          return n == null ? n : Ss(n, K(t, 3), jn);
        }
        function T_(n, t) {
          return n && Lt(n, K(t, 3));
        }
        function I_(n, t) {
          return n && ku(n, K(t, 3));
        }
        function M_(n) {
          return n == null ? [] : ui(n, Bn(n));
        }
        function L_(n) {
          return n == null ? [] : ui(n, jn(n));
        }
        function yo(n, t, i) {
          var o = n == null ? u : pe(n, t);
          return o === u ? i : o;
        }
        function b_(n, t) {
          return n != null && ua(n, t, np);
        }
        function xo(n, t) {
          return n != null && ua(n, t, tp);
        }
        var P_ = Qs(function (n, t, i) {
            t != null && typeof t.toString != 'function' && (t = Xr.call(t)),
              (n[t] = i);
          }, Eo(nt)),
          N_ = Qs(function (n, t, i) {
            t != null && typeof t.toString != 'function' && (t = Xr.call(t)),
              vn.call(n, t) ? n[t].push(i) : (n[t] = [i]);
          }, K),
          O_ = sn(sr);
        function Bn(n) {
          return Vn(n) ? ds(n) : Hu(n);
        }
        function jn(n) {
          return Vn(n) ? ds(n, !0) : cp(n);
        }
        function $_(n, t) {
          var i = {};
          return (
            (t = K(t, 3)),
            Lt(n, function (o, a, p) {
              kt(i, t(o, a, p), o);
            }),
            i
          );
        }
        function F_(n, t) {
          var i = {};
          return (
            (t = K(t, 3)),
            Lt(n, function (o, a, p) {
              kt(i, a, t(o, a, p));
            }),
            i
          );
        }
        var D_ = $e(function (n, t, i) {
            oi(n, t, i);
          }),
          Wa = $e(function (n, t, i, o) {
            oi(n, t, i, o);
          }),
          z_ = Gt(function (n, t) {
            var i = {};
            if (n == null) return i;
            var o = !1;
            (t = Cn(t, function (p) {
              return (p = ie(p, n)), o || (o = p.length > 1), p;
            })),
              bt(n, uo(n), i),
              o && (i = _t(i, y | x | C, Pp));
            for (var a = t.length; a--; ) Qu(i, t[a]);
            return i;
          });
        function B_(n, t) {
          return ka(n, xi(K(t)));
        }
        var W_ = Gt(function (n, t) {
          return n == null ? {} : pp(n, t);
        });
        function ka(n, t) {
          if (n == null) return {};
          var i = Cn(uo(n), function (o) {
            return [o];
          });
          return (
            (t = K(t)),
            Ps(n, i, function (o, a) {
              return t(o, a[0]);
            })
          );
        }
        function k_(n, t, i) {
          t = ie(t, n);
          var o = -1,
            a = t.length;
          for (a || ((a = 1), (n = u)); ++o < a; ) {
            var p = n == null ? u : n[Pt(t[o])];
            p === u && ((o = a), (p = i)), (n = Ht(p) ? p.call(n) : p);
          }
          return n;
        }
        function U_(n, t, i) {
          return n == null ? n : lr(n, t, i);
        }
        function G_(n, t, i, o) {
          return (
            (o = typeof o == 'function' ? o : u), n == null ? n : lr(n, t, i, o)
          );
        }
        var Ua = na(Bn),
          Ga = na(jn);
        function q_(n, t, i) {
          var o = en(n),
            a = o || oe(n) || ze(n);
          if (((t = K(t, 4)), i == null)) {
            var p = n && n.constructor;
            a
              ? (i = o ? new p() : [])
              : Rn(n)
              ? (i = Ht(p) ? Oe(Zr(n)) : {})
              : (i = {});
          }
          return (
            (a ? pt : Lt)(n, function (_, m, E) {
              return t(i, _, m, E);
            }),
            i
          );
        }
        function H_(n, t) {
          return n == null ? !0 : Qu(n, t);
        }
        function X_(n, t, i) {
          return n == null ? n : Ds(n, t, no(i));
        }
        function Y_(n, t, i, o) {
          return (
            (o = typeof o == 'function' ? o : u),
            n == null ? n : Ds(n, t, no(i), o)
          );
        }
        function Be(n) {
          return n == null ? [] : Pu(n, Bn(n));
        }
        function K_(n) {
          return n == null ? [] : Pu(n, jn(n));
        }
        function Z_(n, t, i) {
          return (
            i === u && ((i = t), (t = u)),
            i !== u && ((i = mt(i)), (i = i === i ? i : 0)),
            t !== u && ((t = mt(t)), (t = t === t ? t : 0)),
            he(mt(n), t, i)
          );
        }
        function J_(n, t, i) {
          return (
            (t = Xt(t)),
            i === u ? ((i = t), (t = 0)) : (i = Xt(i)),
            (n = mt(n)),
            ep(n, t, i)
          );
        }
        function Q_(n, t, i) {
          if (
            (i && typeof i != 'boolean' && Yn(n, t, i) && (t = i = u),
            i === u &&
              (typeof t == 'boolean'
                ? ((i = t), (t = u))
                : typeof n == 'boolean' && ((i = n), (n = u))),
            n === u && t === u
              ? ((n = 0), (t = 1))
              : ((n = Xt(n)), t === u ? ((t = n), (n = 0)) : (t = Xt(t))),
            n > t)
          ) {
            var o = n;
            (n = t), (t = o);
          }
          if (i || n % 1 || t % 1) {
            var a = ps();
            return Gn(n + a * (t - n + Mh('1e-' + ((a + '').length - 1))), t);
          }
          return Ku(n, t);
        }
        var V_ = Fe(function (n, t, i) {
          return (t = t.toLowerCase()), n + (i ? qa(t) : t);
        });
        function qa(n) {
          return So(_n(n).toLowerCase());
        }
        function Ha(n) {
          return (n = _n(n)), n && n.replace(nh, Uh).replace(mh, '');
        }
        function j_(n, t, i) {
          (n = _n(n)), (t = ot(t));
          var o = n.length;
          i = i === u ? o : he(un(i), 0, o);
          var a = i;
          return (i -= t.length), i >= 0 && n.slice(i, a) == t;
        }
        function n1(n) {
          return (n = _n(n)), n && Oc.test(n) ? n.replace(Sf, Gh) : n;
        }
        function t1(n) {
          return (n = _n(n)), n && Wc.test(n) ? n.replace(_u, '\\$&') : n;
        }
        var e1 = Fe(function (n, t, i) {
            return n + (i ? '-' : '') + t.toLowerCase();
          }),
          r1 = Fe(function (n, t, i) {
            return n + (i ? ' ' : '') + t.toLowerCase();
          }),
          i1 = Ks('toLowerCase');
        function u1(n, t, i) {
          (n = _n(n)), (t = un(t));
          var o = t ? Me(n) : 0;
          if (!t || o >= t) return n;
          var a = (t - o) / 2;
          return hi(jr(a), i) + n + hi(Vr(a), i);
        }
        function o1(n, t, i) {
          (n = _n(n)), (t = un(t));
          var o = t ? Me(n) : 0;
          return t && o < t ? n + hi(t - o, i) : n;
        }
        function f1(n, t, i) {
          (n = _n(n)), (t = un(t));
          var o = t ? Me(n) : 0;
          return t && o < t ? hi(t - o, i) + n : n;
        }
        function s1(n, t, i) {
          return (
            i || t == null ? (t = 0) : t && (t = +t),
            d0(_n(n).replace(vu, ''), t || 0)
          );
        }
        function a1(n, t, i) {
          return (
            (i ? Yn(n, t, i) : t === u) ? (t = 1) : (t = un(t)), Zu(_n(n), t)
          );
        }
        function l1() {
          var n = arguments,
            t = _n(n[0]);
          return n.length < 3 ? t : t.replace(n[1], n[2]);
        }
        var c1 = Fe(function (n, t, i) {
          return n + (i ? '_' : '') + t.toLowerCase();
        });
        function h1(n, t, i) {
          return (
            i && typeof i != 'number' && Yn(n, t, i) && (t = i = u),
            (i = i === u ? Q : i >>> 0),
            i
              ? ((n = _n(n)),
                n &&
                (typeof t == 'string' || (t != null && !mo(t))) &&
                ((t = ot(t)), !t && Ie(n))
                  ? ue(At(n), 0, i)
                  : n.split(t, i))
              : []
          );
        }
        var p1 = Fe(function (n, t, i) {
          return n + (i ? ' ' : '') + So(t);
        });
        function g1(n, t, i) {
          return (
            (n = _n(n)),
            (i = i == null ? 0 : he(un(i), 0, n.length)),
            (t = ot(t)),
            n.slice(i, i + t.length) == t
          );
        }
        function d1(n, t, i) {
          var o = l.templateSettings;
          i && Yn(n, t, i) && (t = u), (n = _n(n)), (t = Ai({}, t, o, ta));
          var a = Ai({}, t.imports, o.imports, ta),
            p = Bn(a),
            _ = Pu(a, p),
            m,
            E,
            L = 0,
            b = t.interpolate || Dr,
            N = "__p += '",
            D = Ou(
              (t.escape || Dr).source +
                '|' +
                b.source +
                '|' +
                (b === Ef ? Kc : Dr).source +
                '|' +
                (t.evaluate || Dr).source +
                '|$',
              'g'
            ),
            H =
              '//# sourceURL=' +
              (vn.call(t, 'sourceURL')
                ? (t.sourceURL + '').replace(/\s/g, ' ')
                : 'lodash.templateSources[' + ++Ah + ']') +
              `
`;
          n.replace(D, function (J, an, cn, st, Kn, at) {
            return (
              cn || (cn = st),
              (N += n.slice(L, at).replace(th, qh)),
              an &&
                ((m = !0),
                (N +=
                  `' +
__e(` +
                  an +
                  `) +
'`)),
              Kn &&
                ((E = !0),
                (N +=
                  `';
` +
                  Kn +
                  `;
__p += '`)),
              cn &&
                (N +=
                  `' +
((__t = (` +
                  cn +
                  `)) == null ? '' : __t) +
'`),
              (L = at + J.length),
              J
            );
          }),
            (N += `';
`);
          var Z = vn.call(t, 'variable') && t.variable;
          if (!Z)
            N =
              `with (obj) {
` +
              N +
              `
}
`;
          else if (Xc.test(Z)) throw new tn(g);
          (N = (E ? N.replace(Lc, '') : N)
            .replace(bc, '$1')
            .replace(Pc, '$1;')),
            (N =
              'function(' +
              (Z || 'obj') +
              `) {
` +
              (Z
                ? ''
                : `obj || (obj = {});
`) +
              "var __t, __p = ''" +
              (m ? ', __e = _.escape' : '') +
              (E
                ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
`
                : `;
`) +
              N +
              `return __p
}`);
          var fn = Ya(function () {
            return dn(p, H + 'return ' + N).apply(u, _);
          });
          if (((fn.source = N), wo(fn))) throw fn;
          return fn;
        }
        function _1(n) {
          return _n(n).toLowerCase();
        }
        function v1(n) {
          return _n(n).toUpperCase();
        }
        function w1(n, t, i) {
          if (((n = _n(n)), n && (i || t === u))) return es(n);
          if (!n || !(t = ot(t))) return n;
          var o = At(n),
            a = At(t),
            p = rs(o, a),
            _ = is(o, a) + 1;
          return ue(o, p, _).join('');
        }
        function m1(n, t, i) {
          if (((n = _n(n)), n && (i || t === u))) return n.slice(0, os(n) + 1);
          if (!n || !(t = ot(t))) return n;
          var o = At(n),
            a = is(o, At(t)) + 1;
          return ue(o, 0, a).join('');
        }
        function y1(n, t, i) {
          if (((n = _n(n)), n && (i || t === u))) return n.replace(vu, '');
          if (!n || !(t = ot(t))) return n;
          var o = At(n),
            a = rs(o, At(t));
          return ue(o, a).join('');
        }
        function x1(n, t) {
          var i = pn,
            o = j;
          if (Rn(t)) {
            var a = 'separator' in t ? t.separator : a;
            (i = 'length' in t ? un(t.length) : i),
              (o = 'omission' in t ? ot(t.omission) : o);
          }
          n = _n(n);
          var p = n.length;
          if (Ie(n)) {
            var _ = At(n);
            p = _.length;
          }
          if (i >= p) return n;
          var m = i - Me(o);
          if (m < 1) return o;
          var E = _ ? ue(_, 0, m).join('') : n.slice(0, m);
          if (a === u) return E + o;
          if ((_ && (m += E.length - m), mo(a))) {
            if (n.slice(m).search(a)) {
              var L,
                b = E;
              for (
                a.global || (a = Ou(a.source, _n(Af.exec(a)) + 'g')),
                  a.lastIndex = 0;
                (L = a.exec(b));

              )
                var N = L.index;
              E = E.slice(0, N === u ? m : N);
            }
          } else if (n.indexOf(ot(a), m) != m) {
            var D = E.lastIndexOf(a);
            D > -1 && (E = E.slice(0, D));
          }
          return E + o;
        }
        function S1(n) {
          return (n = _n(n)), n && Nc.test(n) ? n.replace(xf, Qh) : n;
        }
        var E1 = Fe(function (n, t, i) {
            return n + (i ? ' ' : '') + t.toUpperCase();
          }),
          So = Ks('toUpperCase');
        function Xa(n, t, i) {
          return (
            (n = _n(n)),
            (t = i ? u : t),
            t === u ? (Xh(n) ? n0(n) : Dh(n)) : n.match(t) || []
          );
        }
        var Ya = sn(function (n, t) {
            try {
              return it(n, u, t);
            } catch (i) {
              return wo(i) ? i : new tn(i);
            }
          }),
          A1 = Gt(function (n, t) {
            return (
              pt(t, function (i) {
                (i = Pt(i)), kt(n, i, _o(n[i], n));
              }),
              n
            );
          });
        function C1(n) {
          var t = n == null ? 0 : n.length,
            i = K();
          return (
            (n = t
              ? Cn(n, function (o) {
                  if (typeof o[1] != 'function') throw new gt(c);
                  return [i(o[0]), o[1]];
                })
              : []),
            sn(function (o) {
              for (var a = -1; ++a < t; ) {
                var p = n[a];
                if (it(p[0], this, o)) return it(p[1], this, o);
              }
            })
          );
        }
        function R1(n) {
          return Q0(_t(n, y));
        }
        function Eo(n) {
          return function () {
            return n;
          };
        }
        function T1(n, t) {
          return n == null || n !== n ? t : n;
        }
        var I1 = Js(),
          M1 = Js(!0);
        function nt(n) {
          return n;
        }
        function Ao(n) {
          return Rs(typeof n == 'function' ? n : _t(n, y));
        }
        function L1(n) {
          return Is(_t(n, y));
        }
        function b1(n, t) {
          return Ms(n, _t(t, y));
        }
        var P1 = sn(function (n, t) {
            return function (i) {
              return sr(i, n, t);
            };
          }),
          N1 = sn(function (n, t) {
            return function (i) {
              return sr(n, i, t);
            };
          });
        function Co(n, t, i) {
          var o = Bn(t),
            a = ui(t, o);
          i == null &&
            !(Rn(t) && (a.length || !o.length)) &&
            ((i = t), (t = n), (n = this), (a = ui(t, Bn(t))));
          var p = !(Rn(i) && 'chain' in i) || !!i.chain,
            _ = Ht(n);
          return (
            pt(a, function (m) {
              var E = t[m];
              (n[m] = E),
                _ &&
                  (n.prototype[m] = function () {
                    var L = this.__chain__;
                    if (p || L) {
                      var b = n(this.__wrapped__),
                        N = (b.__actions__ = Qn(this.__actions__));
                      return (
                        N.push({ func: E, args: arguments, thisArg: n }),
                        (b.__chain__ = L),
                        b
                      );
                    }
                    return E.apply(n, jt([this.value()], arguments));
                  });
            }),
            n
          );
        }
        function O1() {
          return Wn._ === this && (Wn._ = o0), this;
        }
        function Ro() {}
        function $1(n) {
          return (
            (n = un(n)),
            sn(function (t) {
              return Ls(t, n);
            })
          );
        }
        var F1 = eo(Cn),
          D1 = eo(Qf),
          z1 = eo(Tu);
        function Ka(n) {
          return ao(n) ? Iu(Pt(n)) : gp(n);
        }
        function B1(n) {
          return function (t) {
            return n == null ? u : pe(n, t);
          };
        }
        var W1 = Vs(),
          k1 = Vs(!0);
        function To() {
          return [];
        }
        function Io() {
          return !1;
        }
        function U1() {
          return {};
        }
        function G1() {
          return '';
        }
        function q1() {
          return !0;
        }
        function H1(n, t) {
          if (((n = un(n)), n < 1 || n > G)) return [];
          var i = Q,
            o = Gn(n, Q);
          (t = K(t)), (n -= Q);
          for (var a = bu(o, t); ++i < n; ) t(i);
          return a;
        }
        function X1(n) {
          return en(n) ? Cn(n, Pt) : ft(n) ? [n] : Qn(ga(_n(n)));
        }
        function Y1(n) {
          var t = ++i0;
          return _n(n) + t;
        }
        var K1 = ci(function (n, t) {
            return n + t;
          }, 0),
          Z1 = ro('ceil'),
          J1 = ci(function (n, t) {
            return n / t;
          }, 1),
          Q1 = ro('floor');
        function V1(n) {
          return n && n.length ? ii(n, nt, Uu) : u;
        }
        function j1(n, t) {
          return n && n.length ? ii(n, K(t, 2), Uu) : u;
        }
        function nv(n) {
          return ns(n, nt);
        }
        function tv(n, t) {
          return ns(n, K(t, 2));
        }
        function ev(n) {
          return n && n.length ? ii(n, nt, Xu) : u;
        }
        function rv(n, t) {
          return n && n.length ? ii(n, K(t, 2), Xu) : u;
        }
        var iv = ci(function (n, t) {
            return n * t;
          }, 1),
          uv = ro('round'),
          ov = ci(function (n, t) {
            return n - t;
          }, 0);
        function fv(n) {
          return n && n.length ? Lu(n, nt) : 0;
        }
        function sv(n, t) {
          return n && n.length ? Lu(n, K(t, 2)) : 0;
        }
        return (
          (l.after = Ld),
          (l.ary = Ca),
          (l.assign = v_),
          (l.assignIn = Ba),
          (l.assignInWith = Ai),
          (l.assignWith = w_),
          (l.at = m_),
          (l.before = Ra),
          (l.bind = _o),
          (l.bindAll = A1),
          (l.bindKey = Ta),
          (l.castArray = Ud),
          (l.chain = Sa),
          (l.chunk = Qp),
          (l.compact = Vp),
          (l.concat = jp),
          (l.cond = C1),
          (l.conforms = R1),
          (l.constant = Eo),
          (l.countBy = fd),
          (l.create = y_),
          (l.curry = Ia),
          (l.curryRight = Ma),
          (l.debounce = La),
          (l.defaults = x_),
          (l.defaultsDeep = S_),
          (l.defer = bd),
          (l.delay = Pd),
          (l.difference = ng),
          (l.differenceBy = tg),
          (l.differenceWith = eg),
          (l.drop = rg),
          (l.dropRight = ig),
          (l.dropRightWhile = ug),
          (l.dropWhile = og),
          (l.fill = fg),
          (l.filter = ad),
          (l.flatMap = hd),
          (l.flatMapDeep = pd),
          (l.flatMapDepth = gd),
          (l.flatten = wa),
          (l.flattenDeep = sg),
          (l.flattenDepth = ag),
          (l.flip = Nd),
          (l.flow = I1),
          (l.flowRight = M1),
          (l.fromPairs = lg),
          (l.functions = M_),
          (l.functionsIn = L_),
          (l.groupBy = dd),
          (l.initial = hg),
          (l.intersection = pg),
          (l.intersectionBy = gg),
          (l.intersectionWith = dg),
          (l.invert = P_),
          (l.invertBy = N_),
          (l.invokeMap = vd),
          (l.iteratee = Ao),
          (l.keyBy = wd),
          (l.keys = Bn),
          (l.keysIn = jn),
          (l.map = wi),
          (l.mapKeys = $_),
          (l.mapValues = F_),
          (l.matches = L1),
          (l.matchesProperty = b1),
          (l.memoize = yi),
          (l.merge = D_),
          (l.mergeWith = Wa),
          (l.method = P1),
          (l.methodOf = N1),
          (l.mixin = Co),
          (l.negate = xi),
          (l.nthArg = $1),
          (l.omit = z_),
          (l.omitBy = B_),
          (l.once = Od),
          (l.orderBy = md),
          (l.over = F1),
          (l.overArgs = $d),
          (l.overEvery = D1),
          (l.overSome = z1),
          (l.partial = vo),
          (l.partialRight = ba),
          (l.partition = yd),
          (l.pick = W_),
          (l.pickBy = ka),
          (l.property = Ka),
          (l.propertyOf = B1),
          (l.pull = mg),
          (l.pullAll = ya),
          (l.pullAllBy = yg),
          (l.pullAllWith = xg),
          (l.pullAt = Sg),
          (l.range = W1),
          (l.rangeRight = k1),
          (l.rearg = Fd),
          (l.reject = Ed),
          (l.remove = Eg),
          (l.rest = Dd),
          (l.reverse = po),
          (l.sampleSize = Cd),
          (l.set = U_),
          (l.setWith = G_),
          (l.shuffle = Rd),
          (l.slice = Ag),
          (l.sortBy = Md),
          (l.sortedUniq = bg),
          (l.sortedUniqBy = Pg),
          (l.split = h1),
          (l.spread = zd),
          (l.tail = Ng),
          (l.take = Og),
          (l.takeRight = $g),
          (l.takeRightWhile = Fg),
          (l.takeWhile = Dg),
          (l.tap = Vg),
          (l.throttle = Bd),
          (l.thru = vi),
          (l.toArray = Fa),
          (l.toPairs = Ua),
          (l.toPairsIn = Ga),
          (l.toPath = X1),
          (l.toPlainObject = za),
          (l.transform = q_),
          (l.unary = Wd),
          (l.union = zg),
          (l.unionBy = Bg),
          (l.unionWith = Wg),
          (l.uniq = kg),
          (l.uniqBy = Ug),
          (l.uniqWith = Gg),
          (l.unset = H_),
          (l.unzip = go),
          (l.unzipWith = xa),
          (l.update = X_),
          (l.updateWith = Y_),
          (l.values = Be),
          (l.valuesIn = K_),
          (l.without = qg),
          (l.words = Xa),
          (l.wrap = kd),
          (l.xor = Hg),
          (l.xorBy = Xg),
          (l.xorWith = Yg),
          (l.zip = Kg),
          (l.zipObject = Zg),
          (l.zipObjectDeep = Jg),
          (l.zipWith = Qg),
          (l.entries = Ua),
          (l.entriesIn = Ga),
          (l.extend = Ba),
          (l.extendWith = Ai),
          Co(l, l),
          (l.add = K1),
          (l.attempt = Ya),
          (l.camelCase = V_),
          (l.capitalize = qa),
          (l.ceil = Z1),
          (l.clamp = Z_),
          (l.clone = Gd),
          (l.cloneDeep = Hd),
          (l.cloneDeepWith = Xd),
          (l.cloneWith = qd),
          (l.conformsTo = Yd),
          (l.deburr = Ha),
          (l.defaultTo = T1),
          (l.divide = J1),
          (l.endsWith = j_),
          (l.eq = Rt),
          (l.escape = n1),
          (l.escapeRegExp = t1),
          (l.every = sd),
          (l.find = ld),
          (l.findIndex = _a),
          (l.findKey = E_),
          (l.findLast = cd),
          (l.findLastIndex = va),
          (l.findLastKey = A_),
          (l.floor = Q1),
          (l.forEach = Ea),
          (l.forEachRight = Aa),
          (l.forIn = C_),
          (l.forInRight = R_),
          (l.forOwn = T_),
          (l.forOwnRight = I_),
          (l.get = yo),
          (l.gt = Kd),
          (l.gte = Zd),
          (l.has = b_),
          (l.hasIn = xo),
          (l.head = ma),
          (l.identity = nt),
          (l.includes = _d),
          (l.indexOf = cg),
          (l.inRange = J_),
          (l.invoke = O_),
          (l.isArguments = _e),
          (l.isArray = en),
          (l.isArrayBuffer = Jd),
          (l.isArrayLike = Vn),
          (l.isArrayLikeObject = bn),
          (l.isBoolean = Qd),
          (l.isBuffer = oe),
          (l.isDate = Vd),
          (l.isElement = jd),
          (l.isEmpty = n_),
          (l.isEqual = t_),
          (l.isEqualWith = e_),
          (l.isError = wo),
          (l.isFinite = r_),
          (l.isFunction = Ht),
          (l.isInteger = Pa),
          (l.isLength = Si),
          (l.isMap = Na),
          (l.isMatch = i_),
          (l.isMatchWith = u_),
          (l.isNaN = o_),
          (l.isNative = f_),
          (l.isNil = a_),
          (l.isNull = s_),
          (l.isNumber = Oa),
          (l.isObject = Rn),
          (l.isObjectLike = Mn),
          (l.isPlainObject = gr),
          (l.isRegExp = mo),
          (l.isSafeInteger = l_),
          (l.isSet = $a),
          (l.isString = Ei),
          (l.isSymbol = ft),
          (l.isTypedArray = ze),
          (l.isUndefined = c_),
          (l.isWeakMap = h_),
          (l.isWeakSet = p_),
          (l.join = _g),
          (l.kebabCase = e1),
          (l.last = wt),
          (l.lastIndexOf = vg),
          (l.lowerCase = r1),
          (l.lowerFirst = i1),
          (l.lt = g_),
          (l.lte = d_),
          (l.max = V1),
          (l.maxBy = j1),
          (l.mean = nv),
          (l.meanBy = tv),
          (l.min = ev),
          (l.minBy = rv),
          (l.stubArray = To),
          (l.stubFalse = Io),
          (l.stubObject = U1),
          (l.stubString = G1),
          (l.stubTrue = q1),
          (l.multiply = iv),
          (l.nth = wg),
          (l.noConflict = O1),
          (l.noop = Ro),
          (l.now = mi),
          (l.pad = u1),
          (l.padEnd = o1),
          (l.padStart = f1),
          (l.parseInt = s1),
          (l.random = Q_),
          (l.reduce = xd),
          (l.reduceRight = Sd),
          (l.repeat = a1),
          (l.replace = l1),
          (l.result = k_),
          (l.round = uv),
          (l.runInContext = S),
          (l.sample = Ad),
          (l.size = Td),
          (l.snakeCase = c1),
          (l.some = Id),
          (l.sortedIndex = Cg),
          (l.sortedIndexBy = Rg),
          (l.sortedIndexOf = Tg),
          (l.sortedLastIndex = Ig),
          (l.sortedLastIndexBy = Mg),
          (l.sortedLastIndexOf = Lg),
          (l.startCase = p1),
          (l.startsWith = g1),
          (l.subtract = ov),
          (l.sum = fv),
          (l.sumBy = sv),
          (l.template = d1),
          (l.times = H1),
          (l.toFinite = Xt),
          (l.toInteger = un),
          (l.toLength = Da),
          (l.toLower = _1),
          (l.toNumber = mt),
          (l.toSafeInteger = __),
          (l.toString = _n),
          (l.toUpper = v1),
          (l.trim = w1),
          (l.trimEnd = m1),
          (l.trimStart = y1),
          (l.truncate = x1),
          (l.unescape = S1),
          (l.uniqueId = Y1),
          (l.upperCase = E1),
          (l.upperFirst = So),
          (l.each = Ea),
          (l.eachRight = Aa),
          (l.first = ma),
          Co(
            l,
            (function () {
              var n = {};
              return (
                Lt(l, function (t, i) {
                  vn.call(l.prototype, i) || (n[i] = t);
                }),
                n
              );
            })(),
            { chain: !1 }
          ),
          (l.VERSION = f),
          pt(
            [
              'bind',
              'bindKey',
              'curry',
              'curryRight',
              'partial',
              'partialRight',
            ],
            function (n) {
              l[n].placeholder = l;
            }
          ),
          pt(['drop', 'take'], function (n, t) {
            (ln.prototype[n] = function (i) {
              i = i === u ? 1 : Dn(un(i), 0);
              var o = this.__filtered__ && !t ? new ln(this) : this.clone();
              return (
                o.__filtered__
                  ? (o.__takeCount__ = Gn(i, o.__takeCount__))
                  : o.__views__.push({
                      size: Gn(i, Q),
                      type: n + (o.__dir__ < 0 ? 'Right' : ''),
                    }),
                o
              );
            }),
              (ln.prototype[n + 'Right'] = function (i) {
                return this.reverse()[n](i).reverse();
              });
          }),
          pt(['filter', 'map', 'takeWhile'], function (n, t) {
            var i = t + 1,
              o = i == A || i == I;
            ln.prototype[n] = function (a) {
              var p = this.clone();
              return (
                p.__iteratees__.push({
                  iteratee: K(a, 3),
                  type: i,
                }),
                (p.__filtered__ = p.__filtered__ || o),
                p
              );
            };
          }),
          pt(['head', 'last'], function (n, t) {
            var i = 'take' + (t ? 'Right' : '');
            ln.prototype[n] = function () {
              return this[i](1).value()[0];
            };
          }),
          pt(['initial', 'tail'], function (n, t) {
            var i = 'drop' + (t ? '' : 'Right');
            ln.prototype[n] = function () {
              return this.__filtered__ ? new ln(this) : this[i](1);
            };
          }),
          (ln.prototype.compact = function () {
            return this.filter(nt);
          }),
          (ln.prototype.find = function (n) {
            return this.filter(n).head();
          }),
          (ln.prototype.findLast = function (n) {
            return this.reverse().find(n);
          }),
          (ln.prototype.invokeMap = sn(function (n, t) {
            return typeof n == 'function'
              ? new ln(this)
              : this.map(function (i) {
                  return sr(i, n, t);
                });
          })),
          (ln.prototype.reject = function (n) {
            return this.filter(xi(K(n)));
          }),
          (ln.prototype.slice = function (n, t) {
            n = un(n);
            var i = this;
            return i.__filtered__ && (n > 0 || t < 0)
              ? new ln(i)
              : (n < 0 ? (i = i.takeRight(-n)) : n && (i = i.drop(n)),
                t !== u &&
                  ((t = un(t)), (i = t < 0 ? i.dropRight(-t) : i.take(t - n))),
                i);
          }),
          (ln.prototype.takeRightWhile = function (n) {
            return this.reverse().takeWhile(n).reverse();
          }),
          (ln.prototype.toArray = function () {
            return this.take(Q);
          }),
          Lt(ln.prototype, function (n, t) {
            var i = /^(?:filter|find|map|reject)|While$/.test(t),
              o = /^(?:head|last)$/.test(t),
              a = l[o ? 'take' + (t == 'last' ? 'Right' : '') : t],
              p = o || /^find/.test(t);
            a &&
              (l.prototype[t] = function () {
                var _ = this.__wrapped__,
                  m = o ? [1] : arguments,
                  E = _ instanceof ln,
                  L = m[0],
                  b = E || en(_),
                  N = function (an) {
                    var cn = a.apply(l, jt([an], m));
                    return o && D ? cn[0] : cn;
                  };
                b &&
                  i &&
                  typeof L == 'function' &&
                  L.length != 1 &&
                  (E = b = !1);
                var D = this.__chain__,
                  H = !!this.__actions__.length,
                  Z = p && !D,
                  fn = E && !H;
                if (!p && b) {
                  _ = fn ? _ : new ln(this);
                  var J = n.apply(_, m);
                  return (
                    J.__actions__.push({ func: vi, args: [N], thisArg: u }),
                    new dt(J, D)
                  );
                }
                return Z && fn
                  ? n.apply(this, m)
                  : ((J = this.thru(N)),
                    Z ? (o ? J.value()[0] : J.value()) : J);
              });
          }),
          pt(
            ['pop', 'push', 'shift', 'sort', 'splice', 'unshift'],
            function (n) {
              var t = Gr[n],
                i = /^(?:push|sort|unshift)$/.test(n) ? 'tap' : 'thru',
                o = /^(?:pop|shift)$/.test(n);
              l.prototype[n] = function () {
                var a = arguments;
                if (o && !this.__chain__) {
                  var p = this.value();
                  return t.apply(en(p) ? p : [], a);
                }
                return this[i](function (_) {
                  return t.apply(en(_) ? _ : [], a);
                });
              };
            }
          ),
          Lt(ln.prototype, function (n, t) {
            var i = l[t];
            if (i) {
              var o = i.name + '';
              vn.call(Ne, o) || (Ne[o] = []), Ne[o].push({ name: t, func: i });
            }
          }),
          (Ne[li(u, O).name] = [
            {
              name: 'wrapper',
              func: u,
            },
          ]),
          (ln.prototype.clone = S0),
          (ln.prototype.reverse = E0),
          (ln.prototype.value = A0),
          (l.prototype.at = jg),
          (l.prototype.chain = nd),
          (l.prototype.commit = td),
          (l.prototype.next = ed),
          (l.prototype.plant = id),
          (l.prototype.reverse = ud),
          (l.prototype.toJSON = l.prototype.valueOf = l.prototype.value = od),
          (l.prototype.first = l.prototype.head),
          tr && (l.prototype[tr] = rd),
          l
        );
      },
      Le = t0();
    se ? (((se.exports = Le)._ = Le), (Eu._ = Le)) : (Wn._ = Le);
  }).call(dr);
})(Wi, Wi.exports);
var hv = Wi.exports,
  Fo = 'http://www.w3.org/1999/xhtml';
const Ja = {
  svg: 'http://www.w3.org/2000/svg',
  xhtml: Fo,
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace',
  xmlns: 'http://www.w3.org/2000/xmlns/',
};
function iu(e) {
  var r = (e += ''),
    u = r.indexOf(':');
  return (
    u >= 0 && (r = e.slice(0, u)) !== 'xmlns' && (e = e.slice(u + 1)),
    Ja.hasOwnProperty(r) ? { space: Ja[r], local: e } : e
  );
}
function pv(e) {
  return function () {
    var r = this.ownerDocument,
      u = this.namespaceURI;
    return u === Fo && r.documentElement.namespaceURI === Fo
      ? r.createElement(e)
      : r.createElementNS(u, e);
  };
}
function gv(e) {
  return function () {
    return this.ownerDocument.createElementNS(e.space, e.local);
  };
}
function Nl(e) {
  var r = iu(e);
  return (r.local ? gv : pv)(r);
}
function dv() {}
function ff(e) {
  return e == null
    ? dv
    : function () {
        return this.querySelector(e);
      };
}
function _v(e) {
  typeof e != 'function' && (e = ff(e));
  for (var r = this._groups, u = r.length, f = new Array(u), s = 0; s < u; ++s)
    for (
      var h = r[s], c = h.length, g = (f[s] = new Array(c)), v, w, d = 0;
      d < c;
      ++d
    )
      (v = h[d]) &&
        (w = e.call(v, v.__data__, d, h)) &&
        ('__data__' in v && (w.__data__ = v.__data__), (g[d] = w));
  return new Zn(f, this._parents);
}
function Ol(e) {
  return e == null ? [] : Array.isArray(e) ? e : Array.from(e);
}
function vv() {
  return [];
}
function $l(e) {
  return e == null
    ? vv
    : function () {
        return this.querySelectorAll(e);
      };
}
function wv(e) {
  return function () {
    return Ol(e.apply(this, arguments));
  };
}
function mv(e) {
  typeof e == 'function' ? (e = wv(e)) : (e = $l(e));
  for (var r = this._groups, u = r.length, f = [], s = [], h = 0; h < u; ++h)
    for (var c = r[h], g = c.length, v, w = 0; w < g; ++w)
      (v = c[w]) && (f.push(e.call(v, v.__data__, w, c)), s.push(v));
  return new Zn(f, s);
}
function Fl(e) {
  return function () {
    return this.matches(e);
  };
}
function Dl(e) {
  return function (r) {
    return r.matches(e);
  };
}
var yv = Array.prototype.find;
function xv(e) {
  return function () {
    return yv.call(this.children, e);
  };
}
function Sv() {
  return this.firstElementChild;
}
function Ev(e) {
  return this.select(e == null ? Sv : xv(typeof e == 'function' ? e : Dl(e)));
}
var Av = Array.prototype.filter;
function Cv() {
  return Array.from(this.children);
}
function Rv(e) {
  return function () {
    return Av.call(this.children, e);
  };
}
function Tv(e) {
  return this.selectAll(
    e == null ? Cv : Rv(typeof e == 'function' ? e : Dl(e))
  );
}
function Iv(e) {
  typeof e != 'function' && (e = Fl(e));
  for (var r = this._groups, u = r.length, f = new Array(u), s = 0; s < u; ++s)
    for (var h = r[s], c = h.length, g = (f[s] = []), v, w = 0; w < c; ++w)
      (v = h[w]) && e.call(v, v.__data__, w, h) && g.push(v);
  return new Zn(f, this._parents);
}
function zl(e) {
  return new Array(e.length);
}
function Mv() {
  return new Zn(this._enter || this._groups.map(zl), this._parents);
}
function ki(e, r) {
  (this.ownerDocument = e.ownerDocument),
    (this.namespaceURI = e.namespaceURI),
    (this._next = null),
    (this._parent = e),
    (this.__data__ = r);
}
ki.prototype = {
  constructor: ki,
  appendChild: function (e) {
    return this._parent.insertBefore(e, this._next);
  },
  insertBefore: function (e, r) {
    return this._parent.insertBefore(e, r);
  },
  querySelector: function (e) {
    return this._parent.querySelector(e);
  },
  querySelectorAll: function (e) {
    return this._parent.querySelectorAll(e);
  },
};
function Lv(e) {
  return function () {
    return e;
  };
}
function bv(e, r, u, f, s, h) {
  for (var c = 0, g, v = r.length, w = h.length; c < w; ++c)
    (g = r[c]) ? ((g.__data__ = h[c]), (f[c] = g)) : (u[c] = new ki(e, h[c]));
  for (; c < v; ++c) (g = r[c]) && (s[c] = g);
}
function Pv(e, r, u, f, s, h, c) {
  var g,
    v,
    w = /* @__PURE__ */ new Map(),
    d = r.length,
    y = h.length,
    x = new Array(d),
    C;
  for (g = 0; g < d; ++g)
    (v = r[g]) &&
      ((x[g] = C = c.call(v, v.__data__, g, r) + ''),
      w.has(C) ? (s[g] = v) : w.set(C, v));
  for (g = 0; g < y; ++g)
    (C = c.call(e, h[g], g, h) + ''),
      (v = w.get(C))
        ? ((f[g] = v), (v.__data__ = h[g]), w.delete(C))
        : (u[g] = new ki(e, h[g]));
  for (g = 0; g < d; ++g) (v = r[g]) && w.get(x[g]) === v && (s[g] = v);
}
function Nv(e) {
  return e.__data__;
}
function Ov(e, r) {
  if (!arguments.length) return Array.from(this, Nv);
  var u = r ? Pv : bv,
    f = this._parents,
    s = this._groups;
  typeof e != 'function' && (e = Lv(e));
  for (
    var h = s.length,
      c = new Array(h),
      g = new Array(h),
      v = new Array(h),
      w = 0;
    w < h;
    ++w
  ) {
    var d = f[w],
      y = s[w],
      x = y.length,
      C = $v(e.call(d, d && d.__data__, w, f)),
      P = C.length,
      z = (g[w] = new Array(P)),
      $ = (c[w] = new Array(P)),
      O = (v[w] = new Array(x));
    u(d, y, z, $, O, C, r);
    for (var U = 0, k = 0, B, q; U < P; ++U)
      if ((B = z[U])) {
        for (U >= k && (k = U + 1); !(q = $[k]) && ++k < P; );
        B._next = q || null;
      }
  }
  return (c = new Zn(c, f)), (c._enter = g), (c._exit = v), c;
}
function $v(e) {
  return typeof e == 'object' && 'length' in e ? e : Array.from(e);
}
function Fv() {
  return new Zn(this._exit || this._groups.map(zl), this._parents);
}
function Dv(e, r, u) {
  var f = this.enter(),
    s = this,
    h = this.exit();
  return (
    typeof e == 'function'
      ? ((f = e(f)), f && (f = f.selection()))
      : (f = f.append(e + '')),
    r != null && ((s = r(s)), s && (s = s.selection())),
    u == null ? h.remove() : u(h),
    f && s ? f.merge(s).order() : s
  );
}
function zv(e) {
  for (
    var r = e.selection ? e.selection() : e,
      u = this._groups,
      f = r._groups,
      s = u.length,
      h = f.length,
      c = Math.min(s, h),
      g = new Array(s),
      v = 0;
    v < c;
    ++v
  )
    for (
      var w = u[v], d = f[v], y = w.length, x = (g[v] = new Array(y)), C, P = 0;
      P < y;
      ++P
    )
      (C = w[P] || d[P]) && (x[P] = C);
  for (; v < s; ++v) g[v] = u[v];
  return new Zn(g, this._parents);
}
function Bv() {
  for (var e = this._groups, r = -1, u = e.length; ++r < u; )
    for (var f = e[r], s = f.length - 1, h = f[s], c; --s >= 0; )
      (c = f[s]) &&
        (h &&
          c.compareDocumentPosition(h) ^ 4 &&
          h.parentNode.insertBefore(c, h),
        (h = c));
  return this;
}
function Wv(e) {
  e || (e = kv);
  function r(y, x) {
    return y && x ? e(y.__data__, x.__data__) : !y - !x;
  }
  for (
    var u = this._groups, f = u.length, s = new Array(f), h = 0;
    h < f;
    ++h
  ) {
    for (
      var c = u[h], g = c.length, v = (s[h] = new Array(g)), w, d = 0;
      d < g;
      ++d
    )
      (w = c[d]) && (v[d] = w);
    v.sort(r);
  }
  return new Zn(s, this._parents).order();
}
function kv(e, r) {
  return e < r ? -1 : e > r ? 1 : e >= r ? 0 : NaN;
}
function Uv() {
  var e = arguments[0];
  return (arguments[0] = this), e.apply(null, arguments), this;
}
function Gv() {
  return Array.from(this);
}
function qv() {
  for (var e = this._groups, r = 0, u = e.length; r < u; ++r)
    for (var f = e[r], s = 0, h = f.length; s < h; ++s) {
      var c = f[s];
      if (c) return c;
    }
  return null;
}
function Hv() {
  let e = 0;
  for (const r of this) ++e;
  return e;
}
function Xv() {
  return !this.node();
}
function Yv(e) {
  for (var r = this._groups, u = 0, f = r.length; u < f; ++u)
    for (var s = r[u], h = 0, c = s.length, g; h < c; ++h)
      (g = s[h]) && e.call(g, g.__data__, h, s);
  return this;
}
function Kv(e) {
  return function () {
    this.removeAttribute(e);
  };
}
function Zv(e) {
  return function () {
    this.removeAttributeNS(e.space, e.local);
  };
}
function Jv(e, r) {
  return function () {
    this.setAttribute(e, r);
  };
}
function Qv(e, r) {
  return function () {
    this.setAttributeNS(e.space, e.local, r);
  };
}
function Vv(e, r) {
  return function () {
    var u = r.apply(this, arguments);
    u == null ? this.removeAttribute(e) : this.setAttribute(e, u);
  };
}
function jv(e, r) {
  return function () {
    var u = r.apply(this, arguments);
    u == null
      ? this.removeAttributeNS(e.space, e.local)
      : this.setAttributeNS(e.space, e.local, u);
  };
}
function nw(e, r) {
  var u = iu(e);
  if (arguments.length < 2) {
    var f = this.node();
    return u.local ? f.getAttributeNS(u.space, u.local) : f.getAttribute(u);
  }
  return this.each(
    (r == null
      ? u.local
        ? Zv
        : Kv
      : typeof r == 'function'
      ? u.local
        ? jv
        : Vv
      : u.local
      ? Qv
      : Jv)(u, r)
  );
}
function Bl(e) {
  return (
    (e.ownerDocument && e.ownerDocument.defaultView) ||
    (e.document && e) ||
    e.defaultView
  );
}
function tw(e) {
  return function () {
    this.style.removeProperty(e);
  };
}
function ew(e, r, u) {
  return function () {
    this.style.setProperty(e, r, u);
  };
}
function rw(e, r, u) {
  return function () {
    var f = r.apply(this, arguments);
    f == null ? this.style.removeProperty(e) : this.style.setProperty(e, f, u);
  };
}
function iw(e, r, u) {
  return arguments.length > 1
    ? this.each(
        (r == null ? tw : typeof r == 'function' ? rw : ew)(e, r, u ?? '')
      )
    : qe(this.node(), e);
}
function qe(e, r) {
  return (
    e.style.getPropertyValue(r) ||
    Bl(e).getComputedStyle(e, null).getPropertyValue(r)
  );
}
function uw(e) {
  return function () {
    delete this[e];
  };
}
function ow(e, r) {
  return function () {
    this[e] = r;
  };
}
function fw(e, r) {
  return function () {
    var u = r.apply(this, arguments);
    u == null ? delete this[e] : (this[e] = u);
  };
}
function sw(e, r) {
  return arguments.length > 1
    ? this.each((r == null ? uw : typeof r == 'function' ? fw : ow)(e, r))
    : this.node()[e];
}
function Wl(e) {
  return e.trim().split(/^|\s+/);
}
function sf(e) {
  return e.classList || new kl(e);
}
function kl(e) {
  (this._node = e), (this._names = Wl(e.getAttribute('class') || ''));
}
kl.prototype = {
  add: function (e) {
    var r = this._names.indexOf(e);
    r < 0 &&
      (this._names.push(e),
      this._node.setAttribute('class', this._names.join(' ')));
  },
  remove: function (e) {
    var r = this._names.indexOf(e);
    r >= 0 &&
      (this._names.splice(r, 1),
      this._node.setAttribute('class', this._names.join(' ')));
  },
  contains: function (e) {
    return this._names.indexOf(e) >= 0;
  },
};
function Ul(e, r) {
  for (var u = sf(e), f = -1, s = r.length; ++f < s; ) u.add(r[f]);
}
function Gl(e, r) {
  for (var u = sf(e), f = -1, s = r.length; ++f < s; ) u.remove(r[f]);
}
function aw(e) {
  return function () {
    Ul(this, e);
  };
}
function lw(e) {
  return function () {
    Gl(this, e);
  };
}
function cw(e, r) {
  return function () {
    (r.apply(this, arguments) ? Ul : Gl)(this, e);
  };
}
function hw(e, r) {
  var u = Wl(e + '');
  if (arguments.length < 2) {
    for (var f = sf(this.node()), s = -1, h = u.length; ++s < h; )
      if (!f.contains(u[s])) return !1;
    return !0;
  }
  return this.each((typeof r == 'function' ? cw : r ? aw : lw)(u, r));
}
function pw() {
  this.textContent = '';
}
function gw(e) {
  return function () {
    this.textContent = e;
  };
}
function dw(e) {
  return function () {
    var r = e.apply(this, arguments);
    this.textContent = r ?? '';
  };
}
function _w(e) {
  return arguments.length
    ? this.each(e == null ? pw : (typeof e == 'function' ? dw : gw)(e))
    : this.node().textContent;
}
function vw() {
  this.innerHTML = '';
}
function ww(e) {
  return function () {
    this.innerHTML = e;
  };
}
function mw(e) {
  return function () {
    var r = e.apply(this, arguments);
    this.innerHTML = r ?? '';
  };
}
function yw(e) {
  return arguments.length
    ? this.each(e == null ? vw : (typeof e == 'function' ? mw : ww)(e))
    : this.node().innerHTML;
}
function xw() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function Sw() {
  return this.each(xw);
}
function Ew() {
  this.previousSibling &&
    this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function Aw() {
  return this.each(Ew);
}
function Cw(e) {
  var r = typeof e == 'function' ? e : Nl(e);
  return this.select(function () {
    return this.appendChild(r.apply(this, arguments));
  });
}
function Rw() {
  return null;
}
function Tw(e, r) {
  var u = typeof e == 'function' ? e : Nl(e),
    f = r == null ? Rw : typeof r == 'function' ? r : ff(r);
  return this.select(function () {
    return this.insertBefore(
      u.apply(this, arguments),
      f.apply(this, arguments) || null
    );
  });
}
function Iw() {
  var e = this.parentNode;
  e && e.removeChild(this);
}
function Mw() {
  return this.each(Iw);
}
function Lw() {
  var e = this.cloneNode(!1),
    r = this.parentNode;
  return r ? r.insertBefore(e, this.nextSibling) : e;
}
function bw() {
  var e = this.cloneNode(!0),
    r = this.parentNode;
  return r ? r.insertBefore(e, this.nextSibling) : e;
}
function Pw(e) {
  return this.select(e ? bw : Lw);
}
function Nw(e) {
  return arguments.length ? this.property('__data__', e) : this.node().__data__;
}
function Ow(e) {
  return function (r) {
    e.call(this, r, this.__data__);
  };
}
function $w(e) {
  return e
    .trim()
    .split(/^|\s+/)
    .map(function (r) {
      var u = '',
        f = r.indexOf('.');
      return (
        f >= 0 && ((u = r.slice(f + 1)), (r = r.slice(0, f))),
        { type: r, name: u }
      );
    });
}
function Fw(e) {
  return function () {
    var r = this.__on;
    if (r) {
      for (var u = 0, f = -1, s = r.length, h; u < s; ++u)
        (h = r[u]),
          (!e.type || h.type === e.type) && h.name === e.name
            ? this.removeEventListener(h.type, h.listener, h.options)
            : (r[++f] = h);
      ++f ? (r.length = f) : delete this.__on;
    }
  };
}
function Dw(e, r, u) {
  return function () {
    var f = this.__on,
      s,
      h = Ow(r);
    if (f) {
      for (var c = 0, g = f.length; c < g; ++c)
        if ((s = f[c]).type === e.type && s.name === e.name) {
          this.removeEventListener(s.type, s.listener, s.options),
            this.addEventListener(s.type, (s.listener = h), (s.options = u)),
            (s.value = r);
          return;
        }
    }
    this.addEventListener(e.type, h, u),
      (s = { type: e.type, name: e.name, value: r, listener: h, options: u }),
      f ? f.push(s) : (this.__on = [s]);
  };
}
function zw(e, r, u) {
  var f = $w(e + ''),
    s,
    h = f.length,
    c;
  if (arguments.length < 2) {
    var g = this.node().__on;
    if (g) {
      for (var v = 0, w = g.length, d; v < w; ++v)
        for (s = 0, d = g[v]; s < h; ++s)
          if ((c = f[s]).type === d.type && c.name === d.name) return d.value;
    }
    return;
  }
  for (g = r ? Dw : Fw, s = 0; s < h; ++s) this.each(g(f[s], r, u));
  return this;
}
function ql(e, r, u) {
  var f = Bl(e),
    s = f.CustomEvent;
  typeof s == 'function'
    ? (s = new s(r, u))
    : ((s = f.document.createEvent('Event')),
      u
        ? (s.initEvent(r, u.bubbles, u.cancelable), (s.detail = u.detail))
        : s.initEvent(r, !1, !1)),
    e.dispatchEvent(s);
}
function Bw(e, r) {
  return function () {
    return ql(this, e, r);
  };
}
function Ww(e, r) {
  return function () {
    return ql(this, e, r.apply(this, arguments));
  };
}
function kw(e, r) {
  return this.each((typeof r == 'function' ? Ww : Bw)(e, r));
}
function* Uw() {
  for (var e = this._groups, r = 0, u = e.length; r < u; ++r)
    for (var f = e[r], s = 0, h = f.length, c; s < h; ++s)
      (c = f[s]) && (yield c);
}
var af = [null];
function Zn(e, r) {
  (this._groups = e), (this._parents = r);
}
function Ke() {
  return new Zn([[document.documentElement]], af);
}
function Gw() {
  return this;
}
Zn.prototype = Ke.prototype = {
  constructor: Zn,
  select: _v,
  selectAll: mv,
  selectChild: Ev,
  selectChildren: Tv,
  filter: Iv,
  data: Ov,
  enter: Mv,
  exit: Fv,
  join: Dv,
  merge: zv,
  selection: Gw,
  order: Bv,
  sort: Wv,
  call: Uv,
  nodes: Gv,
  node: qv,
  size: Hv,
  empty: Xv,
  each: Yv,
  attr: nw,
  style: iw,
  property: sw,
  classed: hw,
  text: _w,
  html: yw,
  raise: Sw,
  lower: Aw,
  append: Cw,
  insert: Tw,
  remove: Mw,
  clone: Pw,
  datum: Nw,
  on: zw,
  dispatch: kw,
  [Symbol.iterator]: Uw,
};
function Un(e) {
  return typeof e == 'string'
    ? new Zn([[document.querySelector(e)]], [document.documentElement])
    : new Zn([[e]], af);
}
function qw(e) {
  let r;
  for (; (r = e.sourceEvent); ) e = r;
  return e;
}
function ve(e, r) {
  if (((e = qw(e)), r === void 0 && (r = e.currentTarget), r)) {
    var u = r.ownerSVGElement || r;
    if (u.createSVGPoint) {
      var f = u.createSVGPoint();
      return (
        (f.x = e.clientX),
        (f.y = e.clientY),
        (f = f.matrixTransform(r.getScreenCTM().inverse())),
        [f.x, f.y]
      );
    }
    if (r.getBoundingClientRect) {
      var s = r.getBoundingClientRect();
      return [
        e.clientX - s.left - r.clientLeft,
        e.clientY - s.top - r.clientTop,
      ];
    }
  }
  return [e.pageX, e.pageY];
}
function we(e) {
  return typeof e == 'string'
    ? new Zn([document.querySelectorAll(e)], [document.documentElement])
    : new Zn([Ol(e)], af);
}
class xe {
  constructor() {
    (this._partials = new Float64Array(32)), (this._n = 0);
  }
  add(r) {
    const u = this._partials;
    let f = 0;
    for (let s = 0; s < this._n && s < 32; s++) {
      const h = u[s],
        c = r + h,
        g = Math.abs(r) < Math.abs(h) ? r - (c - h) : h - (c - r);
      g && (u[f++] = g), (r = c);
    }
    return (u[f] = r), (this._n = f + 1), this;
  }
  valueOf() {
    const r = this._partials;
    let u = this._n,
      f,
      s,
      h,
      c = 0;
    if (u > 0) {
      for (
        c = r[--u];
        u > 0 && ((f = c), (s = r[--u]), (c = f + s), (h = s - (c - f)), !h);

      );
      u > 0 &&
        ((h < 0 && r[u - 1] < 0) || (h > 0 && r[u - 1] > 0)) &&
        ((s = h * 2), (f = c + s), s == f - c && (c = f));
    }
    return c;
  }
}
function* Hw(e) {
  for (const r of e) yield* r;
}
function Hl(e) {
  return Array.from(Hw(e));
}
var yn = 1e-6,
  Xw = 1e-12,
  hn = Math.PI,
  tt = hn / 2,
  Qa = hn / 4,
  ct = hn * 2,
  lt = 180 / hn,
  $n = hn / 180,
  Tn = Math.abs,
  Xl = Math.atan,
  Cr = Math.atan2,
  Nn = Math.cos,
  Yw = Math.exp,
  Kw = Math.log,
  On = Math.sin,
  Zw =
    Math.sign ||
    function (e) {
      return e > 0 ? 1 : e < 0 ? -1 : 0;
    },
  Ae = Math.sqrt,
  Jw = Math.tan;
function Qw(e) {
  return e > 1 ? 0 : e < -1 ? hn : Math.acos(e);
}
function Rr(e) {
  return e > 1 ? tt : e < -1 ? -tt : Math.asin(e);
}
function xt() {}
function Ui(e, r) {
  e && ja.hasOwnProperty(e.type) && ja[e.type](e, r);
}
var Va = {
    Feature: function (e, r) {
      Ui(e.geometry, r);
    },
    FeatureCollection: function (e, r) {
      for (var u = e.features, f = -1, s = u.length; ++f < s; )
        Ui(u[f].geometry, r);
    },
  },
  ja = {
    Sphere: function (e, r) {
      r.sphere();
    },
    Point: function (e, r) {
      (e = e.coordinates), r.point(e[0], e[1], e[2]);
    },
    MultiPoint: function (e, r) {
      for (var u = e.coordinates, f = -1, s = u.length; ++f < s; )
        (e = u[f]), r.point(e[0], e[1], e[2]);
    },
    LineString: function (e, r) {
      Do(e.coordinates, r, 0);
    },
    MultiLineString: function (e, r) {
      for (var u = e.coordinates, f = -1, s = u.length; ++f < s; )
        Do(u[f], r, 0);
    },
    Polygon: function (e, r) {
      nl(e.coordinates, r);
    },
    MultiPolygon: function (e, r) {
      for (var u = e.coordinates, f = -1, s = u.length; ++f < s; ) nl(u[f], r);
    },
    GeometryCollection: function (e, r) {
      for (var u = e.geometries, f = -1, s = u.length; ++f < s; ) Ui(u[f], r);
    },
  };
function Do(e, r, u) {
  var f = -1,
    s = e.length - u,
    h;
  for (r.lineStart(); ++f < s; ) (h = e[f]), r.point(h[0], h[1], h[2]);
  r.lineEnd();
}
function nl(e, r) {
  var u = -1,
    f = e.length;
  for (r.polygonStart(); ++u < f; ) Do(e[u], r, 1);
  r.polygonEnd();
}
function We(e, r) {
  e && Va.hasOwnProperty(e.type) ? Va[e.type](e, r) : Ui(e, r);
}
function zo(e) {
  return [Cr(e[1], e[0]), Rr(e[2])];
}
function He(e) {
  var r = e[0],
    u = e[1],
    f = Nn(u);
  return [f * Nn(r), f * On(r), On(u)];
}
function Ti(e, r) {
  return e[0] * r[0] + e[1] * r[1] + e[2] * r[2];
}
function Gi(e, r) {
  return [
    e[1] * r[2] - e[2] * r[1],
    e[2] * r[0] - e[0] * r[2],
    e[0] * r[1] - e[1] * r[0],
  ];
}
function Mo(e, r) {
  (e[0] += r[0]), (e[1] += r[1]), (e[2] += r[2]);
}
function Ii(e, r) {
  return [e[0] * r, e[1] * r, e[2] * r];
}
function Bo(e) {
  var r = Ae(e[0] * e[0] + e[1] * e[1] + e[2] * e[2]);
  (e[0] /= r), (e[1] /= r), (e[2] /= r);
}
function Wo(e, r) {
  function u(f, s) {
    return (f = e(f, s)), r(f[0], f[1]);
  }
  return (
    e.invert &&
      r.invert &&
      (u.invert = function (f, s) {
        return (f = r.invert(f, s)), f && e.invert(f[0], f[1]);
      }),
    u
  );
}
function ko(e, r) {
  return Tn(e) > hn && (e -= Math.round(e / ct) * ct), [e, r];
}
ko.invert = ko;
function Yl(e, r, u) {
  return (e %= ct)
    ? r || u
      ? Wo(el(e), rl(r, u))
      : el(e)
    : r || u
    ? rl(r, u)
    : ko;
}
function tl(e) {
  return function (r, u) {
    return (r += e), Tn(r) > hn && (r -= Math.round(r / ct) * ct), [r, u];
  };
}
function el(e) {
  var r = tl(e);
  return (r.invert = tl(-e)), r;
}
function rl(e, r) {
  var u = Nn(e),
    f = On(e),
    s = Nn(r),
    h = On(r);
  function c(g, v) {
    var w = Nn(v),
      d = Nn(g) * w,
      y = On(g) * w,
      x = On(v),
      C = x * u + d * f;
    return [Cr(y * s - C * h, d * u - x * f), Rr(C * s + y * h)];
  }
  return (
    (c.invert = function (g, v) {
      var w = Nn(v),
        d = Nn(g) * w,
        y = On(g) * w,
        x = On(v),
        C = x * s - y * h;
      return [Cr(y * s + x * h, d * u + C * f), Rr(C * u - d * f)];
    }),
    c
  );
}
function Vw(e) {
  e = Yl(e[0] * $n, e[1] * $n, e.length > 2 ? e[2] * $n : 0);
  function r(u) {
    return (u = e(u[0] * $n, u[1] * $n)), (u[0] *= lt), (u[1] *= lt), u;
  }
  return (
    (r.invert = function (u) {
      return (
        (u = e.invert(u[0] * $n, u[1] * $n)), (u[0] *= lt), (u[1] *= lt), u
      );
    }),
    r
  );
}
function jw(e, r, u, f, s, h) {
  if (u) {
    var c = Nn(r),
      g = On(r),
      v = f * u;
    s == null
      ? ((s = r + f * ct), (h = r - v / 2))
      : ((s = il(c, s)),
        (h = il(c, h)),
        (f > 0 ? s < h : s > h) && (s += f * ct));
    for (var w, d = s; f > 0 ? d > h : d < h; d -= v)
      (w = zo([c, -g * Nn(d), -g * On(d)])), e.point(w[0], w[1]);
  }
}
function il(e, r) {
  (r = He(r)), (r[0] -= e), Bo(r);
  var u = Qw(-r[1]);
  return ((-r[2] < 0 ? -u : u) + ct - yn) % ct;
}
function Kl() {
  var e = [],
    r;
  return {
    point: function (u, f, s) {
      r.push([u, f, s]);
    },
    lineStart: function () {
      e.push((r = []));
    },
    lineEnd: xt,
    rejoin: function () {
      e.length > 1 && e.push(e.pop().concat(e.shift()));
    },
    result: function () {
      var u = e;
      return (e = []), (r = null), u;
    },
  };
}
function $i(e, r) {
  return Tn(e[0] - r[0]) < yn && Tn(e[1] - r[1]) < yn;
}
function Mi(e, r, u, f) {
  (this.x = e),
    (this.z = r),
    (this.o = u),
    (this.e = f),
    (this.v = !1),
    (this.n = this.p = null);
}
function Zl(e, r, u, f, s) {
  var h = [],
    c = [],
    g,
    v;
  if (
    (e.forEach(function (P) {
      if (!((z = P.length - 1) <= 0)) {
        var z,
          $ = P[0],
          O = P[z],
          U;
        if ($i($, O)) {
          if (!$[2] && !O[2]) {
            for (s.lineStart(), g = 0; g < z; ++g) s.point(($ = P[g])[0], $[1]);
            s.lineEnd();
            return;
          }
          O[0] += 2 * yn;
        }
        h.push((U = new Mi($, P, null, !0))),
          c.push((U.o = new Mi($, null, U, !1))),
          h.push((U = new Mi(O, P, null, !1))),
          c.push((U.o = new Mi(O, null, U, !0)));
      }
    }),
    !!h.length)
  ) {
    for (c.sort(r), ul(h), ul(c), g = 0, v = c.length; g < v; ++g)
      c[g].e = u = !u;
    for (var w = h[0], d, y; ; ) {
      for (var x = w, C = !0; x.v; ) if ((x = x.n) === w) return;
      (d = x.z), s.lineStart();
      do {
        if (((x.v = x.o.v = !0), x.e)) {
          if (C)
            for (g = 0, v = d.length; g < v; ++g) s.point((y = d[g])[0], y[1]);
          else f(x.x, x.n.x, 1, s);
          x = x.n;
        } else {
          if (C)
            for (d = x.p.z, g = d.length - 1; g >= 0; --g)
              s.point((y = d[g])[0], y[1]);
          else f(x.x, x.p.x, -1, s);
          x = x.p;
        }
        (x = x.o), (d = x.z), (C = !C);
      } while (!x.v);
      s.lineEnd();
    }
  }
}
function ul(e) {
  if ((r = e.length)) {
    for (var r, u = 0, f = e[0], s; ++u < r; )
      (f.n = s = e[u]), (s.p = f), (f = s);
    (f.n = s = e[0]), (s.p = f);
  }
}
function Lo(e) {
  return Tn(e[0]) <= hn ? e[0] : Zw(e[0]) * (((Tn(e[0]) + hn) % ct) - hn);
}
function nm(e, r) {
  var u = Lo(r),
    f = r[1],
    s = On(f),
    h = [On(u), -Nn(u), 0],
    c = 0,
    g = 0,
    v = new xe();
  s === 1 ? (f = tt + yn) : s === -1 && (f = -tt - yn);
  for (var w = 0, d = e.length; w < d; ++w)
    if ((x = (y = e[w]).length))
      for (
        var y,
          x,
          C = y[x - 1],
          P = Lo(C),
          z = C[1] / 2 + Qa,
          $ = On(z),
          O = Nn(z),
          U = 0;
        U < x;
        ++U, P = B, $ = X, O = V, C = k
      ) {
        var k = y[U],
          B = Lo(k),
          q = k[1] / 2 + Qa,
          X = On(q),
          V = Nn(q),
          rn = B - P,
          on = rn >= 0 ? 1 : -1,
          pn = on * rn,
          j = pn > hn,
          zn = $ * X;
        if (
          (v.add(Cr(zn * on * On(pn), O * V + zn * Nn(pn))),
          (c += j ? rn + on * ct : rn),
          j ^ (P >= u) ^ (B >= u))
        ) {
          var xn = Gi(He(C), He(k));
          Bo(xn);
          var A = Gi(h, xn);
          Bo(A);
          var R = (j ^ (rn >= 0) ? -1 : 1) * Rr(A[2]);
          (f > R || (f === R && (xn[0] || xn[1]))) &&
            (g += j ^ (rn >= 0) ? 1 : -1);
        }
      }
  return (c < -yn || (c < yn && v < -Xw)) ^ (g & 1);
}
function Jl(e, r, u, f) {
  return function (s) {
    var h = r(s),
      c = Kl(),
      g = r(c),
      v = !1,
      w,
      d,
      y,
      x = {
        point: C,
        lineStart: z,
        lineEnd: $,
        polygonStart: function () {
          (x.point = O), (x.lineStart = U), (x.lineEnd = k), (d = []), (w = []);
        },
        polygonEnd: function () {
          (x.point = C), (x.lineStart = z), (x.lineEnd = $), (d = Hl(d));
          var B = nm(w, f);
          d.length
            ? (v || (s.polygonStart(), (v = !0)), Zl(d, em, B, u, s))
            : B &&
              (v || (s.polygonStart(), (v = !0)),
              s.lineStart(),
              u(null, null, 1, s),
              s.lineEnd()),
            v && (s.polygonEnd(), (v = !1)),
            (d = w = null);
        },
        sphere: function () {
          s.polygonStart(),
            s.lineStart(),
            u(null, null, 1, s),
            s.lineEnd(),
            s.polygonEnd();
        },
      };
    function C(B, q) {
      e(B, q) && s.point(B, q);
    }
    function P(B, q) {
      h.point(B, q);
    }
    function z() {
      (x.point = P), h.lineStart();
    }
    function $() {
      (x.point = C), h.lineEnd();
    }
    function O(B, q) {
      y.push([B, q]), g.point(B, q);
    }
    function U() {
      g.lineStart(), (y = []);
    }
    function k() {
      O(y[0][0], y[0][1]), g.lineEnd();
      var B = g.clean(),
        q = c.result(),
        X,
        V = q.length,
        rn,
        on,
        pn;
      if ((y.pop(), w.push(y), (y = null), !!V)) {
        if (B & 1) {
          if (((on = q[0]), (rn = on.length - 1) > 0)) {
            for (
              v || (s.polygonStart(), (v = !0)), s.lineStart(), X = 0;
              X < rn;
              ++X
            )
              s.point((pn = on[X])[0], pn[1]);
            s.lineEnd();
          }
          return;
        }
        V > 1 && B & 2 && q.push(q.pop().concat(q.shift())),
          d.push(q.filter(tm));
      }
    }
    return x;
  };
}
function tm(e) {
  return e.length > 1;
}
function em(e, r) {
  return (
    ((e = e.x)[0] < 0 ? e[1] - tt - yn : tt - e[1]) -
    ((r = r.x)[0] < 0 ? r[1] - tt - yn : tt - r[1])
  );
}
const ol = Jl(
  function () {
    return !0;
  },
  rm,
  um,
  [-hn, -tt]
);
function rm(e) {
  var r = NaN,
    u = NaN,
    f = NaN,
    s;
  return {
    lineStart: function () {
      e.lineStart(), (s = 1);
    },
    point: function (h, c) {
      var g = h > 0 ? hn : -hn,
        v = Tn(h - r);
      Tn(v - hn) < yn
        ? (e.point(r, (u = (u + c) / 2 > 0 ? tt : -tt)),
          e.point(f, u),
          e.lineEnd(),
          e.lineStart(),
          e.point(g, u),
          e.point(h, u),
          (s = 0))
        : f !== g &&
          v >= hn &&
          (Tn(r - f) < yn && (r -= f * yn),
          Tn(h - g) < yn && (h -= g * yn),
          (u = im(r, u, h, c)),
          e.point(f, u),
          e.lineEnd(),
          e.lineStart(),
          e.point(g, u),
          (s = 0)),
        e.point((r = h), (u = c)),
        (f = g);
    },
    lineEnd: function () {
      e.lineEnd(), (r = u = NaN);
    },
    clean: function () {
      return 2 - s;
    },
  };
}
function im(e, r, u, f) {
  var s,
    h,
    c = On(e - u);
  return Tn(c) > yn
    ? Xl(
        (On(r) * (h = Nn(f)) * On(u) - On(f) * (s = Nn(r)) * On(e)) /
          (s * h * c)
      )
    : (r + f) / 2;
}
function um(e, r, u, f) {
  var s;
  if (e == null)
    (s = u * tt),
      f.point(-hn, s),
      f.point(0, s),
      f.point(hn, s),
      f.point(hn, 0),
      f.point(hn, -s),
      f.point(0, -s),
      f.point(-hn, -s),
      f.point(-hn, 0),
      f.point(-hn, s);
  else if (Tn(e[0] - r[0]) > yn) {
    var h = e[0] < r[0] ? hn : -hn;
    (s = (u * h) / 2), f.point(-h, s), f.point(0, s), f.point(h, s);
  } else f.point(r[0], r[1]);
}
function om(e) {
  var r = Nn(e),
    u = 6 * $n,
    f = r > 0,
    s = Tn(r) > yn;
  function h(d, y, x, C) {
    jw(C, e, u, x, d, y);
  }
  function c(d, y) {
    return Nn(d) * Nn(y) > r;
  }
  function g(d) {
    var y, x, C, P, z;
    return {
      lineStart: function () {
        (P = C = !1), (z = 1);
      },
      point: function ($, O) {
        var U = [$, O],
          k,
          B = c($, O),
          q = f ? (B ? 0 : w($, O)) : B ? w($ + ($ < 0 ? hn : -hn), O) : 0;
        if (
          (!y && (P = C = B) && d.lineStart(),
          B !== C &&
            ((k = v(y, U)), (!k || $i(y, k) || $i(U, k)) && (U[2] = 1)),
          B !== C)
        )
          (z = 0),
            B
              ? (d.lineStart(), (k = v(U, y)), d.point(k[0], k[1]))
              : ((k = v(y, U)), d.point(k[0], k[1], 2), d.lineEnd()),
            (y = k);
        else if (s && y && f ^ B) {
          var X;
          !(q & x) &&
            (X = v(U, y, !0)) &&
            ((z = 0),
            f
              ? (d.lineStart(),
                d.point(X[0][0], X[0][1]),
                d.point(X[1][0], X[1][1]),
                d.lineEnd())
              : (d.point(X[1][0], X[1][1]),
                d.lineEnd(),
                d.lineStart(),
                d.point(X[0][0], X[0][1], 3)));
        }
        B && (!y || !$i(y, U)) && d.point(U[0], U[1]),
          (y = U),
          (C = B),
          (x = q);
      },
      lineEnd: function () {
        C && d.lineEnd(), (y = null);
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function () {
        return z | ((P && C) << 1);
      },
    };
  }
  function v(d, y, x) {
    var C = He(d),
      P = He(y),
      z = [1, 0, 0],
      $ = Gi(C, P),
      O = Ti($, $),
      U = $[0],
      k = O - U * U;
    if (!k) return !x && d;
    var B = (r * O) / k,
      q = (-r * U) / k,
      X = Gi(z, $),
      V = Ii(z, B),
      rn = Ii($, q);
    Mo(V, rn);
    var on = X,
      pn = Ti(V, on),
      j = Ti(on, on),
      zn = pn * pn - j * (Ti(V, V) - 1);
    if (!(zn < 0)) {
      var xn = Ae(zn),
        A = Ii(on, (-pn - xn) / j);
      if ((Mo(A, V), (A = zo(A)), !x)) return A;
      var R = d[0],
        I = y[0],
        F = d[1],
        G = y[1],
        Y;
      I < R && ((Y = R), (R = I), (I = Y));
      var nn = I - R,
        Q = Tn(nn - hn) < yn,
        gn = Q || nn < yn;
      if (
        (!Q && G < F && ((Y = F), (F = G), (G = Y)),
        gn
          ? Q
            ? (F + G > 0) ^ (A[1] < (Tn(A[0] - R) < yn ? F : G))
            : F <= A[1] && A[1] <= G
          : (nn > hn) ^ (R <= A[0] && A[0] <= I))
      ) {
        var In = Ii(on, (-pn + xn) / j);
        return Mo(In, V), [A, zo(In)];
      }
    }
  }
  function w(d, y) {
    var x = f ? e : hn - e,
      C = 0;
    return (
      d < -x ? (C |= 1) : d > x && (C |= 2),
      y < -x ? (C |= 4) : y > x && (C |= 8),
      C
    );
  }
  return Jl(c, g, h, f ? [0, -e] : [-hn, e - hn]);
}
function fm(e, r, u, f, s, h) {
  var c = e[0],
    g = e[1],
    v = r[0],
    w = r[1],
    d = 0,
    y = 1,
    x = v - c,
    C = w - g,
    P;
  if (((P = u - c), !(!x && P > 0))) {
    if (((P /= x), x < 0)) {
      if (P < d) return;
      P < y && (y = P);
    } else if (x > 0) {
      if (P > y) return;
      P > d && (d = P);
    }
    if (((P = s - c), !(!x && P < 0))) {
      if (((P /= x), x < 0)) {
        if (P > y) return;
        P > d && (d = P);
      } else if (x > 0) {
        if (P < d) return;
        P < y && (y = P);
      }
      if (((P = f - g), !(!C && P > 0))) {
        if (((P /= C), C < 0)) {
          if (P < d) return;
          P < y && (y = P);
        } else if (C > 0) {
          if (P > y) return;
          P > d && (d = P);
        }
        if (((P = h - g), !(!C && P < 0))) {
          if (((P /= C), C < 0)) {
            if (P > y) return;
            P > d && (d = P);
          } else if (C > 0) {
            if (P < d) return;
            P < y && (y = P);
          }
          return (
            d > 0 && ((e[0] = c + d * x), (e[1] = g + d * C)),
            y < 1 && ((r[0] = c + y * x), (r[1] = g + y * C)),
            !0
          );
        }
      }
    }
  }
}
var wr = 1e9,
  Li = -wr;
function sm(e, r, u, f) {
  function s(w, d) {
    return e <= w && w <= u && r <= d && d <= f;
  }
  function h(w, d, y, x) {
    var C = 0,
      P = 0;
    if (w == null || (C = c(w, y)) !== (P = c(d, y)) || (v(w, d) < 0) ^ (y > 0))
      do x.point(C === 0 || C === 3 ? e : u, C > 1 ? f : r);
      while ((C = (C + y + 4) % 4) !== P);
    else x.point(d[0], d[1]);
  }
  function c(w, d) {
    return Tn(w[0] - e) < yn
      ? d > 0
        ? 0
        : 3
      : Tn(w[0] - u) < yn
      ? d > 0
        ? 2
        : 1
      : Tn(w[1] - r) < yn
      ? d > 0
        ? 1
        : 0
      : d > 0
      ? 3
      : 2;
  }
  function g(w, d) {
    return v(w.x, d.x);
  }
  function v(w, d) {
    var y = c(w, 1),
      x = c(d, 1);
    return y !== x
      ? y - x
      : y === 0
      ? d[1] - w[1]
      : y === 1
      ? w[0] - d[0]
      : y === 2
      ? w[1] - d[1]
      : d[0] - w[0];
  }
  return function (w) {
    var d = w,
      y = Kl(),
      x,
      C,
      P,
      z,
      $,
      O,
      U,
      k,
      B,
      q,
      X,
      V = {
        point: rn,
        lineStart: zn,
        lineEnd: xn,
        polygonStart: pn,
        polygonEnd: j,
      };
    function rn(R, I) {
      s(R, I) && d.point(R, I);
    }
    function on() {
      for (var R = 0, I = 0, F = C.length; I < F; ++I)
        for (
          var G = C[I],
            Y = 1,
            nn = G.length,
            Q = G[0],
            gn,
            In,
            An = Q[0],
            Sn = Q[1];
          Y < nn;
          ++Y
        )
          (gn = An),
            (In = Sn),
            (Q = G[Y]),
            (An = Q[0]),
            (Sn = Q[1]),
            In <= f
              ? Sn > f && (An - gn) * (f - In) > (Sn - In) * (e - gn) && ++R
              : Sn <= f && (An - gn) * (f - In) < (Sn - In) * (e - gn) && --R;
      return R;
    }
    function pn() {
      (d = y), (x = []), (C = []), (X = !0);
    }
    function j() {
      var R = on(),
        I = X && R,
        F = (x = Hl(x)).length;
      (I || F) &&
        (w.polygonStart(),
        I && (w.lineStart(), h(null, null, 1, w), w.lineEnd()),
        F && Zl(x, g, R, h, w),
        w.polygonEnd()),
        (d = w),
        (x = C = P = null);
    }
    function zn() {
      (V.point = A), C && C.push((P = [])), (q = !0), (B = !1), (U = k = NaN);
    }
    function xn() {
      x && (A(z, $), O && B && y.rejoin(), x.push(y.result())),
        (V.point = rn),
        B && d.lineEnd();
    }
    function A(R, I) {
      var F = s(R, I);
      if ((C && P.push([R, I]), q))
        (z = R),
          ($ = I),
          (O = F),
          (q = !1),
          F && (d.lineStart(), d.point(R, I));
      else if (F && B) d.point(R, I);
      else {
        var G = [
            (U = Math.max(Li, Math.min(wr, U))),
            (k = Math.max(Li, Math.min(wr, k))),
          ],
          Y = [
            (R = Math.max(Li, Math.min(wr, R))),
            (I = Math.max(Li, Math.min(wr, I))),
          ];
        fm(G, Y, e, r, u, f)
          ? (B || (d.lineStart(), d.point(G[0], G[1])),
            d.point(Y[0], Y[1]),
            F || d.lineEnd(),
            (X = !1))
          : F && (d.lineStart(), d.point(R, I), (X = !1));
      }
      (U = R), (k = I), (B = F);
    }
    return V;
  };
}
const Uo = (e) => e;
var bo = new xe(),
  Go = new xe(),
  Ql,
  Vl,
  qo,
  Ho,
  Zt = {
    point: xt,
    lineStart: xt,
    lineEnd: xt,
    polygonStart: function () {
      (Zt.lineStart = am), (Zt.lineEnd = cm);
    },
    polygonEnd: function () {
      (Zt.lineStart = Zt.lineEnd = Zt.point = xt),
        bo.add(Tn(Go)),
        (Go = new xe());
    },
    result: function () {
      var e = bo / 2;
      return (bo = new xe()), e;
    },
  };
function am() {
  Zt.point = lm;
}
function lm(e, r) {
  (Zt.point = jl), (Ql = qo = e), (Vl = Ho = r);
}
function jl(e, r) {
  Go.add(Ho * e - qo * r), (qo = e), (Ho = r);
}
function cm() {
  jl(Ql, Vl);
}
var Xe = 1 / 0,
  qi = Xe,
  Tr = -Xe,
  Hi = Tr,
  Xi = {
    point: hm,
    lineStart: xt,
    lineEnd: xt,
    polygonStart: xt,
    polygonEnd: xt,
    result: function () {
      var e = [
        [Xe, qi],
        [Tr, Hi],
      ];
      return (Tr = Hi = -(qi = Xe = 1 / 0)), e;
    },
  };
function hm(e, r) {
  e < Xe && (Xe = e),
    e > Tr && (Tr = e),
    r < qi && (qi = r),
    r > Hi && (Hi = r);
}
var Xo = 0,
  Yo = 0,
  mr = 0,
  Yi = 0,
  Ki = 0,
  ke = 0,
  Ko = 0,
  Zo = 0,
  yr = 0,
  nc,
  tc,
  Nt,
  Ot,
  yt = {
    point: Se,
    lineStart: fl,
    lineEnd: sl,
    polygonStart: function () {
      (yt.lineStart = dm), (yt.lineEnd = _m);
    },
    polygonEnd: function () {
      (yt.point = Se), (yt.lineStart = fl), (yt.lineEnd = sl);
    },
    result: function () {
      var e = yr
        ? [Ko / yr, Zo / yr]
        : ke
        ? [Yi / ke, Ki / ke]
        : mr
        ? [Xo / mr, Yo / mr]
        : [NaN, NaN];
      return (Xo = Yo = mr = Yi = Ki = ke = Ko = Zo = yr = 0), e;
    },
  };
function Se(e, r) {
  (Xo += e), (Yo += r), ++mr;
}
function fl() {
  yt.point = pm;
}
function pm(e, r) {
  (yt.point = gm), Se((Nt = e), (Ot = r));
}
function gm(e, r) {
  var u = e - Nt,
    f = r - Ot,
    s = Ae(u * u + f * f);
  (Yi += (s * (Nt + e)) / 2),
    (Ki += (s * (Ot + r)) / 2),
    (ke += s),
    Se((Nt = e), (Ot = r));
}
function sl() {
  yt.point = Se;
}
function dm() {
  yt.point = vm;
}
function _m() {
  ec(nc, tc);
}
function vm(e, r) {
  (yt.point = ec), Se((nc = Nt = e), (tc = Ot = r));
}
function ec(e, r) {
  var u = e - Nt,
    f = r - Ot,
    s = Ae(u * u + f * f);
  (Yi += (s * (Nt + e)) / 2),
    (Ki += (s * (Ot + r)) / 2),
    (ke += s),
    (s = Ot * e - Nt * r),
    (Ko += s * (Nt + e)),
    (Zo += s * (Ot + r)),
    (yr += s * 3),
    Se((Nt = e), (Ot = r));
}
function rc(e) {
  this._context = e;
}
rc.prototype = {
  _radius: 4.5,
  pointRadius: function (e) {
    return (this._radius = e), this;
  },
  polygonStart: function () {
    this._line = 0;
  },
  polygonEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._point = 0;
  },
  lineEnd: function () {
    this._line === 0 && this._context.closePath(), (this._point = NaN);
  },
  point: function (e, r) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(e, r), (this._point = 1);
        break;
      }
      case 1: {
        this._context.lineTo(e, r);
        break;
      }
      default: {
        this._context.moveTo(e + this._radius, r),
          this._context.arc(e, r, this._radius, 0, ct);
        break;
      }
    }
  },
  result: xt,
};
var Jo = new xe(),
  Po,
  ic,
  uc,
  xr,
  Sr,
  Ir = {
    point: xt,
    lineStart: function () {
      Ir.point = wm;
    },
    lineEnd: function () {
      Po && oc(ic, uc), (Ir.point = xt);
    },
    polygonStart: function () {
      Po = !0;
    },
    polygonEnd: function () {
      Po = null;
    },
    result: function () {
      var e = +Jo;
      return (Jo = new xe()), e;
    },
  };
function wm(e, r) {
  (Ir.point = oc), (ic = xr = e), (uc = Sr = r);
}
function oc(e, r) {
  (xr -= e), (Sr -= r), Jo.add(Ae(xr * xr + Sr * Sr)), (xr = e), (Sr = r);
}
let al, Zi, ll, cl;
class hl {
  constructor(r) {
    (this._append = r == null ? fc : mm(r)),
      (this._radius = 4.5),
      (this._ = '');
  }
  pointRadius(r) {
    return (this._radius = +r), this;
  }
  polygonStart() {
    this._line = 0;
  }
  polygonEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    this._line === 0 && (this._ += 'Z'), (this._point = NaN);
  }
  point(r, u) {
    switch (this._point) {
      case 0: {
        this._append`M${r},${u}`, (this._point = 1);
        break;
      }
      case 1: {
        this._append`L${r},${u}`;
        break;
      }
      default: {
        if (
          (this._append`M${r},${u}`, this._radius !== ll || this._append !== Zi)
        ) {
          const f = this._radius,
            s = this._;
          (this._ = ''),
            this._append`m0,${f}a${f},${f} 0 1,1 0,${
              -2 * f
            }a${f},${f} 0 1,1 0,${2 * f}z`,
            (ll = f),
            (Zi = this._append),
            (cl = this._),
            (this._ = s);
        }
        this._ += cl;
        break;
      }
    }
  }
  result() {
    const r = this._;
    return (this._ = ''), r.length ? r : null;
  }
}
function fc(e) {
  let r = 1;
  this._ += e[0];
  for (const u = e.length; r < u; ++r) this._ += arguments[r] + e[r];
}
function mm(e) {
  const r = Math.floor(e);
  if (!(r >= 0)) throw new RangeError(`invalid digits: ${e}`);
  if (r > 15) return fc;
  if (r !== al) {
    const u = 10 ** r;
    (al = r),
      (Zi = function (s) {
        let h = 1;
        this._ += s[0];
        for (const c = s.length; h < c; ++h)
          this._ += Math.round(arguments[h] * u) / u + s[h];
      });
  }
  return Zi;
}
function ym(e, r) {
  let u = 3,
    f = 4.5,
    s,
    h;
  function c(g) {
    return (
      g &&
        (typeof f == 'function' && h.pointRadius(+f.apply(this, arguments)),
        We(g, s(h))),
      h.result()
    );
  }
  return (
    (c.area = function (g) {
      return We(g, s(Zt)), Zt.result();
    }),
    (c.measure = function (g) {
      return We(g, s(Ir)), Ir.result();
    }),
    (c.bounds = function (g) {
      return We(g, s(Xi)), Xi.result();
    }),
    (c.centroid = function (g) {
      return We(g, s(yt)), yt.result();
    }),
    (c.projection = function (g) {
      return arguments.length
        ? ((s = g == null ? ((e = null), Uo) : (e = g).stream), c)
        : e;
    }),
    (c.context = function (g) {
      return arguments.length
        ? ((h = g == null ? ((r = null), new hl(u)) : new rc((r = g))),
          typeof f != 'function' && h.pointRadius(f),
          c)
        : r;
    }),
    (c.pointRadius = function (g) {
      return arguments.length
        ? ((f = typeof g == 'function' ? g : (h.pointRadius(+g), +g)), c)
        : f;
    }),
    (c.digits = function (g) {
      if (!arguments.length) return u;
      if (g == null) u = null;
      else {
        const v = Math.floor(g);
        if (!(v >= 0)) throw new RangeError(`invalid digits: ${g}`);
        u = v;
      }
      return r === null && (h = new hl(u)), c;
    }),
    c.projection(e).digits(u).context(r)
  );
}
function lf(e) {
  return function (r) {
    var u = new Qo();
    for (var f in e) u[f] = e[f];
    return (u.stream = r), u;
  };
}
function Qo() {}
Qo.prototype = {
  constructor: Qo,
  point: function (e, r) {
    this.stream.point(e, r);
  },
  sphere: function () {
    this.stream.sphere();
  },
  lineStart: function () {
    this.stream.lineStart();
  },
  lineEnd: function () {
    this.stream.lineEnd();
  },
  polygonStart: function () {
    this.stream.polygonStart();
  },
  polygonEnd: function () {
    this.stream.polygonEnd();
  },
};
function cf(e, r, u) {
  var f = e.clipExtent && e.clipExtent();
  return (
    e.scale(150).translate([0, 0]),
    f != null && e.clipExtent(null),
    We(u, e.stream(Xi)),
    r(Xi.result()),
    f != null && e.clipExtent(f),
    e
  );
}
function sc(e, r, u) {
  return cf(
    e,
    function (f) {
      var s = r[1][0] - r[0][0],
        h = r[1][1] - r[0][1],
        c = Math.min(s / (f[1][0] - f[0][0]), h / (f[1][1] - f[0][1])),
        g = +r[0][0] + (s - c * (f[1][0] + f[0][0])) / 2,
        v = +r[0][1] + (h - c * (f[1][1] + f[0][1])) / 2;
      e.scale(150 * c).translate([g, v]);
    },
    u
  );
}
function xm(e, r, u) {
  return sc(e, [[0, 0], r], u);
}
function Sm(e, r, u) {
  return cf(
    e,
    function (f) {
      var s = +r,
        h = s / (f[1][0] - f[0][0]),
        c = (s - h * (f[1][0] + f[0][0])) / 2,
        g = -h * f[0][1];
      e.scale(150 * h).translate([c, g]);
    },
    u
  );
}
function Em(e, r, u) {
  return cf(
    e,
    function (f) {
      var s = +r,
        h = s / (f[1][1] - f[0][1]),
        c = -h * f[0][0],
        g = (s - h * (f[1][1] + f[0][1])) / 2;
      e.scale(150 * h).translate([c, g]);
    },
    u
  );
}
var pl = 16,
  Am = Nn(30 * $n);
function gl(e, r) {
  return +r ? Rm(e, r) : Cm(e);
}
function Cm(e) {
  return lf({
    point: function (r, u) {
      (r = e(r, u)), this.stream.point(r[0], r[1]);
    },
  });
}
function Rm(e, r) {
  function u(f, s, h, c, g, v, w, d, y, x, C, P, z, $) {
    var O = w - f,
      U = d - s,
      k = O * O + U * U;
    if (k > 4 * r && z--) {
      var B = c + x,
        q = g + C,
        X = v + P,
        V = Ae(B * B + q * q + X * X),
        rn = Rr((X /= V)),
        on = Tn(Tn(X) - 1) < yn || Tn(h - y) < yn ? (h + y) / 2 : Cr(q, B),
        pn = e(on, rn),
        j = pn[0],
        zn = pn[1],
        xn = j - f,
        A = zn - s,
        R = U * xn - O * A;
      ((R * R) / k > r ||
        Tn((O * xn + U * A) / k - 0.5) > 0.3 ||
        c * x + g * C + v * P < Am) &&
        (u(f, s, h, c, g, v, j, zn, on, (B /= V), (q /= V), X, z, $),
        $.point(j, zn),
        u(j, zn, on, B, q, X, w, d, y, x, C, P, z, $));
    }
  }
  return function (f) {
    var s,
      h,
      c,
      g,
      v,
      w,
      d,
      y,
      x,
      C,
      P,
      z,
      $ = {
        point: O,
        lineStart: U,
        lineEnd: B,
        polygonStart: function () {
          f.polygonStart(), ($.lineStart = q);
        },
        polygonEnd: function () {
          f.polygonEnd(), ($.lineStart = U);
        },
      };
    function O(rn, on) {
      (rn = e(rn, on)), f.point(rn[0], rn[1]);
    }
    function U() {
      (y = NaN), ($.point = k), f.lineStart();
    }
    function k(rn, on) {
      var pn = He([rn, on]),
        j = e(rn, on);
      u(
        y,
        x,
        d,
        C,
        P,
        z,
        (y = j[0]),
        (x = j[1]),
        (d = rn),
        (C = pn[0]),
        (P = pn[1]),
        (z = pn[2]),
        pl,
        f
      ),
        f.point(y, x);
    }
    function B() {
      ($.point = O), f.lineEnd();
    }
    function q() {
      U(), ($.point = X), ($.lineEnd = V);
    }
    function X(rn, on) {
      k((s = rn), on),
        (h = y),
        (c = x),
        (g = C),
        (v = P),
        (w = z),
        ($.point = k);
    }
    function V() {
      u(y, x, d, C, P, z, h, c, s, g, v, w, pl, f), ($.lineEnd = B), B();
    }
    return $;
  };
}
var Tm = lf({
  point: function (e, r) {
    this.stream.point(e * $n, r * $n);
  },
});
function Im(e) {
  return lf({
    point: function (r, u) {
      var f = e(r, u);
      return this.stream.point(f[0], f[1]);
    },
  });
}
function Mm(e, r, u, f, s) {
  function h(c, g) {
    return (c *= f), (g *= s), [r + e * c, u - e * g];
  }
  return (
    (h.invert = function (c, g) {
      return [((c - r) / e) * f, ((u - g) / e) * s];
    }),
    h
  );
}
function dl(e, r, u, f, s, h) {
  if (!h) return Mm(e, r, u, f, s);
  var c = Nn(h),
    g = On(h),
    v = c * e,
    w = g * e,
    d = c / e,
    y = g / e,
    x = (g * u - c * r) / e,
    C = (g * r + c * u) / e;
  function P(z, $) {
    return (z *= f), ($ *= s), [v * z - w * $ + r, u - w * z - v * $];
  }
  return (
    (P.invert = function (z, $) {
      return [f * (d * z - y * $ + x), s * (C - y * z - d * $)];
    }),
    P
  );
}
function Lm(e) {
  return bm(function () {
    return e;
  })();
}
function bm(e) {
  var r,
    u = 150,
    f = 480,
    s = 250,
    h = 0,
    c = 0,
    g = 0,
    v = 0,
    w = 0,
    d,
    y = 0,
    x = 1,
    C = 1,
    P = null,
    z = ol,
    $ = null,
    O,
    U,
    k,
    B = Uo,
    q = 0.5,
    X,
    V,
    rn,
    on,
    pn;
  function j(R) {
    return rn(R[0] * $n, R[1] * $n);
  }
  function zn(R) {
    return (R = rn.invert(R[0], R[1])), R && [R[0] * lt, R[1] * lt];
  }
  (j.stream = function (R) {
    return on && pn === R ? on : (on = Tm(Im(d)(z(X(B((pn = R)))))));
  }),
    (j.preclip = function (R) {
      return arguments.length ? ((z = R), (P = void 0), A()) : z;
    }),
    (j.postclip = function (R) {
      return arguments.length ? ((B = R), ($ = O = U = k = null), A()) : B;
    }),
    (j.clipAngle = function (R) {
      return arguments.length
        ? ((z = +R ? om((P = R * $n)) : ((P = null), ol)), A())
        : P * lt;
    }),
    (j.clipExtent = function (R) {
      return arguments.length
        ? ((B =
            R == null
              ? (($ = O = U = k = null), Uo)
              : sm(
                  ($ = +R[0][0]),
                  (O = +R[0][1]),
                  (U = +R[1][0]),
                  (k = +R[1][1])
                )),
          A())
        : $ == null
        ? null
        : [
            [$, O],
            [U, k],
          ];
    }),
    (j.scale = function (R) {
      return arguments.length ? ((u = +R), xn()) : u;
    }),
    (j.translate = function (R) {
      return arguments.length ? ((f = +R[0]), (s = +R[1]), xn()) : [f, s];
    }),
    (j.center = function (R) {
      return arguments.length
        ? ((h = (R[0] % 360) * $n), (c = (R[1] % 360) * $n), xn())
        : [h * lt, c * lt];
    }),
    (j.rotate = function (R) {
      return arguments.length
        ? ((g = (R[0] % 360) * $n),
          (v = (R[1] % 360) * $n),
          (w = R.length > 2 ? (R[2] % 360) * $n : 0),
          xn())
        : [g * lt, v * lt, w * lt];
    }),
    (j.angle = function (R) {
      return arguments.length ? ((y = (R % 360) * $n), xn()) : y * lt;
    }),
    (j.reflectX = function (R) {
      return arguments.length ? ((x = R ? -1 : 1), xn()) : x < 0;
    }),
    (j.reflectY = function (R) {
      return arguments.length ? ((C = R ? -1 : 1), xn()) : C < 0;
    }),
    (j.precision = function (R) {
      return arguments.length ? ((X = gl(V, (q = R * R))), A()) : Ae(q);
    }),
    (j.fitExtent = function (R, I) {
      return sc(j, R, I);
    }),
    (j.fitSize = function (R, I) {
      return xm(j, R, I);
    }),
    (j.fitWidth = function (R, I) {
      return Sm(j, R, I);
    }),
    (j.fitHeight = function (R, I) {
      return Em(j, R, I);
    });
  function xn() {
    var R = dl(u, 0, 0, x, C, y).apply(null, r(h, c)),
      I = dl(u, f - R[0], s - R[1], x, C, y);
    return (
      (d = Yl(g, v, w)), (V = Wo(r, I)), (rn = Wo(d, V)), (X = gl(V, q)), A()
    );
  }
  function A() {
    return (on = pn = null), j;
  }
  return function () {
    return (r = e.apply(this, arguments)), (j.invert = r.invert && zn), xn();
  };
}
function hf(e, r) {
  return [e, Kw(Jw((tt + r) / 2))];
}
hf.invert = function (e, r) {
  return [e, 2 * Xl(Yw(r)) - tt];
};
function Pm() {
  return Nm(hf).scale(961 / ct);
}
function Nm(e) {
  var r = Lm(e),
    u = r.center,
    f = r.scale,
    s = r.translate,
    h = r.clipExtent,
    c = null,
    g,
    v,
    w;
  (r.scale = function (y) {
    return arguments.length ? (f(y), d()) : f();
  }),
    (r.translate = function (y) {
      return arguments.length ? (s(y), d()) : s();
    }),
    (r.center = function (y) {
      return arguments.length ? (u(y), d()) : u();
    }),
    (r.clipExtent = function (y) {
      return arguments.length
        ? (y == null
            ? (c = g = v = w = null)
            : ((c = +y[0][0]), (g = +y[0][1]), (v = +y[1][0]), (w = +y[1][1])),
          d())
        : c == null
        ? null
        : [
            [c, g],
            [v, w],
          ];
    });
  function d() {
    var y = hn * f(),
      x = r(Vw(r.rotate()).invert([0, 0]));
    return h(
      c == null
        ? [
            [x[0] - y, x[1] - y],
            [x[0] + y, x[1] + y],
          ]
        : e === hf
        ? [
            [Math.max(x[0] - y, c), g],
            [Math.min(x[0] + y, v), w],
          ]
        : [
            [c, Math.max(x[1] - y, g)],
            [v, Math.min(x[1] + y, w)],
          ]
    );
  }
  return d();
}
var Om = { value: () => {} };
function pf() {
  for (var e = 0, r = arguments.length, u = {}, f; e < r; ++e) {
    if (!(f = arguments[e] + '') || f in u || /[\s.]/.test(f))
      throw new Error('illegal type: ' + f);
    u[f] = [];
  }
  return new Fi(u);
}
function Fi(e) {
  this._ = e;
}
function $m(e, r) {
  return e
    .trim()
    .split(/^|\s+/)
    .map(function (u) {
      var f = '',
        s = u.indexOf('.');
      if (
        (s >= 0 && ((f = u.slice(s + 1)), (u = u.slice(0, s))),
        u && !r.hasOwnProperty(u))
      )
        throw new Error('unknown type: ' + u);
      return { type: u, name: f };
    });
}
Fi.prototype = pf.prototype = {
  constructor: Fi,
  on: function (e, r) {
    var u = this._,
      f = $m(e + '', u),
      s,
      h = -1,
      c = f.length;
    if (arguments.length < 2) {
      for (; ++h < c; )
        if ((s = (e = f[h]).type) && (s = Fm(u[s], e.name))) return s;
      return;
    }
    if (r != null && typeof r != 'function')
      throw new Error('invalid callback: ' + r);
    for (; ++h < c; )
      if ((s = (e = f[h]).type)) u[s] = _l(u[s], e.name, r);
      else if (r == null) for (s in u) u[s] = _l(u[s], e.name, null);
    return this;
  },
  copy: function () {
    var e = {},
      r = this._;
    for (var u in r) e[u] = r[u].slice();
    return new Fi(e);
  },
  call: function (e, r) {
    if ((s = arguments.length - 2) > 0)
      for (var u = new Array(s), f = 0, s, h; f < s; ++f)
        u[f] = arguments[f + 2];
    if (!this._.hasOwnProperty(e)) throw new Error('unknown type: ' + e);
    for (h = this._[e], f = 0, s = h.length; f < s; ++f) h[f].value.apply(r, u);
  },
  apply: function (e, r, u) {
    if (!this._.hasOwnProperty(e)) throw new Error('unknown type: ' + e);
    for (var f = this._[e], s = 0, h = f.length; s < h; ++s)
      f[s].value.apply(r, u);
  },
};
function Fm(e, r) {
  for (var u = 0, f = e.length, s; u < f; ++u)
    if ((s = e[u]).name === r) return s.value;
}
function _l(e, r, u) {
  for (var f = 0, s = e.length; f < s; ++f)
    if (e[f].name === r) {
      (e[f] = Om), (e = e.slice(0, f).concat(e.slice(f + 1)));
      break;
    }
  return u != null && e.push({ name: r, value: u }), e;
}
var Ye = 0,
  Er = 0,
  _r = 0,
  ac = 1e3,
  Ji,
  Ar,
  Qi = 0,
  Ee = 0,
  uu = 0,
  Mr = typeof performance == 'object' && performance.now ? performance : Date,
  lc =
    typeof window == 'object' && window.requestAnimationFrame
      ? window.requestAnimationFrame.bind(window)
      : function (e) {
          setTimeout(e, 17);
        };
function gf() {
  return Ee || (lc(Dm), (Ee = Mr.now() + uu));
}
function Dm() {
  Ee = 0;
}
function Vi() {
  this._call = this._time = this._next = null;
}
Vi.prototype = cc.prototype = {
  constructor: Vi,
  restart: function (e, r, u) {
    if (typeof e != 'function')
      throw new TypeError('callback is not a function');
    (u = (u == null ? gf() : +u) + (r == null ? 0 : +r)),
      !this._next &&
        Ar !== this &&
        (Ar ? (Ar._next = this) : (Ji = this), (Ar = this)),
      (this._call = e),
      (this._time = u),
      Vo();
  },
  stop: function () {
    this._call && ((this._call = null), (this._time = 1 / 0), Vo());
  },
};
function cc(e, r, u) {
  var f = new Vi();
  return f.restart(e, r, u), f;
}
function zm() {
  gf(), ++Ye;
  for (var e = Ji, r; e; )
    (r = Ee - e._time) >= 0 && e._call.call(void 0, r), (e = e._next);
  --Ye;
}
function vl() {
  (Ee = (Qi = Mr.now()) + uu), (Ye = Er = 0);
  try {
    zm();
  } finally {
    (Ye = 0), Wm(), (Ee = 0);
  }
}
function Bm() {
  var e = Mr.now(),
    r = e - Qi;
  r > ac && ((uu -= r), (Qi = e));
}
function Wm() {
  for (var e, r = Ji, u, f = 1 / 0; r; )
    r._call
      ? (f > r._time && (f = r._time), (e = r), (r = r._next))
      : ((u = r._next), (r._next = null), (r = e ? (e._next = u) : (Ji = u)));
  (Ar = e), Vo(f);
}
function Vo(e) {
  if (!Ye) {
    Er && (Er = clearTimeout(Er));
    var r = e - Ee;
    r > 24
      ? (e < 1 / 0 && (Er = setTimeout(vl, e - Mr.now() - uu)),
        _r && (_r = clearInterval(_r)))
      : (_r || ((Qi = Mr.now()), (_r = setInterval(Bm, ac))), (Ye = 1), lc(vl));
  }
}
function wl(e, r, u) {
  var f = new Vi();
  return (
    (r = r == null ? 0 : +r),
    f.restart(
      (s) => {
        f.stop(), e(s + r);
      },
      r,
      u
    ),
    f
  );
}
var km = pf('start', 'end', 'cancel', 'interrupt'),
  Um = [],
  hc = 0,
  ml = 1,
  jo = 2,
  Di = 3,
  yl = 4,
  nf = 5,
  zi = 6;
function ou(e, r, u, f, s, h) {
  var c = e.__transition;
  if (!c) e.__transition = {};
  else if (u in c) return;
  Gm(e, u, {
    name: r,
    index: f,
    // For context during callback.
    group: s,
    // For context during callback.
    on: km,
    tween: Um,
    time: h.time,
    delay: h.delay,
    duration: h.duration,
    ease: h.ease,
    timer: null,
    state: hc,
  });
}
function df(e, r) {
  var u = Mt(e, r);
  if (u.state > hc) throw new Error('too late; already scheduled');
  return u;
}
function Ft(e, r) {
  var u = Mt(e, r);
  if (u.state > Di) throw new Error('too late; already running');
  return u;
}
function Mt(e, r) {
  var u = e.__transition;
  if (!u || !(u = u[r])) throw new Error('transition not found');
  return u;
}
function Gm(e, r, u) {
  var f = e.__transition,
    s;
  (f[r] = u), (u.timer = cc(h, 0, u.time));
  function h(w) {
    (u.state = ml),
      u.timer.restart(c, u.delay, u.time),
      u.delay <= w && c(w - u.delay);
  }
  function c(w) {
    var d, y, x, C;
    if (u.state !== ml) return v();
    for (d in f)
      if (((C = f[d]), C.name === u.name)) {
        if (C.state === Di) return wl(c);
        C.state === yl
          ? ((C.state = zi),
            C.timer.stop(),
            C.on.call('interrupt', e, e.__data__, C.index, C.group),
            delete f[d])
          : +d < r &&
            ((C.state = zi),
            C.timer.stop(),
            C.on.call('cancel', e, e.__data__, C.index, C.group),
            delete f[d]);
      }
    if (
      (wl(function () {
        u.state === Di &&
          ((u.state = yl), u.timer.restart(g, u.delay, u.time), g(w));
      }),
      (u.state = jo),
      u.on.call('start', e, e.__data__, u.index, u.group),
      u.state === jo)
    ) {
      for (
        u.state = Di, s = new Array((x = u.tween.length)), d = 0, y = -1;
        d < x;
        ++d
      )
        (C = u.tween[d].value.call(e, e.__data__, u.index, u.group)) &&
          (s[++y] = C);
      s.length = y + 1;
    }
  }
  function g(w) {
    for (
      var d =
          w < u.duration
            ? u.ease.call(null, w / u.duration)
            : (u.timer.restart(v), (u.state = nf), 1),
        y = -1,
        x = s.length;
      ++y < x;

    )
      s[y].call(e, d);
    u.state === nf && (u.on.call('end', e, e.__data__, u.index, u.group), v());
  }
  function v() {
    (u.state = zi), u.timer.stop(), delete f[r];
    for (var w in f) return;
    delete e.__transition;
  }
}
function Bi(e, r) {
  var u = e.__transition,
    f,
    s,
    h = !0,
    c;
  if (u) {
    r = r == null ? null : r + '';
    for (c in u) {
      if ((f = u[c]).name !== r) {
        h = !1;
        continue;
      }
      (s = f.state > jo && f.state < nf),
        (f.state = zi),
        f.timer.stop(),
        f.on.call(s ? 'interrupt' : 'cancel', e, e.__data__, f.index, f.group),
        delete u[c];
    }
    h && delete e.__transition;
  }
}
function qm(e) {
  return this.each(function () {
    Bi(this, e);
  });
}
function _f(e, r, u) {
  (e.prototype = r.prototype = u), (u.constructor = e);
}
function pc(e, r) {
  var u = Object.create(e.prototype);
  for (var f in r) u[f] = r[f];
  return u;
}
function Nr() {}
var Lr = 0.7,
  ji = 1 / Lr,
  Ge = '\\s*([+-]?\\d+)\\s*',
  br = '\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*',
  $t = '\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*',
  Hm = /^#([0-9a-f]{3,8})$/,
  Xm = new RegExp(`^rgb\\(${Ge},${Ge},${Ge}\\)$`),
  Ym = new RegExp(`^rgb\\(${$t},${$t},${$t}\\)$`),
  Km = new RegExp(`^rgba\\(${Ge},${Ge},${Ge},${br}\\)$`),
  Zm = new RegExp(`^rgba\\(${$t},${$t},${$t},${br}\\)$`),
  Jm = new RegExp(`^hsl\\(${br},${$t},${$t}\\)$`),
  Qm = new RegExp(`^hsla\\(${br},${$t},${$t},${br}\\)$`),
  xl = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074,
  };
_f(Nr, Pr, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Sl,
  // Deprecated! Use color.formatHex.
  formatHex: Sl,
  formatHex8: Vm,
  formatHsl: jm,
  formatRgb: El,
  toString: El,
});
function Sl() {
  return this.rgb().formatHex();
}
function Vm() {
  return this.rgb().formatHex8();
}
function jm() {
  return gc(this).formatHsl();
}
function El() {
  return this.rgb().formatRgb();
}
function Pr(e) {
  var r, u;
  return (
    (e = (e + '').trim().toLowerCase()),
    (r = Hm.exec(e))
      ? ((u = r[1].length),
        (r = parseInt(r[1], 16)),
        u === 6
          ? Al(r)
          : u === 3
          ? new et(
              ((r >> 8) & 15) | ((r >> 4) & 240),
              ((r >> 4) & 15) | (r & 240),
              ((r & 15) << 4) | (r & 15),
              1
            )
          : u === 8
          ? bi(
              (r >> 24) & 255,
              (r >> 16) & 255,
              (r >> 8) & 255,
              (r & 255) / 255
            )
          : u === 4
          ? bi(
              ((r >> 12) & 15) | ((r >> 8) & 240),
              ((r >> 8) & 15) | ((r >> 4) & 240),
              ((r >> 4) & 15) | (r & 240),
              (((r & 15) << 4) | (r & 15)) / 255
            )
          : null)
      : (r = Xm.exec(e))
      ? new et(r[1], r[2], r[3], 1)
      : (r = Ym.exec(e))
      ? new et((r[1] * 255) / 100, (r[2] * 255) / 100, (r[3] * 255) / 100, 1)
      : (r = Km.exec(e))
      ? bi(r[1], r[2], r[3], r[4])
      : (r = Zm.exec(e))
      ? bi((r[1] * 255) / 100, (r[2] * 255) / 100, (r[3] * 255) / 100, r[4])
      : (r = Jm.exec(e))
      ? Tl(r[1], r[2] / 100, r[3] / 100, 1)
      : (r = Qm.exec(e))
      ? Tl(r[1], r[2] / 100, r[3] / 100, r[4])
      : xl.hasOwnProperty(e)
      ? Al(xl[e])
      : e === 'transparent'
      ? new et(NaN, NaN, NaN, 0)
      : null
  );
}
function Al(e) {
  return new et((e >> 16) & 255, (e >> 8) & 255, e & 255, 1);
}
function bi(e, r, u, f) {
  return f <= 0 && (e = r = u = NaN), new et(e, r, u, f);
}
function ny(e) {
  return (
    e instanceof Nr || (e = Pr(e)),
    e ? ((e = e.rgb()), new et(e.r, e.g, e.b, e.opacity)) : new et()
  );
}
function tf(e, r, u, f) {
  return arguments.length === 1 ? ny(e) : new et(e, r, u, f ?? 1);
}
function et(e, r, u, f) {
  (this.r = +e), (this.g = +r), (this.b = +u), (this.opacity = +f);
}
_f(
  et,
  tf,
  pc(Nr, {
    brighter(e) {
      return (
        (e = e == null ? ji : Math.pow(ji, e)),
        new et(this.r * e, this.g * e, this.b * e, this.opacity)
      );
    },
    darker(e) {
      return (
        (e = e == null ? Lr : Math.pow(Lr, e)),
        new et(this.r * e, this.g * e, this.b * e, this.opacity)
      );
    },
    rgb() {
      return this;
    },
    clamp() {
      return new et(ye(this.r), ye(this.g), ye(this.b), nu(this.opacity));
    },
    displayable() {
      return (
        -0.5 <= this.r &&
        this.r < 255.5 &&
        -0.5 <= this.g &&
        this.g < 255.5 &&
        -0.5 <= this.b &&
        this.b < 255.5 &&
        0 <= this.opacity &&
        this.opacity <= 1
      );
    },
    hex: Cl,
    // Deprecated! Use color.formatHex.
    formatHex: Cl,
    formatHex8: ty,
    formatRgb: Rl,
    toString: Rl,
  })
);
function Cl() {
  return `#${me(this.r)}${me(this.g)}${me(this.b)}`;
}
function ty() {
  return `#${me(this.r)}${me(this.g)}${me(this.b)}${me(
    (isNaN(this.opacity) ? 1 : this.opacity) * 255
  )}`;
}
function Rl() {
  const e = nu(this.opacity);
  return `${e === 1 ? 'rgb(' : 'rgba('}${ye(this.r)}, ${ye(this.g)}, ${ye(
    this.b
  )}${e === 1 ? ')' : `, ${e})`}`;
}
function nu(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function ye(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function me(e) {
  return (e = ye(e)), (e < 16 ? '0' : '') + e.toString(16);
}
function Tl(e, r, u, f) {
  return (
    f <= 0
      ? (e = r = u = NaN)
      : u <= 0 || u >= 1
      ? (e = r = NaN)
      : r <= 0 && (e = NaN),
    new It(e, r, u, f)
  );
}
function gc(e) {
  if (e instanceof It) return new It(e.h, e.s, e.l, e.opacity);
  if ((e instanceof Nr || (e = Pr(e)), !e)) return new It();
  if (e instanceof It) return e;
  e = e.rgb();
  var r = e.r / 255,
    u = e.g / 255,
    f = e.b / 255,
    s = Math.min(r, u, f),
    h = Math.max(r, u, f),
    c = NaN,
    g = h - s,
    v = (h + s) / 2;
  return (
    g
      ? (r === h
          ? (c = (u - f) / g + (u < f) * 6)
          : u === h
          ? (c = (f - r) / g + 2)
          : (c = (r - u) / g + 4),
        (g /= v < 0.5 ? h + s : 2 - h - s),
        (c *= 60))
      : (g = v > 0 && v < 1 ? 0 : c),
    new It(c, g, v, e.opacity)
  );
}
function ey(e, r, u, f) {
  return arguments.length === 1 ? gc(e) : new It(e, r, u, f ?? 1);
}
function It(e, r, u, f) {
  (this.h = +e), (this.s = +r), (this.l = +u), (this.opacity = +f);
}
_f(
  It,
  ey,
  pc(Nr, {
    brighter(e) {
      return (
        (e = e == null ? ji : Math.pow(ji, e)),
        new It(this.h, this.s, this.l * e, this.opacity)
      );
    },
    darker(e) {
      return (
        (e = e == null ? Lr : Math.pow(Lr, e)),
        new It(this.h, this.s, this.l * e, this.opacity)
      );
    },
    rgb() {
      var e = (this.h % 360) + (this.h < 0) * 360,
        r = isNaN(e) || isNaN(this.s) ? 0 : this.s,
        u = this.l,
        f = u + (u < 0.5 ? u : 1 - u) * r,
        s = 2 * u - f;
      return new et(
        No(e >= 240 ? e - 240 : e + 120, s, f),
        No(e, s, f),
        No(e < 120 ? e + 240 : e - 120, s, f),
        this.opacity
      );
    },
    clamp() {
      return new It(Il(this.h), Pi(this.s), Pi(this.l), nu(this.opacity));
    },
    displayable() {
      return (
        ((0 <= this.s && this.s <= 1) || isNaN(this.s)) &&
        0 <= this.l &&
        this.l <= 1 &&
        0 <= this.opacity &&
        this.opacity <= 1
      );
    },
    formatHsl() {
      const e = nu(this.opacity);
      return `${e === 1 ? 'hsl(' : 'hsla('}${Il(this.h)}, ${
        Pi(this.s) * 100
      }%, ${Pi(this.l) * 100}%${e === 1 ? ')' : `, ${e})`}`;
    },
  })
);
function Il(e) {
  return (e = (e || 0) % 360), e < 0 ? e + 360 : e;
}
function Pi(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function No(e, r, u) {
  return (
    (e < 60
      ? r + ((u - r) * e) / 60
      : e < 180
      ? u
      : e < 240
      ? r + ((u - r) * (240 - e)) / 60
      : r) * 255
  );
}
const dc = (e) => () => e;
function ry(e, r) {
  return function (u) {
    return e + u * r;
  };
}
function iy(e, r, u) {
  return (
    (e = Math.pow(e, u)),
    (r = Math.pow(r, u) - e),
    (u = 1 / u),
    function (f) {
      return Math.pow(e + f * r, u);
    }
  );
}
function uy(e) {
  return (e = +e) == 1
    ? _c
    : function (r, u) {
        return u - r ? iy(r, u, e) : dc(isNaN(r) ? u : r);
      };
}
function _c(e, r) {
  var u = r - e;
  return u ? ry(e, u) : dc(isNaN(e) ? r : e);
}
const Ml = (function e(r) {
  var u = uy(r);
  function f(s, h) {
    var c = u((s = tf(s)).r, (h = tf(h)).r),
      g = u(s.g, h.g),
      v = u(s.b, h.b),
      w = _c(s.opacity, h.opacity);
    return function (d) {
      return (
        (s.r = c(d)), (s.g = g(d)), (s.b = v(d)), (s.opacity = w(d)), s + ''
      );
    };
  }
  return (f.gamma = e), f;
})(1);
function fe(e, r) {
  return (
    (e = +e),
    (r = +r),
    function (u) {
      return e * (1 - u) + r * u;
    }
  );
}
var ef = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
  Oo = new RegExp(ef.source, 'g');
function oy(e) {
  return function () {
    return e;
  };
}
function fy(e) {
  return function (r) {
    return e(r) + '';
  };
}
function sy(e, r) {
  var u = (ef.lastIndex = Oo.lastIndex = 0),
    f,
    s,
    h,
    c = -1,
    g = [],
    v = [];
  for (e = e + '', r = r + ''; (f = ef.exec(e)) && (s = Oo.exec(r)); )
    (h = s.index) > u &&
      ((h = r.slice(u, h)), g[c] ? (g[c] += h) : (g[++c] = h)),
      (f = f[0]) === (s = s[0])
        ? g[c]
          ? (g[c] += s)
          : (g[++c] = s)
        : ((g[++c] = null), v.push({ i: c, x: fe(f, s) })),
      (u = Oo.lastIndex);
  return (
    u < r.length && ((h = r.slice(u)), g[c] ? (g[c] += h) : (g[++c] = h)),
    g.length < 2
      ? v[0]
        ? fy(v[0].x)
        : oy(r)
      : ((r = v.length),
        function (w) {
          for (var d = 0, y; d < r; ++d) g[(y = v[d]).i] = y.x(w);
          return g.join('');
        })
  );
}
var Ll = 180 / Math.PI,
  rf = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1,
  };
function vc(e, r, u, f, s, h) {
  var c, g, v;
  return (
    (c = Math.sqrt(e * e + r * r)) && ((e /= c), (r /= c)),
    (v = e * u + r * f) && ((u -= e * v), (f -= r * v)),
    (g = Math.sqrt(u * u + f * f)) && ((u /= g), (f /= g), (v /= g)),
    e * f < r * u && ((e = -e), (r = -r), (v = -v), (c = -c)),
    {
      translateX: s,
      translateY: h,
      rotate: Math.atan2(r, e) * Ll,
      skewX: Math.atan(v) * Ll,
      scaleX: c,
      scaleY: g,
    }
  );
}
var Ni;
function ay(e) {
  const r = new (typeof DOMMatrix == 'function' ? DOMMatrix : WebKitCSSMatrix)(
    e + ''
  );
  return r.isIdentity ? rf : vc(r.a, r.b, r.c, r.d, r.e, r.f);
}
function ly(e) {
  return e == null ||
    (Ni || (Ni = document.createElementNS('http://www.w3.org/2000/svg', 'g')),
    Ni.setAttribute('transform', e),
    !(e = Ni.transform.baseVal.consolidate()))
    ? rf
    : ((e = e.matrix), vc(e.a, e.b, e.c, e.d, e.e, e.f));
}
function wc(e, r, u, f) {
  function s(w) {
    return w.length ? w.pop() + ' ' : '';
  }
  function h(w, d, y, x, C, P) {
    if (w !== y || d !== x) {
      var z = C.push('translate(', null, r, null, u);
      P.push({ i: z - 4, x: fe(w, y) }, { i: z - 2, x: fe(d, x) });
    } else (y || x) && C.push('translate(' + y + r + x + u);
  }
  function c(w, d, y, x) {
    w !== d
      ? (w - d > 180 ? (d += 360) : d - w > 180 && (w += 360),
        x.push({ i: y.push(s(y) + 'rotate(', null, f) - 2, x: fe(w, d) }))
      : d && y.push(s(y) + 'rotate(' + d + f);
  }
  function g(w, d, y, x) {
    w !== d
      ? x.push({ i: y.push(s(y) + 'skewX(', null, f) - 2, x: fe(w, d) })
      : d && y.push(s(y) + 'skewX(' + d + f);
  }
  function v(w, d, y, x, C, P) {
    if (w !== y || d !== x) {
      var z = C.push(s(C) + 'scale(', null, ',', null, ')');
      P.push({ i: z - 4, x: fe(w, y) }, { i: z - 2, x: fe(d, x) });
    } else (y !== 1 || x !== 1) && C.push(s(C) + 'scale(' + y + ',' + x + ')');
  }
  return function (w, d) {
    var y = [],
      x = [];
    return (
      (w = e(w)),
      (d = e(d)),
      h(w.translateX, w.translateY, d.translateX, d.translateY, y, x),
      c(w.rotate, d.rotate, y, x),
      g(w.skewX, d.skewX, y, x),
      v(w.scaleX, w.scaleY, d.scaleX, d.scaleY, y, x),
      (w = d = null),
      function (C) {
        for (var P = -1, z = x.length, $; ++P < z; ) y[($ = x[P]).i] = $.x(C);
        return y.join('');
      }
    );
  };
}
var cy = wc(ay, 'px, ', 'px)', 'deg)'),
  hy = wc(ly, ', ', ')', ')'),
  py = 1e-12;
function bl(e) {
  return ((e = Math.exp(e)) + 1 / e) / 2;
}
function gy(e) {
  return ((e = Math.exp(e)) - 1 / e) / 2;
}
function dy(e) {
  return ((e = Math.exp(2 * e)) - 1) / (e + 1);
}
const _y = (function e(r, u, f) {
  function s(h, c) {
    var g = h[0],
      v = h[1],
      w = h[2],
      d = c[0],
      y = c[1],
      x = c[2],
      C = d - g,
      P = y - v,
      z = C * C + P * P,
      $,
      O;
    if (z < py)
      (O = Math.log(x / w) / r),
        ($ = function (V) {
          return [g + V * C, v + V * P, w * Math.exp(r * V * O)];
        });
    else {
      var U = Math.sqrt(z),
        k = (x * x - w * w + f * z) / (2 * w * u * U),
        B = (x * x - w * w - f * z) / (2 * x * u * U),
        q = Math.log(Math.sqrt(k * k + 1) - k),
        X = Math.log(Math.sqrt(B * B + 1) - B);
      (O = (X - q) / r),
        ($ = function (V) {
          var rn = V * O,
            on = bl(q),
            pn = (w / (u * U)) * (on * dy(r * rn + q) - gy(q));
          return [g + pn * C, v + pn * P, (w * on) / bl(r * rn + q)];
        });
    }
    return ($.duration = (O * 1e3 * r) / Math.SQRT2), $;
  }
  return (
    (s.rho = function (h) {
      var c = Math.max(1e-3, +h),
        g = c * c,
        v = g * g;
      return e(c, g, v);
    }),
    s
  );
})(Math.SQRT2, 2, 4);
function vy(e, r) {
  var u, f;
  return function () {
    var s = Ft(this, e),
      h = s.tween;
    if (h !== u) {
      f = u = h;
      for (var c = 0, g = f.length; c < g; ++c)
        if (f[c].name === r) {
          (f = f.slice()), f.splice(c, 1);
          break;
        }
    }
    s.tween = f;
  };
}
function wy(e, r, u) {
  var f, s;
  if (typeof u != 'function') throw new Error();
  return function () {
    var h = Ft(this, e),
      c = h.tween;
    if (c !== f) {
      s = (f = c).slice();
      for (var g = { name: r, value: u }, v = 0, w = s.length; v < w; ++v)
        if (s[v].name === r) {
          s[v] = g;
          break;
        }
      v === w && s.push(g);
    }
    h.tween = s;
  };
}
function my(e, r) {
  var u = this._id;
  if (((e += ''), arguments.length < 2)) {
    for (var f = Mt(this.node(), u).tween, s = 0, h = f.length, c; s < h; ++s)
      if ((c = f[s]).name === e) return c.value;
    return null;
  }
  return this.each((r == null ? vy : wy)(u, e, r));
}
function vf(e, r, u) {
  var f = e._id;
  return (
    e.each(function () {
      var s = Ft(this, f);
      (s.value || (s.value = {}))[r] = u.apply(this, arguments);
    }),
    function (s) {
      return Mt(s, f).value[r];
    }
  );
}
function mc(e, r) {
  var u;
  return (
    typeof r == 'number'
      ? fe
      : r instanceof Pr
      ? Ml
      : (u = Pr(r))
      ? ((r = u), Ml)
      : sy
  )(e, r);
}
function yy(e) {
  return function () {
    this.removeAttribute(e);
  };
}
function xy(e) {
  return function () {
    this.removeAttributeNS(e.space, e.local);
  };
}
function Sy(e, r, u) {
  var f,
    s = u + '',
    h;
  return function () {
    var c = this.getAttribute(e);
    return c === s ? null : c === f ? h : (h = r((f = c), u));
  };
}
function Ey(e, r, u) {
  var f,
    s = u + '',
    h;
  return function () {
    var c = this.getAttributeNS(e.space, e.local);
    return c === s ? null : c === f ? h : (h = r((f = c), u));
  };
}
function Ay(e, r, u) {
  var f, s, h;
  return function () {
    var c,
      g = u(this),
      v;
    return g == null
      ? void this.removeAttribute(e)
      : ((c = this.getAttribute(e)),
        (v = g + ''),
        c === v
          ? null
          : c === f && v === s
          ? h
          : ((s = v), (h = r((f = c), g))));
  };
}
function Cy(e, r, u) {
  var f, s, h;
  return function () {
    var c,
      g = u(this),
      v;
    return g == null
      ? void this.removeAttributeNS(e.space, e.local)
      : ((c = this.getAttributeNS(e.space, e.local)),
        (v = g + ''),
        c === v
          ? null
          : c === f && v === s
          ? h
          : ((s = v), (h = r((f = c), g))));
  };
}
function Ry(e, r) {
  var u = iu(e),
    f = u === 'transform' ? hy : mc;
  return this.attrTween(
    e,
    typeof r == 'function'
      ? (u.local ? Cy : Ay)(u, f, vf(this, 'attr.' + e, r))
      : r == null
      ? (u.local ? xy : yy)(u)
      : (u.local ? Ey : Sy)(u, f, r)
  );
}
function Ty(e, r) {
  return function (u) {
    this.setAttribute(e, r.call(this, u));
  };
}
function Iy(e, r) {
  return function (u) {
    this.setAttributeNS(e.space, e.local, r.call(this, u));
  };
}
function My(e, r) {
  var u, f;
  function s() {
    var h = r.apply(this, arguments);
    return h !== f && (u = (f = h) && Iy(e, h)), u;
  }
  return (s._value = r), s;
}
function Ly(e, r) {
  var u, f;
  function s() {
    var h = r.apply(this, arguments);
    return h !== f && (u = (f = h) && Ty(e, h)), u;
  }
  return (s._value = r), s;
}
function by(e, r) {
  var u = 'attr.' + e;
  if (arguments.length < 2) return (u = this.tween(u)) && u._value;
  if (r == null) return this.tween(u, null);
  if (typeof r != 'function') throw new Error();
  var f = iu(e);
  return this.tween(u, (f.local ? My : Ly)(f, r));
}
function Py(e, r) {
  return function () {
    df(this, e).delay = +r.apply(this, arguments);
  };
}
function Ny(e, r) {
  return (
    (r = +r),
    function () {
      df(this, e).delay = r;
    }
  );
}
function Oy(e) {
  var r = this._id;
  return arguments.length
    ? this.each((typeof e == 'function' ? Py : Ny)(r, e))
    : Mt(this.node(), r).delay;
}
function $y(e, r) {
  return function () {
    Ft(this, e).duration = +r.apply(this, arguments);
  };
}
function Fy(e, r) {
  return (
    (r = +r),
    function () {
      Ft(this, e).duration = r;
    }
  );
}
function Dy(e) {
  var r = this._id;
  return arguments.length
    ? this.each((typeof e == 'function' ? $y : Fy)(r, e))
    : Mt(this.node(), r).duration;
}
function zy(e, r) {
  if (typeof r != 'function') throw new Error();
  return function () {
    Ft(this, e).ease = r;
  };
}
function By(e) {
  var r = this._id;
  return arguments.length ? this.each(zy(r, e)) : Mt(this.node(), r).ease;
}
function Wy(e, r) {
  return function () {
    var u = r.apply(this, arguments);
    if (typeof u != 'function') throw new Error();
    Ft(this, e).ease = u;
  };
}
function ky(e) {
  if (typeof e != 'function') throw new Error();
  return this.each(Wy(this._id, e));
}
function Uy(e) {
  typeof e != 'function' && (e = Fl(e));
  for (var r = this._groups, u = r.length, f = new Array(u), s = 0; s < u; ++s)
    for (var h = r[s], c = h.length, g = (f[s] = []), v, w = 0; w < c; ++w)
      (v = h[w]) && e.call(v, v.__data__, w, h) && g.push(v);
  return new Qt(f, this._parents, this._name, this._id);
}
function Gy(e) {
  if (e._id !== this._id) throw new Error();
  for (
    var r = this._groups,
      u = e._groups,
      f = r.length,
      s = u.length,
      h = Math.min(f, s),
      c = new Array(f),
      g = 0;
    g < h;
    ++g
  )
    for (
      var v = r[g], w = u[g], d = v.length, y = (c[g] = new Array(d)), x, C = 0;
      C < d;
      ++C
    )
      (x = v[C] || w[C]) && (y[C] = x);
  for (; g < f; ++g) c[g] = r[g];
  return new Qt(c, this._parents, this._name, this._id);
}
function qy(e) {
  return (e + '')
    .trim()
    .split(/^|\s+/)
    .every(function (r) {
      var u = r.indexOf('.');
      return u >= 0 && (r = r.slice(0, u)), !r || r === 'start';
    });
}
function Hy(e, r, u) {
  var f,
    s,
    h = qy(r) ? df : Ft;
  return function () {
    var c = h(this, e),
      g = c.on;
    g !== f && (s = (f = g).copy()).on(r, u), (c.on = s);
  };
}
function Xy(e, r) {
  var u = this._id;
  return arguments.length < 2
    ? Mt(this.node(), u).on.on(e)
    : this.each(Hy(u, e, r));
}
function Yy(e) {
  return function () {
    var r = this.parentNode;
    for (var u in this.__transition) if (+u !== e) return;
    r && r.removeChild(this);
  };
}
function Ky() {
  return this.on('end.remove', Yy(this._id));
}
function Zy(e) {
  var r = this._name,
    u = this._id;
  typeof e != 'function' && (e = ff(e));
  for (var f = this._groups, s = f.length, h = new Array(s), c = 0; c < s; ++c)
    for (
      var g = f[c], v = g.length, w = (h[c] = new Array(v)), d, y, x = 0;
      x < v;
      ++x
    )
      (d = g[x]) &&
        (y = e.call(d, d.__data__, x, g)) &&
        ('__data__' in d && (y.__data__ = d.__data__),
        (w[x] = y),
        ou(w[x], r, u, x, w, Mt(d, u)));
  return new Qt(h, this._parents, r, u);
}
function Jy(e) {
  var r = this._name,
    u = this._id;
  typeof e != 'function' && (e = $l(e));
  for (var f = this._groups, s = f.length, h = [], c = [], g = 0; g < s; ++g)
    for (var v = f[g], w = v.length, d, y = 0; y < w; ++y)
      if ((d = v[y])) {
        for (
          var x = e.call(d, d.__data__, y, v),
            C,
            P = Mt(d, u),
            z = 0,
            $ = x.length;
          z < $;
          ++z
        )
          (C = x[z]) && ou(C, r, u, z, x, P);
        h.push(x), c.push(d);
      }
  return new Qt(h, c, r, u);
}
var Qy = Ke.prototype.constructor;
function Vy() {
  return new Qy(this._groups, this._parents);
}
function jy(e, r) {
  var u, f, s;
  return function () {
    var h = qe(this, e),
      c = (this.style.removeProperty(e), qe(this, e));
    return h === c ? null : h === u && c === f ? s : (s = r((u = h), (f = c)));
  };
}
function yc(e) {
  return function () {
    this.style.removeProperty(e);
  };
}
function nx(e, r, u) {
  var f,
    s = u + '',
    h;
  return function () {
    var c = qe(this, e);
    return c === s ? null : c === f ? h : (h = r((f = c), u));
  };
}
function tx(e, r, u) {
  var f, s, h;
  return function () {
    var c = qe(this, e),
      g = u(this),
      v = g + '';
    return (
      g == null && (v = g = (this.style.removeProperty(e), qe(this, e))),
      c === v ? null : c === f && v === s ? h : ((s = v), (h = r((f = c), g)))
    );
  };
}
function ex(e, r) {
  var u,
    f,
    s,
    h = 'style.' + r,
    c = 'end.' + h,
    g;
  return function () {
    var v = Ft(this, e),
      w = v.on,
      d = v.value[h] == null ? g || (g = yc(r)) : void 0;
    (w !== u || s !== d) && (f = (u = w).copy()).on(c, (s = d)), (v.on = f);
  };
}
function rx(e, r, u) {
  var f = (e += '') == 'transform' ? cy : mc;
  return r == null
    ? this.styleTween(e, jy(e, f)).on('end.style.' + e, yc(e))
    : typeof r == 'function'
    ? this.styleTween(e, tx(e, f, vf(this, 'style.' + e, r))).each(
        ex(this._id, e)
      )
    : this.styleTween(e, nx(e, f, r), u).on('end.style.' + e, null);
}
function ix(e, r, u) {
  return function (f) {
    this.style.setProperty(e, r.call(this, f), u);
  };
}
function ux(e, r, u) {
  var f, s;
  function h() {
    var c = r.apply(this, arguments);
    return c !== s && (f = (s = c) && ix(e, c, u)), f;
  }
  return (h._value = r), h;
}
function ox(e, r, u) {
  var f = 'style.' + (e += '');
  if (arguments.length < 2) return (f = this.tween(f)) && f._value;
  if (r == null) return this.tween(f, null);
  if (typeof r != 'function') throw new Error();
  return this.tween(f, ux(e, r, u ?? ''));
}
function fx(e) {
  return function () {
    this.textContent = e;
  };
}
function sx(e) {
  return function () {
    var r = e(this);
    this.textContent = r ?? '';
  };
}
function ax(e) {
  return this.tween(
    'text',
    typeof e == 'function'
      ? sx(vf(this, 'text', e))
      : fx(e == null ? '' : e + '')
  );
}
function lx(e) {
  return function (r) {
    this.textContent = e.call(this, r);
  };
}
function cx(e) {
  var r, u;
  function f() {
    var s = e.apply(this, arguments);
    return s !== u && (r = (u = s) && lx(s)), r;
  }
  return (f._value = e), f;
}
function hx(e) {
  var r = 'text';
  if (arguments.length < 1) return (r = this.tween(r)) && r._value;
  if (e == null) return this.tween(r, null);
  if (typeof e != 'function') throw new Error();
  return this.tween(r, cx(e));
}
function px() {
  for (
    var e = this._name,
      r = this._id,
      u = xc(),
      f = this._groups,
      s = f.length,
      h = 0;
    h < s;
    ++h
  )
    for (var c = f[h], g = c.length, v, w = 0; w < g; ++w)
      if ((v = c[w])) {
        var d = Mt(v, r);
        ou(v, e, u, w, c, {
          time: d.time + d.delay + d.duration,
          delay: 0,
          duration: d.duration,
          ease: d.ease,
        });
      }
  return new Qt(f, this._parents, e, u);
}
function gx() {
  var e,
    r,
    u = this,
    f = u._id,
    s = u.size();
  return new Promise(function (h, c) {
    var g = { value: c },
      v = {
        value: function () {
          --s === 0 && h();
        },
      };
    u.each(function () {
      var w = Ft(this, f),
        d = w.on;
      d !== e &&
        ((r = (e = d).copy()),
        r._.cancel.push(g),
        r._.interrupt.push(g),
        r._.end.push(v)),
        (w.on = r);
    }),
      s === 0 && h();
  });
}
var dx = 0;
function Qt(e, r, u, f) {
  (this._groups = e), (this._parents = r), (this._name = u), (this._id = f);
}
function wf(e) {
  return Ke().transition(e);
}
function xc() {
  return ++dx;
}
var Kt = Ke.prototype;
Qt.prototype = wf.prototype = {
  constructor: Qt,
  select: Zy,
  selectAll: Jy,
  selectChild: Kt.selectChild,
  selectChildren: Kt.selectChildren,
  filter: Uy,
  merge: Gy,
  selection: Vy,
  transition: px,
  call: Kt.call,
  nodes: Kt.nodes,
  node: Kt.node,
  size: Kt.size,
  empty: Kt.empty,
  each: Kt.each,
  on: Xy,
  attr: Ry,
  attrTween: by,
  style: rx,
  styleTween: ox,
  text: ax,
  textTween: hx,
  remove: Ky,
  tween: my,
  delay: Oy,
  duration: Dy,
  ease: By,
  easeVarying: ky,
  end: gx,
  [Symbol.iterator]: Kt[Symbol.iterator],
};
function _x(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var vx = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: _x,
};
function wx(e, r) {
  for (var u; !(u = e.__transition) || !(u = u[r]); )
    if (!(e = e.parentNode)) throw new Error(`transition ${r} not found`);
  return u;
}
function mx(e) {
  var r, u;
  e instanceof Qt
    ? ((r = e._id), (e = e._name))
    : ((r = xc()), ((u = vx).time = gf()), (e = e == null ? null : e + ''));
  for (var f = this._groups, s = f.length, h = 0; h < s; ++h)
    for (var c = f[h], g = c.length, v, w = 0; w < g; ++w)
      (v = c[w]) && ou(v, e, r, w, c, u || wx(v, r));
  return new Qt(f, this._parents, e, r);
}
Ke.prototype.interrupt = qm;
Ke.prototype.transition = mx;
const uf = { capture: !0, passive: !1 };
function of(e) {
  e.preventDefault(), e.stopImmediatePropagation();
}
function yx(e) {
  var r = e.document.documentElement,
    u = Un(e).on('dragstart.drag', of, uf);
  'onselectstart' in r
    ? u.on('selectstart.drag', of, uf)
    : ((r.__noselect = r.style.MozUserSelect),
      (r.style.MozUserSelect = 'none'));
}
function xx(e, r) {
  var u = e.document.documentElement,
    f = Un(e).on('dragstart.drag', null);
  r &&
    (f.on('click.drag', of, uf),
    setTimeout(function () {
      f.on('click.drag', null);
    }, 0)),
    'onselectstart' in u
      ? f.on('selectstart.drag', null)
      : ((u.style.MozUserSelect = u.__noselect), delete u.__noselect);
}
const Oi = (e) => () => e;
function Sx(e, { sourceEvent: r, target: u, transform: f, dispatch: s }) {
  Object.defineProperties(this, {
    type: { value: e, enumerable: !0, configurable: !0 },
    sourceEvent: { value: r, enumerable: !0, configurable: !0 },
    target: { value: u, enumerable: !0, configurable: !0 },
    transform: { value: f, enumerable: !0, configurable: !0 },
    _: { value: s },
  });
}
function Jt(e, r, u) {
  (this.k = e), (this.x = r), (this.y = u);
}
Jt.prototype = {
  constructor: Jt,
  scale: function (e) {
    return e === 1 ? this : new Jt(this.k * e, this.x, this.y);
  },
  translate: function (e, r) {
    return (e === 0) & (r === 0)
      ? this
      : new Jt(this.k, this.x + this.k * e, this.y + this.k * r);
  },
  apply: function (e) {
    return [e[0] * this.k + this.x, e[1] * this.k + this.y];
  },
  applyX: function (e) {
    return e * this.k + this.x;
  },
  applyY: function (e) {
    return e * this.k + this.y;
  },
  invert: function (e) {
    return [(e[0] - this.x) / this.k, (e[1] - this.y) / this.k];
  },
  invertX: function (e) {
    return (e - this.x) / this.k;
  },
  invertY: function (e) {
    return (e - this.y) / this.k;
  },
  rescaleX: function (e) {
    return e.copy().domain(e.range().map(this.invertX, this).map(e.invert, e));
  },
  rescaleY: function (e) {
    return e.copy().domain(e.range().map(this.invertY, this).map(e.invert, e));
  },
  toString: function () {
    return 'translate(' + this.x + ',' + this.y + ') scale(' + this.k + ')';
  },
};
var Ue = new Jt(1, 0, 0);
Jt.prototype;
function $o(e) {
  e.stopImmediatePropagation();
}
function vr(e) {
  e.preventDefault(), e.stopImmediatePropagation();
}
function Ex(e) {
  return (!e.ctrlKey || e.type === 'wheel') && !e.button;
}
function Ax() {
  var e = this;
  return e instanceof SVGElement
    ? ((e = e.ownerSVGElement || e),
      e.hasAttribute('viewBox')
        ? ((e = e.viewBox.baseVal),
          [
            [e.x, e.y],
            [e.x + e.width, e.y + e.height],
          ])
        : [
            [0, 0],
            [e.width.baseVal.value, e.height.baseVal.value],
          ])
    : [
        [0, 0],
        [e.clientWidth, e.clientHeight],
      ];
}
function Pl() {
  return this.__zoom || Ue;
}
function Cx(e) {
  return (
    -e.deltaY *
    (e.deltaMode === 1 ? 0.05 : e.deltaMode ? 1 : 2e-3) *
    (e.ctrlKey ? 10 : 1)
  );
}
function Rx() {
  return navigator.maxTouchPoints || 'ontouchstart' in this;
}
function Tx(e, r, u) {
  var f = e.invertX(r[0][0]) - u[0][0],
    s = e.invertX(r[1][0]) - u[1][0],
    h = e.invertY(r[0][1]) - u[0][1],
    c = e.invertY(r[1][1]) - u[1][1];
  return e.translate(
    s > f ? (f + s) / 2 : Math.min(0, f) || Math.max(0, s),
    c > h ? (h + c) / 2 : Math.min(0, h) || Math.max(0, c)
  );
}
function Ix() {
  var e = Ex,
    r = Ax,
    u = Tx,
    f = Cx,
    s = Rx,
    h = [0, 1 / 0],
    c = [
      [-1 / 0, -1 / 0],
      [1 / 0, 1 / 0],
    ],
    g = 250,
    v = _y,
    w = pf('start', 'zoom', 'end'),
    d,
    y,
    x,
    C = 500,
    P = 150,
    z = 0,
    $ = 10;
  function O(A) {
    A.property('__zoom', Pl)
      .on('wheel.zoom', rn, { passive: !1 })
      .on('mousedown.zoom', on)
      .on('dblclick.zoom', pn)
      .filter(s)
      .on('touchstart.zoom', j)
      .on('touchmove.zoom', zn)
      .on('touchend.zoom touchcancel.zoom', xn)
      .style('-webkit-tap-highlight-color', 'rgba(0,0,0,0)');
  }
  (O.transform = function (A, R, I, F) {
    var G = A.selection ? A.selection() : A;
    G.property('__zoom', Pl),
      A !== G
        ? q(A, R, I, F)
        : G.interrupt().each(function () {
            X(this, arguments)
              .event(F)
              .start()
              .zoom(null, typeof R == 'function' ? R.apply(this, arguments) : R)
              .end();
          });
  }),
    (O.scaleBy = function (A, R, I, F) {
      O.scaleTo(
        A,
        function () {
          var G = this.__zoom.k,
            Y = typeof R == 'function' ? R.apply(this, arguments) : R;
          return G * Y;
        },
        I,
        F
      );
    }),
    (O.scaleTo = function (A, R, I, F) {
      O.transform(
        A,
        function () {
          var G = r.apply(this, arguments),
            Y = this.__zoom,
            nn =
              I == null
                ? B(G)
                : typeof I == 'function'
                ? I.apply(this, arguments)
                : I,
            Q = Y.invert(nn),
            gn = typeof R == 'function' ? R.apply(this, arguments) : R;
          return u(k(U(Y, gn), nn, Q), G, c);
        },
        I,
        F
      );
    }),
    (O.translateBy = function (A, R, I, F) {
      O.transform(
        A,
        function () {
          return u(
            this.__zoom.translate(
              typeof R == 'function' ? R.apply(this, arguments) : R,
              typeof I == 'function' ? I.apply(this, arguments) : I
            ),
            r.apply(this, arguments),
            c
          );
        },
        null,
        F
      );
    }),
    (O.translateTo = function (A, R, I, F, G) {
      O.transform(
        A,
        function () {
          var Y = r.apply(this, arguments),
            nn = this.__zoom,
            Q =
              F == null
                ? B(Y)
                : typeof F == 'function'
                ? F.apply(this, arguments)
                : F;
          return u(
            Ue.translate(Q[0], Q[1])
              .scale(nn.k)
              .translate(
                typeof R == 'function' ? -R.apply(this, arguments) : -R,
                typeof I == 'function' ? -I.apply(this, arguments) : -I
              ),
            Y,
            c
          );
        },
        F,
        G
      );
    });
  function U(A, R) {
    return (
      (R = Math.max(h[0], Math.min(h[1], R))),
      R === A.k ? A : new Jt(R, A.x, A.y)
    );
  }
  function k(A, R, I) {
    var F = R[0] - I[0] * A.k,
      G = R[1] - I[1] * A.k;
    return F === A.x && G === A.y ? A : new Jt(A.k, F, G);
  }
  function B(A) {
    return [(+A[0][0] + +A[1][0]) / 2, (+A[0][1] + +A[1][1]) / 2];
  }
  function q(A, R, I, F) {
    A.on('start.zoom', function () {
      X(this, arguments).event(F).start();
    })
      .on('interrupt.zoom end.zoom', function () {
        X(this, arguments).event(F).end();
      })
      .tween('zoom', function () {
        var G = this,
          Y = arguments,
          nn = X(G, Y).event(F),
          Q = r.apply(G, Y),
          gn = I == null ? B(Q) : typeof I == 'function' ? I.apply(G, Y) : I,
          In = Math.max(Q[1][0] - Q[0][0], Q[1][1] - Q[0][1]),
          An = G.__zoom,
          Sn = typeof R == 'function' ? R.apply(G, Y) : R,
          Jn = v(
            An.invert(gn).concat(In / An.k),
            Sn.invert(gn).concat(In / Sn.k)
          );
        return function (rt) {
          if (rt === 1) rt = Sn;
          else {
            var Hn = Jn(rt),
              Dt = In / Hn[2];
            rt = new Jt(Dt, gn[0] - Hn[0] * Dt, gn[1] - Hn[1] * Dt);
          }
          nn.zoom(null, rt);
        };
      });
  }
  function X(A, R, I) {
    return (!I && A.__zooming) || new V(A, R);
  }
  function V(A, R) {
    (this.that = A),
      (this.args = R),
      (this.active = 0),
      (this.sourceEvent = null),
      (this.extent = r.apply(A, R)),
      (this.taps = 0);
  }
  V.prototype = {
    event: function (A) {
      return A && (this.sourceEvent = A), this;
    },
    start: function () {
      return (
        ++this.active === 1 &&
          ((this.that.__zooming = this), this.emit('start')),
        this
      );
    },
    zoom: function (A, R) {
      return (
        this.mouse &&
          A !== 'mouse' &&
          (this.mouse[1] = R.invert(this.mouse[0])),
        this.touch0 &&
          A !== 'touch' &&
          (this.touch0[1] = R.invert(this.touch0[0])),
        this.touch1 &&
          A !== 'touch' &&
          (this.touch1[1] = R.invert(this.touch1[0])),
        (this.that.__zoom = R),
        this.emit('zoom'),
        this
      );
    },
    end: function () {
      return (
        --this.active === 0 && (delete this.that.__zooming, this.emit('end')),
        this
      );
    },
    emit: function (A) {
      var R = Un(this.that).datum();
      w.call(
        A,
        this.that,
        new Sx(A, {
          sourceEvent: this.sourceEvent,
          target: O,
          type: A,
          transform: this.that.__zoom,
          dispatch: w,
        }),
        R
      );
    },
  };
  function rn(A, ...R) {
    if (!e.apply(this, arguments)) return;
    var I = X(this, R).event(A),
      F = this.__zoom,
      G = Math.max(
        h[0],
        Math.min(h[1], F.k * Math.pow(2, f.apply(this, arguments)))
      ),
      Y = ve(A);
    if (I.wheel)
      (I.mouse[0][0] !== Y[0] || I.mouse[0][1] !== Y[1]) &&
        (I.mouse[1] = F.invert((I.mouse[0] = Y))),
        clearTimeout(I.wheel);
    else {
      if (F.k === G) return;
      (I.mouse = [Y, F.invert(Y)]), Bi(this), I.start();
    }
    vr(A),
      (I.wheel = setTimeout(nn, P)),
      I.zoom('mouse', u(k(U(F, G), I.mouse[0], I.mouse[1]), I.extent, c));
    function nn() {
      (I.wheel = null), I.end();
    }
  }
  function on(A, ...R) {
    if (x || !e.apply(this, arguments)) return;
    var I = A.currentTarget,
      F = X(this, R, !0).event(A),
      G = Un(A.view).on('mousemove.zoom', gn, !0).on('mouseup.zoom', In, !0),
      Y = ve(A, I),
      nn = A.clientX,
      Q = A.clientY;
    yx(A.view),
      $o(A),
      (F.mouse = [Y, this.__zoom.invert(Y)]),
      Bi(this),
      F.start();
    function gn(An) {
      if ((vr(An), !F.moved)) {
        var Sn = An.clientX - nn,
          Jn = An.clientY - Q;
        F.moved = Sn * Sn + Jn * Jn > z;
      }
      F.event(An).zoom(
        'mouse',
        u(k(F.that.__zoom, (F.mouse[0] = ve(An, I)), F.mouse[1]), F.extent, c)
      );
    }
    function In(An) {
      G.on('mousemove.zoom mouseup.zoom', null),
        xx(An.view, F.moved),
        vr(An),
        F.event(An).end();
    }
  }
  function pn(A, ...R) {
    if (e.apply(this, arguments)) {
      var I = this.__zoom,
        F = ve(A.changedTouches ? A.changedTouches[0] : A, this),
        G = I.invert(F),
        Y = I.k * (A.shiftKey ? 0.5 : 2),
        nn = u(k(U(I, Y), F, G), r.apply(this, R), c);
      vr(A),
        g > 0
          ? Un(this).transition().duration(g).call(q, nn, F, A)
          : Un(this).call(O.transform, nn, F, A);
    }
  }
  function j(A, ...R) {
    if (e.apply(this, arguments)) {
      var I = A.touches,
        F = I.length,
        G = X(this, R, A.changedTouches.length === F).event(A),
        Y,
        nn,
        Q,
        gn;
      for ($o(A), nn = 0; nn < F; ++nn)
        (Q = I[nn]),
          (gn = ve(Q, this)),
          (gn = [gn, this.__zoom.invert(gn), Q.identifier]),
          G.touch0
            ? !G.touch1 &&
              G.touch0[2] !== gn[2] &&
              ((G.touch1 = gn), (G.taps = 0))
            : ((G.touch0 = gn), (Y = !0), (G.taps = 1 + !!d));
      d && (d = clearTimeout(d)),
        Y &&
          (G.taps < 2 &&
            ((y = gn[0]),
            (d = setTimeout(function () {
              d = null;
            }, C))),
          Bi(this),
          G.start());
    }
  }
  function zn(A, ...R) {
    if (this.__zooming) {
      var I = X(this, R).event(A),
        F = A.changedTouches,
        G = F.length,
        Y,
        nn,
        Q,
        gn;
      for (vr(A), Y = 0; Y < G; ++Y)
        (nn = F[Y]),
          (Q = ve(nn, this)),
          I.touch0 && I.touch0[2] === nn.identifier
            ? (I.touch0[0] = Q)
            : I.touch1 && I.touch1[2] === nn.identifier && (I.touch1[0] = Q);
      if (((nn = I.that.__zoom), I.touch1)) {
        var In = I.touch0[0],
          An = I.touch0[1],
          Sn = I.touch1[0],
          Jn = I.touch1[1],
          rt = (rt = Sn[0] - In[0]) * rt + (rt = Sn[1] - In[1]) * rt,
          Hn = (Hn = Jn[0] - An[0]) * Hn + (Hn = Jn[1] - An[1]) * Hn;
        (nn = U(nn, Math.sqrt(rt / Hn))),
          (Q = [(In[0] + Sn[0]) / 2, (In[1] + Sn[1]) / 2]),
          (gn = [(An[0] + Jn[0]) / 2, (An[1] + Jn[1]) / 2]);
      } else if (I.touch0) (Q = I.touch0[0]), (gn = I.touch0[1]);
      else return;
      I.zoom('touch', u(k(nn, Q, gn), I.extent, c));
    }
  }
  function xn(A, ...R) {
    if (this.__zooming) {
      var I = X(this, R).event(A),
        F = A.changedTouches,
        G = F.length,
        Y,
        nn;
      for (
        $o(A),
          x && clearTimeout(x),
          x = setTimeout(function () {
            x = null;
          }, C),
          Y = 0;
        Y < G;
        ++Y
      )
        (nn = F[Y]),
          I.touch0 && I.touch0[2] === nn.identifier
            ? delete I.touch0
            : I.touch1 && I.touch1[2] === nn.identifier && delete I.touch1;
      if (
        (I.touch1 && !I.touch0 && ((I.touch0 = I.touch1), delete I.touch1),
        I.touch0)
      )
        I.touch0[1] = this.__zoom.invert(I.touch0[0]);
      else if (
        (I.end(),
        I.taps === 2 &&
          ((nn = ve(nn, this)), Math.hypot(y[0] - nn[0], y[1] - nn[1]) < $))
      ) {
        var Q = Un(this).on('dblclick.zoom');
        Q && Q.apply(this, arguments);
      }
    }
  }
  return (
    (O.wheelDelta = function (A) {
      return arguments.length
        ? ((f = typeof A == 'function' ? A : Oi(+A)), O)
        : f;
    }),
    (O.filter = function (A) {
      return arguments.length
        ? ((e = typeof A == 'function' ? A : Oi(!!A)), O)
        : e;
    }),
    (O.touchable = function (A) {
      return arguments.length
        ? ((s = typeof A == 'function' ? A : Oi(!!A)), O)
        : s;
    }),
    (O.extent = function (A) {
      return arguments.length
        ? ((r =
            typeof A == 'function'
              ? A
              : Oi([
                  [+A[0][0], +A[0][1]],
                  [+A[1][0], +A[1][1]],
                ])),
          O)
        : r;
    }),
    (O.scaleExtent = function (A) {
      return arguments.length
        ? ((h[0] = +A[0]), (h[1] = +A[1]), O)
        : [h[0], h[1]];
    }),
    (O.translateExtent = function (A) {
      return arguments.length
        ? ((c[0][0] = +A[0][0]),
          (c[1][0] = +A[1][0]),
          (c[0][1] = +A[0][1]),
          (c[1][1] = +A[1][1]),
          O)
        : [
            [c[0][0], c[0][1]],
            [c[1][0], c[1][1]],
          ];
    }),
    (O.constrain = function (A) {
      return arguments.length ? ((u = A), O) : u;
    }),
    (O.duration = function (A) {
      return arguments.length ? ((g = +A), O) : g;
    }),
    (O.interpolate = function (A) {
      return arguments.length ? ((v = A), O) : v;
    }),
    (O.on = function () {
      var A = w.on.apply(w, arguments);
      return A === w ? O : A;
    }),
    (O.clickDistance = function (A) {
      return arguments.length ? ((z = (A = +A) * A), O) : Math.sqrt(z);
    }),
    (O.tapDistance = function (A) {
      return arguments.length ? (($ = +A), O) : $;
    }),
    O
  );
}
function Mx(e) {
  if (!e.ok) throw new Error(e.status + ' ' + e.statusText);
  if (!(e.status === 204 || e.status === 205)) return e.json();
}
function Lx(e, r) {
  return fetch(e, r).then(Mx);
}
const bx = {
    loadingStart: () => {},
    loaded: () => {},
    countryClick: () => {},
    countryMouseEnter: () => {},
    countryMouseLeave: () => {},
    markerClick: () => {},
    markerMouseEnter: () => {},
    markerMouseLeave: () => {},
    zoom: () => {},
  },
  Px = {
    type: 'pin',
    color: 'blue',
    width: 20,
    height: 20,
    radius: 2,
    strokeWidth: 0,
    strokeColor: 'transparent',
    shadow: null,
  },
  Nx = {
    mapPath: './public/map.geo.json',
    selectedCountries: [],
    countryGroups: [],
    selectedGroup: null,
    isZoomable: !1,
    zoomedCountries: [],
    maxZoom: 20,
    zoomDefault: null,
    translateDefault: null,
    markers: [],
    markerStyle: Px,
    countryStrokeWidth: 0.25,
    accentFillColor: 'red',
    accentStrokeColor: '#ffffff',
    countryFillColor: '#cccccc',
    countryStrokeColor: '#ffffff',
    groupFillColor: 'green',
    width: 900,
    height: 600,
    pattern: null,
    patternGradient: null,
    on: bx,
  };
Un.prototype.transition = wf;
we.prototype.transition = wf;
var tu, Sc, eu, Ec, ru, Ac;
class $x {
  constructor(r, u) {
    Ci(this, tu);
    Ci(this, eu);
    Ci(this, ru);
    Ln(this, 'selector');
    Ln(this, 'config');
    Ln(this, 'isLoading');
    Ln(this, 'zoomedCountries');
    Ln(this, 'selectedCountries');
    Ln(this, 'selectedGroup');
    Ln(this, 'countryGroups');
    Ln(this, 'markers');
    Ln(this, 'mapInstancePromise');
    Ln(this, 'svg');
    Ln(this, 'scale');
    Ln(this, 'translate');
    Ln(this, 'projection');
    Ln(this, 'g');
    Ln(this, 'path');
    Ln(this, 'zoom');
    Ln(this, 'defs');
    Ln(this, 'pattern');
    Ln(this, 'patternGradient');
    Ln(this, 'patternFilter');
    Ln(this, 'markerShadow');
    var s, h, c, g;
    (this.selector = r),
      (this.config = hv.merge(Nx, u)),
      (this.isLoading = !0),
      this.config.on.loadingStart(),
      (this.mapInstancePromise = Lx(this.config.mapPath)),
      (this.zoomedCountries = this.config.zoomedCountries),
      (this.selectedCountries = this.config.selectedCountries),
      (this.selectedGroup = this.config.selectedGroup),
      (this.countryGroups = this.config.countryGroups
        ? new Map(this.config.countryGroups.map((v) => [v.id, v.countryList]))
        : null),
      (this.markers = this.config.markers),
      (this.svg = Un(this.selector)
        .append('svg')
        .attr('width', '100%')
        .attr('height', '100%')
        .attr('preserveAspectRatio', 'xMinYMin meet')
        .attr('viewBox', `0 0 ${this.config.width} ${this.config.height}`)
        .style('fill', this.config.countryFillColor)
        .style('stroke', this.config.countryStrokeColor)
        .style('stroke-width', `${this.config.countryStrokeWidth}px`)),
      (this.scale = this.config.width / (Math.PI * 2)),
      (this.translate = [this.config.width / 2, this.config.height / 1.4]),
      (this.projection = Pm()
        .fitSize([500, 500], {})
        .scale(this.scale)
        .translate(this.translate)),
      (this.path = ym(this.projection)),
      (this.g = this.svg.append('g')),
      (this.zoom = Ix()
        .scaleExtent([1, this.config.maxZoom])
        .translateExtent([
          [0, 0],
          [this.config.width, this.config.height],
        ])
        .on('zoom', (v, w) => {
          f(v, this),
            this.config.on.zoom({ target: v.target, data: w, metaMap: this });
        }));
    function f(v, w) {
      w.g.attr('transform', v.transform);
    }
    if (
      (this.config.isZoomable && this.svg.call(this.zoom),
      this.config.zoomDefault &&
        this.svg.call(this.zoom.scaleBy, this.config.zoomDefault),
      this.config.translateDefault)
    ) {
      const v = this.projection(this.config.translateDefault);
      v && this.svg.call(this.zoom.translateTo, v[0], v[1]);
    }
    if (
      ((this.defs = this.svg.append('defs')),
      (this.patternGradient =
        ((h = (s = this.config).patternGradient) == null
          ? void 0
          : h.call(s, this.defs)) ?? null),
      (this.patternFilter = null),
      (this.pattern =
        ((g = (c = this.config).pattern) == null
          ? void 0
          : g.call(c, this.defs)) ?? null),
      this.pattern &&
        (this.g.style('fill', 'url(#pattern)'),
        this.g.style('stroke', 'url(#pattern)')),
      (this.markerShadow = null),
      this.config.markerStyle.shadow)
    ) {
      if (!this.config.markerStyle.shadow.color)
        throw new Error('Shadow color is require!');
      if (!this.config.markerStyle.shadow.blur)
        throw new Error('Shadow blur is require!');
      if (!this.config.markerStyle.shadow.radius)
        throw new Error('Shadow radius is require!');
      (this.markerShadow = this.defs
        .append('filter')
        .attr('id', 'markerShadow')
        .attr('x', '-100%')
        .attr('y', '-100%')
        .attr('width', '300%')
        .attr('height', '300%')
        .attr('filterUnits', 'userSpaceOnUse')
        .attr('color-interpolation-filters', 'sRGB')),
        this.markerShadow
          .append('feFlood')
          .attr('flood-color', this.config.markerStyle.shadow.color)
          .attr('result', 'flood')
          .attr('in', 'SourceAlpha'),
        this.markerShadow
          .append('feComposite')
          .attr('in2', 'SourceAlpha')
          .attr('in', 'flood')
          .attr('operator', 'atop')
          .attr('result', 'color'),
        this.markerShadow
          .append('feMorphology')
          .attr('operator', 'dilate')
          .attr('radius', this.config.markerStyle.shadow.radius)
          .attr('result', 'spread')
          .attr('in', 'color'),
        this.markerShadow
          .append('feGaussianBlur')
          .attr('in', 'spread')
          .attr('stdDeviation', this.config.markerStyle.shadow.blur)
          .attr('result', 'shadow'),
        this.markerShadow
          .append('feOffset')
          .attr('dx', 0)
          .attr('dy', 0)
          .attr('in', 'shadow')
          .attr('result', 'offset');
      const v = this.markerShadow.append('feMerge').attr('result', 'merge');
      v.append('feMergeNode').attr('in', 'offset'),
        v.append('feMergeNode').attr('in', 'SourceGraphic');
    }
    this.mapInstancePromise.then((v) => {
      var w;
      v &&
        this.g
          .selectAll('path')
          .data(v.features)
          .enter()
          .append('path')
          .attr('class', 'country')
          .attr('id', (d) => d.properties.id)
          .attr('d', this.path),
        this.patternGradient &&
          (this.patternFilter = this.g
            .append('rect')
            .attr('id', 'patternFilter')
            .attr('x', 0)
            .attr('y', 0)
            .attr('width', '100%')
            .attr('height', '100%')
            .style('fill', 'url(#patternGradient)')
            .style('mix-blend-mode', 'color')
            .style('pointer-events', 'none')),
        ((w = this.g.node()) == null ? void 0 : w.childNodes[0]) ===
          this.g.select('.markers').node() &&
          this.g.append('use').attr('xlink:href', '#markers'),
        (this.isLoading = !1),
        this.config.on.loaded();
    }),
      this.mapInstancePromise.then(() => {
        var v;
        (v = this.countryGroups) == null ||
          v.forEach((w, d) => {
            const y = w.map((x) => `#${x}`).join(',');
            we(y)
              .attr('class', () => `country ${d}`)
              .transition()
              .style('fill', this.config.groupFillColor)
              .style('stroke', this.config.countryStrokeColor);
          });
      }),
      this.selectCountryList(this.selectedCountries),
      this.zoomCountries(this.zoomedCountries),
      Ri(this, eu, Ec).call(this),
      setTimeout(() => {
        Ri(this, tu, Sc).call(this), Ri(this, ru, Ac).call(this);
      });
  }
  /**
   * @description Select country by id
   * @param {string} id - country id
   */
  selectCountry(r) {
    if (!r) throw new Error('id is required!');
    (this.selectedCountries = [...this.selectedCountries, r]),
      this.mapInstancePromise.then(() => {
        Un(`#${r}`)
          .transition()
          .style('fill', this.config.accentFillColor)
          .style('stroke', this.config.accentStrokeColor);
      });
  }
  /**
   * @description Select countries by id.
   * @param {string[]} idList - List of country ids.
   */
  selectCountryList(r) {
    if (!r) throw new Error('idList is required!');
    this.mapInstancePromise.then(() => {
      r.forEach((u) => {
        this.selectCountry(u);
      });
    });
  }
  /**
   * @description Unselect country by id.
   * @param {string} id - List of country ids.
   */
  unselectCountry(r) {
    if (!r) throw new Error('id is required!');
    Un(`#${r}`)
      .transition()
      .style('fill', this.config.countryFillColor)
      .style('stroke', this.config.countryStrokeColor);
  }
  /**
   * @description Unselect all countries.
   */
  unselectAllCountries() {
    const r = this.selectedCountries.map((u) => `#${u}`).join(',');
    this.mapInstancePromise.then(() => {
      we(r)
        .transition()
        .style('fill', this.config.countryFillColor)
        .style('stroke', this.config.countryStrokeColor);
    });
  }
  /**
   * @description Select country group by  group id
   * @param {string} groupId - group id
   */
  selectGroup(r) {
    var f, s;
    if (!r) throw new Error('groupId is required!');
    this.selectedGroup = r;
    const u =
      (s = (f = this.countryGroups) == null ? void 0 : f.get(r)) == null
        ? void 0
        : s.map((h) => `#${h}`).join(',');
    u &&
      this.mapInstancePromise.then(() => {
        we(u)
          .transition()
          .style('fill', this.config.accentFillColor)
          .style('stroke', this.config.accentStrokeColor);
      });
  }
  /**
   * @description Select country group by  group id
   * @param {string} groupId - group id
   */
  unselectAllGroups() {
    var u, f;
    const r = this.selectedGroup
      ? (f =
          (u = this.countryGroups) == null
            ? void 0
            : u.get(this.selectedGroup)) == null
        ? void 0
        : f.map((s) => `#${s}`).join(',')
      : null;
    r &&
      this.mapInstancePromise.then(() => {
        we(r)
          .transition()
          .style('fill', this.config.groupFillColor)
          .style('stroke', this.config.countryStrokeColor);
      }),
      (this.selectedGroup = null);
  }
  moveToCountry(r, u = this) {
    if (!r) throw new Error('id is required!');
    this.mapInstancePromise.then(() => {
      const [f] = Un(`#${r}`).data(),
        s = u.path.bounds(f),
        h = s[1][0] - s[0][0],
        c = s[1][1] - s[0][1],
        g = (s[0][0] + s[1][0]) / 2,
        v = (s[0][1] + s[1][1]) / 2,
        w = Math.max(
          1,
          Math.min(
            this.config.maxZoom,
            0.9 / Math.max(h / u.config.width, c / u.config.height)
          )
        ),
        d = [u.config.width / 2 - w * g, u.config.height / 2 - w * v];
      u.svg
        .transition()
        .duration(750)
        .call(u.zoom.transform, Ue.translate(d[0], d[1]).scale(w));
    });
  }
  moveToCountries(r, u = this) {
    if (!r || !Array.isArray(r))
      throw new Error(
        'idList is required and must be an array of country ids!'
      );
    this.mapInstancePromise.then(() => {
      const [f] = Un(`#${r[0]}`).data(),
        s = u.path.bounds(f);
      r.forEach((y) => {
        const [x] = Un(`#${y}`).data(),
          C = u.path.bounds(x);
        s[0][0] > C[0][0] && (s[0][0] = C[0][0]),
          s[0][1] > C[0][1] && (s[0][1] = C[0][1]),
          s[1][0] < C[1][0] && (s[1][0] = C[1][0]),
          s[1][1] < C[1][1] && (s[1][1] = C[1][1]);
      });
      const h = s[1][0] - s[0][0],
        c = s[1][1] - s[0][1],
        g = (s[0][0] + s[1][0]) / 2,
        v = (s[0][1] + s[1][1]) / 2,
        w = Math.max(
          1,
          Math.min(
            this.config.maxZoom,
            0.9 / Math.max(h / u.config.width, c / u.config.height)
          )
        ),
        d = [u.config.width / 2 - w * g, u.config.height / 2 - w * v];
      u.svg
        .transition()
        .duration(750)
        .call(u.zoom.transform, Ue.translate(d[0], d[1]).scale(w));
    });
  }
  zoomCountries(r) {
    if (!r)
      throw new Error('id "string" or idList "array of strings" is required!');
    this.mapInstancePromise.then(() => {
      if (typeof r == 'string') {
        const [u] = Un(`#${r}`).data(),
          f = this.path.bounds(u),
          s = f[1][0] - f[0][0],
          h = f[1][1] - f[0][1],
          c = (f[0][0] + f[1][0]) / 2,
          g = (f[0][1] + f[1][1]) / 2,
          v = Math.max(
            1,
            Math.min(
              this.config.maxZoom,
              0.9 / Math.max(s / this.config.width, h / this.config.height)
            )
          ),
          w = [this.config.width / 2 - v * c, this.config.height / 2 - v * g];
        this.svg
          .transition()
          .call(this.zoom.transform, Ue.translate(w[0], w[1]).scale(v));
      }
      if (Array.isArray(r) && r.length > 0) {
        const [u] = Un(`#${r[0]}`).data(),
          f = this.path.bounds(u);
        r.forEach((d) => {
          const [y] = Un(`#${d}`).data(),
            x = this.path.bounds(y);
          f[0][0] > x[0][0] && (f[0][0] = x[0][0]),
            f[0][1] > x[0][1] && (f[0][1] = x[0][1]),
            f[1][0] < x[1][0] && (f[1][0] = x[1][0]),
            f[1][1] < x[1][1] && (f[1][1] = x[1][1]);
        });
        const s = f[1][0] - f[0][0],
          h = f[1][1] - f[0][1],
          c = (f[0][0] + f[1][0]) / 2,
          g = (f[0][1] + f[1][1]) / 2,
          v = Math.max(
            1,
            Math.min(
              this.config.maxZoom,
              0.9 / Math.max(s / this.config.width, h / this.config.height)
            )
          ),
          w = [this.config.width / 2 - v * c, this.config.height / 2 - v * g];
        this.svg
          .transition()
          .call(this.zoom.transform, Ue.translate(w[0], w[1]).scale(v));
      }
    });
  }
}
(tu = new WeakSet()),
  (Sc = function () {
    this.mapInstancePromise.then(() => {
      const u = this.g
        .append('g')
        .attr('class', 'markers')
        .attr('id', 'markers')
        .selectAll('.marker')
        .data(this.markers)
        .enter();
      this.config.markerStyle.type === 'image'
        ? u
            .append('svg:image')
            .attr('x', (f) => {
              var h;
              return (
                ((h = this.projection([f.long, f.lat])) == null
                  ? void 0
                  : h[0]) ?? null
              );
            })
            .attr('class', 'marker')
            .attr('y', (f) => {
              var h;
              const s =
                (h = this.projection([f.long, f.lat])) == null ? void 0 : h[1];
              return s ? s - this.config.markerStyle.height : null;
            })
            .attr('width', this.config.markerStyle.width)
            .attr('height', this.config.markerStyle.height)
            .attr('xlink:href', this.config.markerStyle.img)
            .attr('filter', 'url(#markerShadow)')
        : u
            .append('circle')
            .attr('class', 'marker')
            .attr('r', this.config.markerStyle.radius)
            .attr('cx', (f) => {
              var s;
              return (
                ((s = this.projection([f.long, f.lat])) == null
                  ? void 0
                  : s[0]) ?? null
              );
            })
            .attr('cy', (f) => {
              var s;
              return (
                ((s = this.projection([f.long, f.lat])) == null
                  ? void 0
                  : s[1]) ?? null
              );
            })
            .style('fill', this.config.markerStyle.color)
            .style('stroke-width', this.config.markerStyle.strokeWidth + 'px')
            .style('stroke', this.config.markerStyle.strokeColor)
            .attr('filter', 'url(#markerShadow)');
    });
  }),
  (eu = new WeakSet()),
  (Ec = function () {
    this.mapInstancePromise.then(() => {
      we('.country')
        .on('click', ({ target: r }, u) =>
          this.config.on.countryClick({
            target: r,
            data: u,
            metaMap: this,
          })
        )
        .on('mouseenter', ({ target: r }, u) =>
          this.config.on.countryMouseEnter({
            target: r,
            data: u,
            metaMap: this,
          })
        )
        .on('mouseleave', ({ target: r }, u) =>
          this.config.on.countryMouseLeave({
            target: r,
            data: u,
            metaMap: this,
          })
        );
    });
  }),
  (ru = new WeakSet()),
  (Ac = function () {
    this.mapInstancePromise.then(() => {
      we('.marker')
        .on('click', ({ target: r }, u) =>
          this.config.on.markerClick({ target: r, data: u, metaMap: this })
        )
        .on('mouseenter', ({ target: r }, u) =>
          this.config.on.markerMouseEnter({ target: r, data: u, metaMap: this })
        )
        .on('mouseleave', ({ target: r }, u) =>
          this.config.on.markerMouseLeave({ target: r, data: u, metaMap: this })
        );
    });
  });
export { $x as default };
//# sourceMappingURL=meta-map.js.map
